(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<span class=\"h1 h-title\">Подбор документов</span>\r\n\r\n<div class=\"hint\">\r\n   <span class=\"hint__icon\"></span>\r\n   <div class=\"hint__right\">\r\n       <span class=\"hint__text\">Для перехода к следующему шагу необходимо выбрать соответсвующий пункт в текущей вкладке</span>\r\n       <span class=\"hint__text\">Для возврата назад нажмите на предыдущую вкладку</span>\r\n   </div>\r\n</div>\r\n\r\n<ul class=\"steps\">\r\n   <li *ngFor=\"let lvl of lvlNames; let index = index\" class=\"steps__item\"\r\n    [ngClass]=\"[index + 1 <= lvlCurrent ? activeLvlClass : empty,\r\n                lvlCurrent == lvl.id ? currentStepClass : empty]\"\r\n    (click)=\"onClinkLvl(index + 1)\"> <span>{{lvl.title}}</span></li>\r\n</ul>\r\n\r\n<div class=\"step-info clearfix step-info--{{lvlCurrent}}\">\r\n   <div class=\"row row-eq-height\">\r\n       <div class=\"step-info__list col-xs-12\">\r\n           <span class=\"step-info__list-title\">{{getTextOfLvl()}}:</span>\r\n           <ul class=\"step-info__item selector_list\">\r\n               <li class=\"selector_item\" *ngFor=\"let doc of docsVisible\">\r\n                   <a *ngIf=\"lvlCurrent != 5\" (click)=\"onClinkDoc(doc.id)\">{{ doc.name }}</a>\r\n                   <p *ngIf=\"lvlCurrent == 5\">{{ doc.name }}</p>\r\n                   <button (click)=\"openModal($event, doc.name)\" type=\"button\" *ngIf=\"lvlCurrent == 5\" class=\"btn btn_submit\" data-target=\"#selector\">\r\n                       Заказать\r\n                    </button>\r\n               </li>\r\n           </ul>\r\n       </div>\r\n   </div>\r\n</div>");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _document__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./document */ "./src/app/document.ts");




let AppComponent = class AppComponent {
    constructor(http) {
        this.http = http;
        this.docs = [];
        this.arrayUserDocs = [];
        this.lvlNames = [
            {
                id: 1,
                title: 'Выберите раздел',
                nominative: 'раздел',
                genitive: 'раздела'
            },
            {
                id: 2,
                title: 'Выберите отрасль',
                nominative: 'отрасль',
                genitive: 'отрасли'
            },
            {
                id: 3,
                title: 'Ваш товар',
                nominative: 'товар',
                genitive: 'товара'
            },
            {
                id: 4,
                title: 'Документы для',
                nominative: 'документ',
                genitive: 'документа'
            },
            {
                id: 5,
                title: 'Документы для оформления',
                nominative: 'документ для оформления',
                genitive: 'документов для оформления'
            },
        ];
        this.lvlCurrent = 1;
        this.lvlFinish = 5;
        this.activeLvlClass = 'active-step';
        this.empty = '';
        this.currentStepClass = 'current-step';
        this.classNameLvl = 'steps';
    }
    ngOnInit() {
        this.docs = _document__WEBPACK_IMPORTED_MODULE_3__["documents"];
        this.docsVisible = this.getDocs(1, 0);
    }
    /**
     *   Get docs by lvl and parent id
     */
    getDocs(lvl, patent) {
        const response = [];
        this.docs.forEach((value) => {
            if (typeof patent === 'object' && typeof value.parent === 'object') {
                if (value.lvl === lvl && JSON.stringify(patent) === JSON.stringify(value.parent)) {
                    response.push(value);
                }
            }
            else if (typeof value.parent === 'object') {
                if (value.lvl === lvl && value.parent.includes(patent)) {
                    response.push(value);
                }
            }
            else if (typeof value.parent === 'number') {
                if (value.lvl === lvl && value.parent === patent) {
                    response.push(value);
                }
            }
        });
        return response;
    }
    /**
     *  Action click doc. If current lvl = lvl finish - return
     *  Set new info in arrayUserDocs, currentLvl
     */
    onClinkDoc(id) {
        const elemToScroll = document.getElementsByClassName(this.classNameLvl);
        if (elemToScroll[0]) {
            elemToScroll[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
        const currentDoc = this.getDocById(id);
        if (currentDoc.lvl === this.lvlFinish) {
            return;
        }
        this.arrayUserDocs[currentDoc.lvl - 1] = {
            name: currentDoc.name,
            id: currentDoc.id
        };
        this.deleteUserDocs(currentDoc.lvl);
        this.setCurrentLvl(currentDoc.lvl + 1);
        this.docsVisible = this.getDocs(currentDoc.lvl + 1, currentDoc.id);
    }
    getDocById(id) {
        const docFilter = this.docs.filter(x => x.id === id);
        if (!docFilter[0]) {
            return;
        }
        return docFilter[0];
    }
    deleteUserDocs(from) {
        this.arrayUserDocs.splice(from, this.arrayUserDocs.length - from);
    }
    /**
     *  Action click lvl. If user go to next lvl without choice past - return
     */
    onClinkLvl(lvl) {
        if (!this.arrayUserDocs[lvl - 1]) {
            return;
        }
        this.setCurrentLvl(lvl);
        const lastSelectedDoc = this.getDocById(this.arrayUserDocs[lvl - 1].id);
        this.deleteUserDocs(lvl - 1);
        this.docsVisible = this.getDocs(lastSelectedDoc.lvl, lastSelectedDoc.parent);
    }
    setCurrentLvl(lvl) {
        this.lvlCurrent = lvl;
    }
    /**
     *  Action get text of lvl for Tile and ul
     */
    getTextOfLvl(isNameTile) {
        const text = {
            nameUl: '',
            nameTile: '',
        };
        const obLvl = this.lvlNames.filter(value => value.id === this.lvlCurrent);
        const obLvlNext = this.lvlNames.filter(value => value.id === this.lvlCurrent + 1);
        if (!obLvl[0]) {
            return;
        }
        text.nameTile = `Выберите ${obLvl[0].nominative}`;
        text.nameUl = this.lvlCurrent === this.lvlFinish ?
            'Перечень документов для оформления' :
            `Выберите ${obLvl[0].nominative}`;
        if (obLvlNext[0]) {
            text.nameTile += `, чтобы перейти к Выбору ${obLvlNext[0].genitive}`;
        }
        if (isNameTile) {
            return text.nameTile;
        }
        return text.nameUl;
    }
    isBtnShow() {
        return this.lvlCurrent === this.lvlFinish;
    }
    /**
     *  Action parse user choice docs to string.
     *  Parse array user docs and array docs, that visible on last lvl
     */
    arrayUserDocsToString() {
        const responce = [];
        const lastUserDoc = this.arrayUserDocs[this.arrayUserDocs.length - 1];
        const lastChoice = this.getDocById(lastUserDoc.id);
        const userDocs = this.getDocs(lastChoice.lvl + 1, lastChoice.id);
        responce.push('<br><ul class="array-user-docs"><li><b>Пользователь выбрал:</b></li>');
        this.arrayUserDocs.forEach((value) => {
            responce.push('<li>' + value.name + '</li>');
        });
        responce.push('</ul>');
        responce.push('|<br><ul class="user-docs"><li><b>' + this.getTextOfLvl(false) + '</b>:</li>');
        userDocs.forEach((value) => {
            responce.push('<li>' + value.name + '</li>');
        });
        responce.push('</ul><br>|');
        return responce;
    }
    openModal(event, doc) {
        jQuery('#selector').slideDown();
        jQuery('#selector .document_name').text(doc);
        jQuery('#selector input[name=document]').val(doc);
    }
};
AppComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");





let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"]
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClientModule"]
        ],
        providers: [],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/document.ts":
/*!*****************************!*\
  !*** ./src/app/document.ts ***!
  \*****************************/
/*! exports provided: documents */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "documents", function() { return documents; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const documents = [{
        "id": 1,
        "parent": 0,
        "lvl": 1,
        "name": "Изделия хозяйствено-бытового назначения, одежда, продукция для детей, игрушки"
    }, { "id": 2, "parent": 1, "lvl": 2, "name": "Продукция легкой промышленности" }, {
        "id": 3,
        "parent": 2,
        "lvl": 3,
        "name": "Ткани"
    }, { "id": 4, "parent": 2, "lvl": 3, "name": "Одежда" }, {
        "id": 5,
        "parent": 2,
        "lvl": 3,
        "name": "Обувь"
    }, {
        "id": 6,
        "parent": 2,
        "lvl": 3,
        "name": "Постельное белье"
    }, { "id": 7, "parent": 2, "lvl": 3, "name": "Сумки" }, {
        "id": 8,
        "parent": 2,
        "lvl": 3,
        "name": "Ковры"
    }, {
        "id": 9,
        "parent": 2,
        "lvl": 3,
        "name": "Шторы"
    }, { "id": 10, "parent": 2, "lvl": 3, "name": "Спальные мешки" }, {
        "id": 11,
        "parent": 2,
        "lvl": 3,
        "name": "Изделия кожгалантерейные"
    }, { "id": 12, "parent": 2, "lvl": 3, "name": "Другие изделия" }, {
        "id": 13,
        "parent": [3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 14, "parent": 13, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 15,
        "parent": 13,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия ТР ТС 017 о безопасности продукции легкой промышленности"
    }, {
        "id": 16,
        "parent": 13,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 017 о безопасности продукции легкой промышленности"
    }, { "id": 17, "parent": 13, "lvl": 5, "name": "Сертификат(-ы) соответствия продукции (добровольные)" }, {
        "id": 18,
        "parent": 13,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 19,
        "parent": 13,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 20, "parent": [3, 4, 5, 6, 7, 8, 9, 10, 11, 12], "lvl": 4, "name": "Я - импортер" }, {
        "id": 21,
        "parent": 20,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия ТР ТС 017 о безопасности продукции легкой промышленности"
    }, {
        "id": 22,
        "parent": 20,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 017 о безопасности продукции легкой промышленности"
    }, { "id": 23, "parent": 20, "lvl": 5, "name": "Сертификат(-ы) соответствия продукции (добровольные)" }, {
        "id": 24,
        "parent": 20,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 25, "parent": [3, 4, 5, 6, 7, 8, 9, 10, 11, 12], "lvl": 4, "name": "Я - экспортер" }, {
        "id": 26,
        "parent": 25,
        "lvl": 5,
        "name": "Сертификат(-ы) происхождения продукции"
    }, {
        "id": 27,
        "parent": 25,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, { "id": 28, "parent": [3, 4, 5, 6, 7, 8, 9, 10, 11, 12], "lvl": 4, "name": "Я - продавец" }, {
        "id": 29,
        "parent": 28,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 017 о безопасности продукции легкой промышленности"
    }, {
        "id": 30,
        "parent": 28,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 017 о безопасности продукции легкой промышленности"
    }, {
        "id": 31,
        "parent": 28,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 32,
        "parent": 28,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 33, "parent": 0, "lvl": 1, "name": "Пищевая промышленность" }, {
        "id": 34,
        "parent": 33,
        "lvl": 2,
        "name": "Продукция рыбной промышленности"
    }, { "id": 35, "parent": 34, "lvl": 3, "name": "Рыба свежемороженая" }, {
        "id": 36,
        "parent": 34,
        "lvl": 3,
        "name": "Рыба соленая"
    }, { "id": 37, "parent": 34, "lvl": 3, "name": "Рыба маринованная" }, {
        "id": 38,
        "parent": 34,
        "lvl": 3,
        "name": "Рыба копченая"
    }, { "id": 39, "parent": 34, "lvl": 3, "name": "Рыба сушено-вяленая" }, {
        "id": 40,
        "parent": 34,
        "lvl": 3,
        "name": "Икра"
    }, { "id": 41, "parent": 34, "lvl": 3, "name": "Морепродукты" }, {
        "id": 42,
        "parent": 34,
        "lvl": 3,
        "name": "Супы сухие с рыбой"
    }, { "id": 43, "parent": 34, "lvl": 3, "name": "Консервы с рыбой" }, {
        "id": 44,
        "parent": 34,
        "lvl": 3,
        "name": "Пресервы с рыбой"
    }, { "id": 45, "parent": 34, "lvl": 3, "name": "Рыбий жир" }, {
        "id": 46,
        "parent": 34,
        "lvl": 3,
        "name": "Выпечка с рыбой"
    }, { "id": 47, "parent": 34, "lvl": 3, "name": "Салаты с рыбой" }, {
        "id": 48,
        "parent": 34,
        "lvl": 3,
        "name": "Супы с рыбой"
    }, { "id": 49, "parent": 34, "lvl": 3, "name": "Рыбные продукты для детей" }, {
        "id": 50,
        "parent": 34,
        "lvl": 3,
        "name": "Другие продукты"
    }, {
        "id": 51,
        "parent": [35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 52, "parent": 51, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 53,
        "parent": 51,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации (специализированное питание: для детей\/спортсменов и т.п.)"
    }, { "id": 54, "parent": 51, "lvl": 5, "name": "Декларация(-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)" }, {
        "id": 55,
        "parent": 51,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, { "id": 56, "parent": 51, "lvl": 5, "name": "Ветеринарный сертификат\/удостоверение" }, {
        "id": 57,
        "parent": 51,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, { "id": 58, "parent": 51, "lvl": 5, "name": "Сертификат ИСО предприятия (добровольный документ)" }, {
        "id": 59,
        "parent": 51,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 60,
        "parent": [35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 61,
        "parent": 60,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации (специализированное питание: для детей\/спортсменов и т.п.)"
    }, { "id": 62, "parent": 60, "lvl": 5, "name": "Декларация(-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)" }, {
        "id": 63,
        "parent": 60,
        "lvl": 5,
        "name": "Ветеринарный сертификат"
    }, { "id": 64, "parent": 60, "lvl": 5, "name": "Сертификат(-ы) соответствия продукции (добровольные)" }, {
        "id": 65,
        "parent": 60,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 66,
        "parent": [35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 67, "parent": 66, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 68,
        "parent": 66,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 69,
        "parent": [35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 70,
        "parent": 69,
        "lvl": 5,
        "name": "Копии свидетельств о государственной регистрации (специализированное питание: для детей\/спортсменов и т.п.)"
    }, { "id": 71, "parent": 69, "lvl": 5, "name": "Копии деклараций ГОСТ Р (982 ПП РФ от 01.12.2009)" }, {
        "id": 72,
        "parent": 69,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, { "id": 73, "parent": 69, "lvl": 5, "name": "Копии ветеринарного сертификата\/удостоверения" }, {
        "id": 74,
        "parent": 69,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 75,
        "parent": 69,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 76, "parent": 33, "lvl": 2, "name": "Продукция мясной промышленности" }, {
        "id": 77,
        "parent": 76,
        "lvl": 3,
        "name": "Мясо разделанное замороженное"
    }, { "id": 78, "parent": 76, "lvl": 3, "name": "Мясо разделанное охлажденное" }, {
        "id": 79,
        "parent": 76,
        "lvl": 3,
        "name": "Колбаса"
    }, { "id": 80, "parent": 76, "lvl": 3, "name": "Пельмени" }, {
        "id": 81,
        "parent": 76,
        "lvl": 3,
        "name": "Консервы мясные"
    }, { "id": 82, "parent": 76, "lvl": 3, "name": "Супы мясные" }, {
        "id": 83,
        "parent": 76,
        "lvl": 3,
        "name": "Выпечка с мясом"
    }, { "id": 84, "parent": 76, "lvl": 3, "name": "Салаты с мясом" }, {
        "id": 85,
        "parent": 76,
        "lvl": 3,
        "name": "Полуфабрикаты мясные"
    }, { "id": 86, "parent": 76, "lvl": 3, "name": "Продукты из шпика" }, {
        "id": 87,
        "parent": 76,
        "lvl": 3,
        "name": "Мясные продукты для детей"
    }, { "id": 88, "parent": 76, "lvl": 3, "name": "Другие продукты" }, {
        "id": 89,
        "parent": [77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 90, "parent": 89, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 91,
        "parent": 89,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации (специализированное питание: для детей\/спортсменов и т.п.)"
    }, {
        "id": 92,
        "parent": 89,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 034 о безопасности мяса и мясной продукции"
    }, {
        "id": 93,
        "parent": 89,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, { "id": 94, "parent": 89, "lvl": 5, "name": "Ветеринарный сертификат\/удостоверение" }, {
        "id": 95,
        "parent": 89,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, { "id": 96, "parent": 89, "lvl": 5, "name": "Сертификат ИСО предприятия (добровольный документ)" }, {
        "id": 97,
        "parent": 89,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 98,
        "parent": [77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 99,
        "parent": 98,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации (специализированное питание: для детей\/спортсменов и т.п.)"
    }, {
        "id": 100,
        "parent": 98,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 034 о безопасности мяса и мясной продукции"
    }, { "id": 101, "parent": 98, "lvl": 5, "name": "Ветеринарный сертификат" }, {
        "id": 102,
        "parent": 98,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 103,
        "parent": 98,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 104,
        "parent": [77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 105, "parent": 104, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 106,
        "parent": 104,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 107,
        "parent": [77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 108,
        "parent": 107,
        "lvl": 5,
        "name": "Копии свидетельств о государственной регистрации (специализированное питание: для детей\/спортсменов и т.п.)"
    }, {
        "id": 109,
        "parent": 107,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 034 о безопасности мяса и мясной продукции"
    }, {
        "id": 110,
        "parent": 107,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, { "id": 111, "parent": 107, "lvl": 5, "name": "Копии ветеринарного сертификата\/удостоверения" }, {
        "id": 112,
        "parent": 107,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 113,
        "parent": 107,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 114, "parent": 33, "lvl": 2, "name": "Продукция молочной промышленности" }, {
        "id": 115,
        "parent": 114,
        "lvl": 3,
        "name": "Молоко"
    }, { "id": 116, "parent": 114, "lvl": 3, "name": "Кефир" }, {
        "id": 117,
        "parent": 114,
        "lvl": 3,
        "name": "Ряженка"
    }, { "id": 118, "parent": 114, "lvl": 3, "name": "Йогурт" }, {
        "id": 119,
        "parent": 114,
        "lvl": 3,
        "name": "Творог"
    }, { "id": 120, "parent": 114, "lvl": 3, "name": "Сметана" }, {
        "id": 121,
        "parent": 114,
        "lvl": 3,
        "name": "Сыр"
    }, { "id": 122, "parent": 114, "lvl": 3, "name": "Брынза" }, {
        "id": 123,
        "parent": 114,
        "lvl": 3,
        "name": "Молочная продукция для детей"
    }, { "id": 124, "parent": 114, "lvl": 3, "name": "Другие продукты" }, {
        "id": 125,
        "parent": [115, 116, 117, 118, 119, 120, 121, 122, 123, 124],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 126, "parent": 125, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 127,
        "parent": 125,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации (специализированное питание: для детей\/спортсменов и т.п.)"
    }, {
        "id": 128,
        "parent": 125,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 033 о безопасности молока и молочной продукции"
    }, {
        "id": 129,
        "parent": 125,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, { "id": 130, "parent": 125, "lvl": 5, "name": "Ветеринарный сертификат\/удостоверение" }, {
        "id": 131,
        "parent": 125,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, { "id": 132, "parent": 125, "lvl": 5, "name": "Сертификат ИСО предприятия (добровольный документ)" }, {
        "id": 133,
        "parent": 125,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 134,
        "parent": [115, 116, 117, 118, 119, 120, 121, 122, 123, 124],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 135,
        "parent": 134,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации (специализированное питание: для детей\/спортсменов и т.п.)"
    }, {
        "id": 136,
        "parent": 134,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 033 о безопасности молока и молочной продукции"
    }, { "id": 137, "parent": 134, "lvl": 5, "name": "Ветеринарный сертификат" }, {
        "id": 138,
        "parent": 134,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 139,
        "parent": 134,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 140,
        "parent": [115, 116, 117, 118, 119, 120, 121, 122, 123, 124],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 141, "parent": 140, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 142,
        "parent": 140,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 143,
        "parent": [115, 116, 117, 118, 119, 120, 121, 122, 123, 124],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 144,
        "parent": 143,
        "lvl": 5,
        "name": "Копии свидетельств о государственной регистрации (специализированное питание: для детей\/спортсменов и т.п.)"
    }, {
        "id": 145,
        "parent": 143,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 033 о безопасности молока и молочной продукции"
    }, {
        "id": 146,
        "parent": 143,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, { "id": 147, "parent": 143, "lvl": 5, "name": "Копии ветеринарного сертификата\/удостоверения" }, {
        "id": 148,
        "parent": 143,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 149,
        "parent": 143,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 150, "parent": 33, "lvl": 2, "name": "Продукция соковая" }, {
        "id": 151,
        "parent": 150,
        "lvl": 3,
        "name": "Соки из фруктов"
    }, { "id": 152, "parent": 150, "lvl": 3, "name": "Соки из овощей" }, {
        "id": 153,
        "parent": 150,
        "lvl": 3,
        "name": "Нектары из фруктов"
    }, { "id": 154, "parent": 150, "lvl": 3, "name": "Нектары из овощей" }, {
        "id": 155,
        "parent": 150,
        "lvl": 3,
        "name": "Сокосодержащие напитки"
    }, { "id": 156, "parent": 150, "lvl": 3, "name": "Морсы" }, {
        "id": 157,
        "parent": 150,
        "lvl": 3,
        "name": "Пюре фруктовые"
    }, { "id": 158, "parent": 150, "lvl": 3, "name": "Пюре овощные" }, {
        "id": 159,
        "parent": 150,
        "lvl": 3,
        "name": "Соковая продукция для детей"
    }, { "id": 160, "parent": 150, "lvl": 3, "name": "Другие продукты" }, {
        "id": 161,
        "parent": [151, 152, 153, 154, 155, 156, 157, 158, 159, 160],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 162, "parent": 161, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 163,
        "parent": 161,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации (специализированное питание: для детей\/спортсменов и т.п.)"
    }, {
        "id": 164,
        "parent": 161,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 023 о безопасности соковой продукции из фруктов и овощей"
    }, {
        "id": 165,
        "parent": 161,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, {
        "id": 166,
        "parent": 161,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 167,
        "parent": 161,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 168,
        "parent": 161,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 169,
        "parent": [151, 152, 153, 154, 155, 156, 157, 158, 159, 160],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 170,
        "parent": 169,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации (специализированное питание: для детей\/спортсменов и т.п.)"
    }, {
        "id": 171,
        "parent": 169,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 023 о безопасности соковой продукции из фруктов и овощей"
    }, {
        "id": 172,
        "parent": 169,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 173,
        "parent": 169,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 174,
        "parent": [151, 152, 153, 154, 155, 156, 157, 158, 159, 160],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 175, "parent": 174, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 176,
        "parent": 174,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 177,
        "parent": [151, 152, 153, 154, 155, 156, 157, 158, 159, 160],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 178,
        "parent": 177,
        "lvl": 5,
        "name": "Копии свидетельств о государственной регистрации (специализированное питание: для детей\/спортсменов и т.п.)"
    }, {
        "id": 179,
        "parent": 177,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 023 о безопасности соковой продукции из фруктов и овощей"
    }, {
        "id": 180,
        "parent": 177,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, {
        "id": 181,
        "parent": 177,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 182,
        "parent": 177,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 183, "parent": 33, "lvl": 2, "name": "Продукция зерновой промышленности" }, {
        "id": 184,
        "parent": 183,
        "lvl": 3,
        "name": "Пшеница"
    }, { "id": 185, "parent": 183, "lvl": 3, "name": "Ячмень" }, {
        "id": 186,
        "parent": 183,
        "lvl": 3,
        "name": "Овес"
    }, { "id": 187, "parent": 183, "lvl": 3, "name": "Гречиха" }, {
        "id": 188,
        "parent": 183,
        "lvl": 3,
        "name": "Рис"
    }, { "id": 189, "parent": 183, "lvl": 3, "name": "Кукуруза" }, {
        "id": 190,
        "parent": 183,
        "lvl": 3,
        "name": "Горох"
    }, { "id": 191, "parent": 183, "lvl": 3, "name": "Нут" }, {
        "id": 192,
        "parent": 183,
        "lvl": 3,
        "name": "Фасоль"
    }, { "id": 193, "parent": 183, "lvl": 3, "name": "Чечевица" }, {
        "id": 194,
        "parent": 183,
        "lvl": 3,
        "name": "Соя"
    }, { "id": 195, "parent": 183, "lvl": 3, "name": "Лен" }, {
        "id": 196,
        "parent": 183,
        "lvl": 3,
        "name": "Горчица"
    }, { "id": 197, "parent": 183, "lvl": 3, "name": "Кунжут" }, {
        "id": 198,
        "parent": 183,
        "lvl": 3,
        "name": "Арахис"
    }, { "id": 199, "parent": 183, "lvl": 3, "name": "Прочие зерновые" }, {
        "id": 200,
        "parent": [184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 201, "parent": 200, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 202,
        "parent": 200,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 015 о безопасности зерна"
    }, {
        "id": 203,
        "parent": 200,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, {
        "id": 204,
        "parent": 200,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 205,
        "parent": 200,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, { "id": 206, "parent": 200, "lvl": 5, "name": "Фитосанитарные сертификаты" }, {
        "id": 207,
        "parent": 200,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 208,
        "parent": [184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 209,
        "parent": 208,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 015 о безопасности зерна"
    }, {
        "id": 210,
        "parent": 208,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 211,
        "parent": 208,
        "lvl": 5,
        "name": "Фитосанитарные сертификаты"
    }, {
        "id": 212,
        "parent": 208,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 213,
        "parent": [184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 214, "parent": 213, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 215,
        "parent": 213,
        "lvl": 5,
        "name": "Фитосанитарные сертификаты"
    }, {
        "id": 216,
        "parent": 213,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 217,
        "parent": [184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 218,
        "parent": 217,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 015 о безопасности зерна"
    }, {
        "id": 219,
        "parent": 217,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, {
        "id": 220,
        "parent": 217,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, { "id": 221, "parent": 217, "lvl": 5, "name": "Копии фитосанитарных сертификатов" }, {
        "id": 222,
        "parent": 217,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 223, "parent": 33, "lvl": 2, "name": "Продукция из мяса птицы" }, {
        "id": 224,
        "parent": 223,
        "lvl": 3,
        "name": "Мясо разделанное замороженное"
    }, { "id": 225, "parent": 223, "lvl": 3, "name": "Мясо разделанное охлажденное" }, {
        "id": 226,
        "parent": 223,
        "lvl": 3,
        "name": "Консервы мясные"
    }, { "id": 227, "parent": 223, "lvl": 3, "name": "Супы мясные" }, {
        "id": 228,
        "parent": 223,
        "lvl": 3,
        "name": "Выпечка с мясом"
    }, { "id": 229, "parent": 223, "lvl": 3, "name": "Салаты с мясом" }, {
        "id": 230,
        "parent": 223,
        "lvl": 3,
        "name": "Полуфабрикаты мясные"
    }, { "id": 231, "parent": 223, "lvl": 3, "name": "Мясные продукты для детей" }, {
        "id": 232,
        "parent": 223,
        "lvl": 3,
        "name": "Другие продукты"
    }, {
        "id": 233,
        "parent": [224, 225, 226, 227, 228, 229, 230, 231, 232],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 234, "parent": 233, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 235,
        "parent": 233,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации (специализированное питание: для детей\/спортсменов и т.п.)"
    }, {
        "id": 236,
        "parent": 233,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 034 о безопасности мяса и мясной продукции"
    }, {
        "id": 237,
        "parent": 233,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, {
        "id": 238,
        "parent": 233,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 239,
        "parent": 233,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 240,
        "parent": 233,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 241,
        "parent": [224, 225, 226, 227, 228, 229, 230, 231, 232],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 242,
        "parent": 241,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации (специализированное питание: для детей\/спортсменов и т.п.)"
    }, {
        "id": 243,
        "parent": 241,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 034 о безопасности мяса и мясной продукции"
    }, {
        "id": 244,
        "parent": 241,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 245,
        "parent": 241,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 246,
        "parent": [224, 225, 226, 227, 228, 229, 230, 231, 232],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 247, "parent": 246, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 248,
        "parent": 246,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 249,
        "parent": [224, 225, 226, 227, 228, 229, 230, 231, 232],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 250,
        "parent": 249,
        "lvl": 5,
        "name": "Копии свидетельств о государственной регистрации (специализированное питание: для детей\/спортсменов и т.п.)"
    }, {
        "id": 251,
        "parent": 249,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 034 о безопасности мяса и мясной продукции"
    }, {
        "id": 252,
        "parent": 249,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, {
        "id": 253,
        "parent": 249,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 254,
        "parent": 249,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 255, "parent": 33, "lvl": 2, "name": "Продукция масложировой промышленности" }, {
        "id": 256,
        "parent": 255,
        "lvl": 3,
        "name": "Масло растительное"
    }, { "id": 257, "parent": 255, "lvl": 3, "name": "Маргарин" }, {
        "id": 258,
        "parent": 255,
        "lvl": 3,
        "name": "Майонез"
    }, { "id": 259, "parent": 255, "lvl": 3, "name": "Спред" }, {
        "id": 260,
        "parent": 255,
        "lvl": 3,
        "name": "Жиры кулинарные"
    }, { "id": 261, "parent": 255, "lvl": 3, "name": "Заменители масла" }, {
        "id": 262,
        "parent": 255,
        "lvl": 3,
        "name": "Улучшители масла"
    }, { "id": 263, "parent": 255, "lvl": 3, "name": "Соусы на основе растительных масел" }, {
        "id": 264,
        "parent": 255,
        "lvl": 3,
        "name": "Глицерин натуральный"
    }, { "id": 265, "parent": 255, "lvl": 3, "name": "Мыло хозяйственное" }, {
        "id": 266,
        "parent": 255,
        "lvl": 3,
        "name": "Другие продукты"
    }, {
        "id": 267,
        "parent": [256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 268, "parent": 267, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 269,
        "parent": 267,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 024 о безопасности масложировой продукции"
    }, {
        "id": 270,
        "parent": 267,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, {
        "id": 271,
        "parent": 267,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 272,
        "parent": 267,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 273,
        "parent": 267,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 274,
        "parent": [256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 275,
        "parent": 274,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 024 о безопасности масложировой продукции"
    }, {
        "id": 276,
        "parent": 274,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 277,
        "parent": 274,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 278,
        "parent": [256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 279, "parent": 278, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 280,
        "parent": 278,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 281,
        "parent": [256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 282,
        "parent": 281,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 024 о безопасности масложировой продукции"
    }, {
        "id": 283,
        "parent": 281,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, {
        "id": 284,
        "parent": 281,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 285,
        "parent": 281,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 286,
        "parent": 33,
        "lvl": 2,
        "name": "Специальное питание для спорстменов, диетическое питание"
    }, { "id": 287, "parent": 286, "lvl": 3, "name": "Питание для спортсменов" }, {
        "id": 288,
        "parent": 286,
        "lvl": 3,
        "name": "Диетическое питание"
    }, { "id": 289, "parent": 286, "lvl": 3, "name": "Другие продукты" }, {
        "id": 290,
        "parent": [287, 288, 289],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 291, "parent": 290, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 292,
        "parent": 290,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации"
    }, {
        "id": 293,
        "parent": 290,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, {
        "id": 294,
        "parent": 290,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 295,
        "parent": 290,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 296,
        "parent": 290,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 297, "parent": [287, 288, 289], "lvl": 4, "name": "Я - импортер" }, {
        "id": 298,
        "parent": 297,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации"
    }, {
        "id": 299,
        "parent": 297,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 300,
        "parent": 297,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 301, "parent": [287, 288, 289], "lvl": 4, "name": "Я - экспортер" }, {
        "id": 302,
        "parent": 301,
        "lvl": 5,
        "name": "Сертификат(-ы) происхождения продукции"
    }, {
        "id": 303,
        "parent": 301,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, { "id": 304, "parent": [287, 288, 289], "lvl": 4, "name": "Я - продавец" }, {
        "id": 305,
        "parent": 304,
        "lvl": 5,
        "name": "Копии свидетельств о государственной регистрации"
    }, {
        "id": 306,
        "parent": 304,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, {
        "id": 307,
        "parent": 304,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 308,
        "parent": 304,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 309, "parent": 33, "lvl": 2, "name": "БАДы" }, {
        "id": 310,
        "parent": 309,
        "lvl": 3,
        "name": "БАДы в таблетках"
    }, { "id": 311, "parent": 309, "lvl": 3, "name": "Жидкие БАДы" }, {
        "id": 312,
        "parent": 309,
        "lvl": 3,
        "name": "БАДы порошкообразные"
    }, { "id": 313, "parent": 309, "lvl": 3, "name": "Другие БАДы" }, {
        "id": 314,
        "parent": [310, 311, 312, 313],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 315, "parent": 314, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 316,
        "parent": 314,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации"
    }, {
        "id": 317,
        "parent": 314,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, {
        "id": 318,
        "parent": 314,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 319,
        "parent": 314,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 320,
        "parent": 314,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 321, "parent": [310, 311, 312, 313], "lvl": 4, "name": "Я - импортер" }, {
        "id": 322,
        "parent": 321,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации"
    }, {
        "id": 323,
        "parent": 321,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 324,
        "parent": 321,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 325, "parent": [310, 311, 312, 313], "lvl": 4, "name": "Я - экспортер" }, {
        "id": 326,
        "parent": 325,
        "lvl": 5,
        "name": "Сертификат(-ы) происхождения продукции"
    }, {
        "id": 327,
        "parent": 325,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, { "id": 328, "parent": [310, 311, 312, 313], "lvl": 4, "name": "Я - продавец" }, {
        "id": 329,
        "parent": 328,
        "lvl": 5,
        "name": "Копии свидетельств о государственной регистрации"
    }, {
        "id": 330,
        "parent": 328,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, {
        "id": 331,
        "parent": 328,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 332,
        "parent": 328,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 333, "parent": 33, "lvl": 2, "name": "Питание для детей" }, {
        "id": 334,
        "parent": 333,
        "lvl": 3,
        "name": "Пюре"
    }, { "id": 335, "parent": 333, "lvl": 3, "name": "Смеси" }, {
        "id": 336,
        "parent": 333,
        "lvl": 3,
        "name": "Каши"
    }, { "id": 337, "parent": 333, "lvl": 3, "name": "Напитки" }, {
        "id": 338,
        "parent": 333,
        "lvl": 3,
        "name": "Супы"
    }, { "id": 339, "parent": 333, "lvl": 3, "name": "Конфеты" }, {
        "id": 340,
        "parent": 333,
        "lvl": 3,
        "name": "Другие продукты"
    }, { "id": 341, "parent": [334, 335, 336, 337, 338, 339, 340], "lvl": 4, "name": "Я - изготовитель" }, {
        "id": 342,
        "parent": 341,
        "lvl": 5,
        "name": "Технические условия (или ГОСТ при наличии)"
    }, { "id": 343, "parent": 341, "lvl": 5, "name": "Свидетельство(-а) о государственной регистрации" }, {
        "id": 344,
        "parent": 341,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, {
        "id": 345,
        "parent": 341,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 346,
        "parent": 341,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 347,
        "parent": 341,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 348, "parent": [334, 335, 336, 337, 338, 339, 340], "lvl": 4, "name": "Я - импортер" }, {
        "id": 349,
        "parent": 348,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации"
    }, {
        "id": 350,
        "parent": 348,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 351,
        "parent": 348,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 352, "parent": [334, 335, 336, 337, 338, 339, 340], "lvl": 4, "name": "Я - экспортер" }, {
        "id": 353,
        "parent": 352,
        "lvl": 5,
        "name": "Сертификат(-ы) происхождения продукции"
    }, {
        "id": 354,
        "parent": 352,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, { "id": 355, "parent": [334, 335, 336, 337, 338, 339, 340], "lvl": 4, "name": "Я - продавец" }, {
        "id": 356,
        "parent": 355,
        "lvl": 5,
        "name": "Копии свидетельств о государственной регистрации"
    }, {
        "id": 357,
        "parent": 355,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, {
        "id": 358,
        "parent": 355,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 359,
        "parent": 355,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 360,
        "parent": 33,
        "lvl": 2,
        "name": "Продукция пищевой промышленности (не указанная в списке)"
    }, { "id": 361, "parent": 360, "lvl": 3, "name": "Овощи" }, {
        "id": 362,
        "parent": 360,
        "lvl": 3,
        "name": "Фрукты"
    }, { "id": 363, "parent": 360, "lvl": 3, "name": "Грибы" }, {
        "id": 364,
        "parent": 360,
        "lvl": 3,
        "name": "Ягоды"
    }, { "id": 365, "parent": 360, "lvl": 3, "name": "Каши" }, {
        "id": 366,
        "parent": 360,
        "lvl": 3,
        "name": "Чай"
    }, { "id": 367, "parent": 360, "lvl": 3, "name": "Кофе" }, {
        "id": 368,
        "parent": 360,
        "lvl": 3,
        "name": "Выпечка"
    }, { "id": 369, "parent": 360, "lvl": 3, "name": "Специи" }, {
        "id": 370,
        "parent": 360,
        "lvl": 3,
        "name": "Макароны"
    }, { "id": 371, "parent": 360, "lvl": 3, "name": "Прочие продукты" }, {
        "id": 372,
        "parent": [361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 373, "parent": 372, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 374,
        "parent": 372,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации (специализированное питание: для детей\/спортсменов и т.п.)"
    }, {
        "id": 375,
        "parent": 372,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 021 о безопасности пищевой продукции"
    }, {
        "id": 376,
        "parent": 372,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, {
        "id": 377,
        "parent": 372,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 378,
        "parent": 372,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 379,
        "parent": 372,
        "lvl": 5,
        "name": "Фитосанитарные сертификаты (на овощи\/фрукты\/ягоды\/грибы и т.п.)"
    }, {
        "id": 380,
        "parent": 372,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 381,
        "parent": [361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 382,
        "parent": 381,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации (специализированное питание: для детей\/спортсменов и т.п.)"
    }, {
        "id": 383,
        "parent": 381,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 021 о безопасности пищевой продукции"
    }, {
        "id": 384,
        "parent": 381,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 385,
        "parent": 381,
        "lvl": 5,
        "name": "Фитосанитарные сертификаты (на овощи\/фрукты\/ягоды\/грибы и т.п.)"
    }, {
        "id": 386,
        "parent": 381,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 387,
        "parent": [361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 388, "parent": 387, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 389,
        "parent": 387,
        "lvl": 5,
        "name": "Фитосанитарные сертификаты (на овощи\/фрукты\/ягоды\/грибы и т.п.)"
    }, {
        "id": 390,
        "parent": 387,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 391,
        "parent": [361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 392,
        "parent": 391,
        "lvl": 5,
        "name": "Копии свидетельств о государственной регистрации (специализированное питание: для детей\/спортсменов и т.п.)"
    }, {
        "id": 393,
        "parent": 391,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 021 о безопасности пищевой продукции"
    }, {
        "id": 394,
        "parent": 391,
        "lvl": 5,
        "name": "Разработанные и внедренные принципы безопасности пищевого производства (ХАССП)"
    }, {
        "id": 395,
        "parent": 391,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 396,
        "parent": 391,
        "lvl": 5,
        "name": "Копии фитосанитарных сертификатов (на овощи\/фрукты\/ягоды\/грибы и т.п.)"
    }, {
        "id": 397,
        "parent": 391,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 398, "parent": 0, "lvl": 1, "name": "Продукция деревообрабатывающей промышленности" }, {
        "id": 399,
        "parent": 398,
        "lvl": 2,
        "name": "Продукция деревообрабатывающей промышленности"
    }, { "id": 400, "parent": 399, "lvl": 3, "name": "Доска" }, {
        "id": 401,
        "parent": 399,
        "lvl": 3,
        "name": "Брус"
    }, { "id": 402, "parent": 399, "lvl": 3, "name": "Фанера" }, {
        "id": 403,
        "parent": 399,
        "lvl": 3,
        "name": "Евровагонка"
    }, { "id": 404, "parent": 399, "lvl": 3, "name": "Шпунт" }, {
        "id": 405,
        "parent": 399,
        "lvl": 3,
        "name": "Плинтуса"
    }, { "id": 406, "parent": 399, "lvl": 3, "name": "Наличники" }, {
        "id": 407,
        "parent": 399,
        "lvl": 3,
        "name": "Уголки"
    }, { "id": 408, "parent": 399, "lvl": 3, "name": "Прочие изделия" }, {
        "id": 409,
        "parent": [400, 401, 402, 403, 404, 405, 406, 407, 408],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 410, "parent": 409, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 411,
        "parent": 409,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии пожарной безопасности"
    }, {
        "id": 412,
        "parent": 409,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии пожарной безопасности"
    }, {
        "id": 413,
        "parent": 409,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, { "id": 414, "parent": 409, "lvl": 5, "name": "Сертификат ИСО предприятия (добровольный документ)" }, {
        "id": 415,
        "parent": 409,
        "lvl": 5,
        "name": "Фитосанитарные сертификаты"
    }, {
        "id": 416,
        "parent": 409,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 417,
        "parent": [400, 401, 402, 403, 404, 405, 406, 407, 408],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 418,
        "parent": 417,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии пожарной безопасности"
    }, {
        "id": 419,
        "parent": 417,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии пожарной безопасности"
    }, {
        "id": 420,
        "parent": 417,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 421,
        "parent": 417,
        "lvl": 5,
        "name": "Фитосанитарные сертификаты"
    }, {
        "id": 422,
        "parent": 417,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 423,
        "parent": [400, 401, 402, 403, 404, 405, 406, 407, 408],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 424, "parent": 423, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 425,
        "parent": 423,
        "lvl": 5,
        "name": "Фитосанитарные сертификаты"
    }, {
        "id": 426,
        "parent": 423,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 427,
        "parent": [400, 401, 402, 403, 404, 405, 406, 407, 408],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 428,
        "parent": 427,
        "lvl": 5,
        "name": "Копии сертификатов о соответствии пожарной безопасности"
    }, {
        "id": 429,
        "parent": 427,
        "lvl": 5,
        "name": "Копии деклараций о соответствии пожарной безопасности"
    }, { "id": 430, "parent": 427, "lvl": 5, "name": "Копии фитосанитарных сертификатов" }, {
        "id": 431,
        "parent": 427,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 432,
        "parent": 427,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 433,
        "parent": 0,
        "lvl": 1,
        "name": "Оборудование промышленное, бытовая техника, осветительное оборудование"
    }, { "id": 434, "parent": 433, "lvl": 2, "name": "Оборудование деревообрабатывающее" }, {
        "id": 435,
        "parent": 434,
        "lvl": 3,
        "name": "Ленточное оборудование"
    }, { "id": 436, "parent": 434, "lvl": 3, "name": "Фрезерное оборудование" }, {
        "id": 437,
        "parent": 434,
        "lvl": 3,
        "name": "Сушильные камеры"
    }, { "id": 438, "parent": 434, "lvl": 3, "name": "Пилы" }, {
        "id": 439,
        "parent": 434,
        "lvl": 3,
        "name": "Пресса"
    }, { "id": 440, "parent": 434, "lvl": 3, "name": "Столярное оборудование" }, {
        "id": 441,
        "parent": 434,
        "lvl": 3,
        "name": "Станки для обработки шпона"
    }, { "id": 442, "parent": 434, "lvl": 3, "name": "Оборудование для сращивания по длине" }, {
        "id": 443,
        "parent": 434,
        "lvl": 3,
        "name": "Автоподатчики"
    }, { "id": 444, "parent": 434, "lvl": 3, "name": "Лазерногравировальные станки" }, {
        "id": 445,
        "parent": 434,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 446,
        "parent": [435, 436, 437, 438, 439, 440, 441, 442, 443, 444, 445],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 447, "parent": 446, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 448,
        "parent": 446,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 449,
        "parent": 446,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 450,
        "parent": 446,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 451,
        "parent": 446,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 452,
        "parent": 446,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 453,
        "parent": [435, 436, 437, 438, 439, 440, 441, 442, 443, 444, 445],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 454,
        "parent": 453,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 455,
        "parent": 453,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 456,
        "parent": 453,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 457,
        "parent": 453,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 458,
        "parent": [435, 436, 437, 438, 439, 440, 441, 442, 443, 444, 445],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 459, "parent": 458, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 460,
        "parent": 458,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 461,
        "parent": [435, 436, 437, 438, 439, 440, 441, 442, 443, 444, 445],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 462,
        "parent": 461,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 463,
        "parent": 461,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 464,
        "parent": 461,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 465,
        "parent": 461,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 466, "parent": 433, "lvl": 2, "name": "Оборудование гаражное" }, {
        "id": 467,
        "parent": 466,
        "lvl": 3,
        "name": "Стенд для балансировки колес"
    }, { "id": 468, "parent": 466, "lvl": 3, "name": "Подъмник автомобильный" }, {
        "id": 469,
        "parent": 466,
        "lvl": 3,
        "name": "Вытяжка выхлопных газов"
    }, { "id": 470, "parent": 466, "lvl": 3, "name": "Домкраты" }, {
        "id": 471,
        "parent": 466,
        "lvl": 3,
        "name": "Компрессоры поршневые"
    }, { "id": 472, "parent": 466, "lvl": 3, "name": "Диагностическое оборудование" }, {
        "id": 473,
        "parent": 466,
        "lvl": 3,
        "name": "Покрасочное оборудование"
    }, { "id": 474, "parent": 466, "lvl": 3, "name": "Шиномонтажное оборудование" }, {
        "id": 475,
        "parent": 466,
        "lvl": 3,
        "name": "Очистительное оборудование"
    }, { "id": 476, "parent": 466, "lvl": 3, "name": "Тали, лебедки, краны" }, {
        "id": 477,
        "parent": 466,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 478,
        "parent": [467, 468, 469, 470, 471, 472, 473, 474, 475, 476, 477],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 479, "parent": 478, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 480,
        "parent": 478,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 481,
        "parent": 478,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 482,
        "parent": 478,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 483,
        "parent": 478,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 484,
        "parent": 478,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 485,
        "parent": [467, 468, 469, 470, 471, 472, 473, 474, 475, 476, 477],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 486,
        "parent": 485,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 487,
        "parent": 485,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 488,
        "parent": 485,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 489,
        "parent": 485,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 490,
        "parent": [467, 468, 469, 470, 471, 472, 473, 474, 475, 476, 477],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 491, "parent": 490, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 492,
        "parent": 490,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 493,
        "parent": [467, 468, 469, 470, 471, 472, 473, 474, 475, 476, 477],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 494,
        "parent": 493,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 495,
        "parent": 493,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 496,
        "parent": 493,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 497,
        "parent": 493,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 498,
        "parent": 433,
        "lvl": 2,
        "name": "Оборудование для сельского хозяйства (в т.ч. тракторы)"
    }, { "id": 499, "parent": 498, "lvl": 3, "name": "Тракторы" }, {
        "id": 500,
        "parent": 498,
        "lvl": 3,
        "name": "Прицепы к тракторам"
    }, { "id": 501, "parent": 498, "lvl": 3, "name": "Разрбрызгиватели" }, {
        "id": 502,
        "parent": 498,
        "lvl": 3,
        "name": "Рассеиватели"
    }, { "id": 503, "parent": 498, "lvl": 3, "name": "Крартофелесажалки" }, {
        "id": 504,
        "parent": 498,
        "lvl": 3,
        "name": "Грабли"
    }, { "id": 505, "parent": 498, "lvl": 3, "name": "Косилки" }, {
        "id": 506,
        "parent": 498,
        "lvl": 3,
        "name": "Окучники"
    }, { "id": 507, "parent": 498, "lvl": 3, "name": "Сеялки" }, {
        "id": 508,
        "parent": 498,
        "lvl": 3,
        "name": "Сеновязальная машина"
    }, { "id": 509, "parent": 498, "lvl": 3, "name": "Культиваторы" }, {
        "id": 510,
        "parent": 498,
        "lvl": 3,
        "name": "Пресс-подборщики"
    }, { "id": 511, "parent": 498, "lvl": 3, "name": "Почвообрабатывающий агрегат" }, {
        "id": 512,
        "parent": 498,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 513,
        "parent": [499, 500, 501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511, 512],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 514, "parent": 513, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 515,
        "parent": 513,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 516,
        "parent": 513,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 517,
        "parent": 513,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 031 о безопасности с\/х и лесо\/х тракторов и прицепов к ним"
    }, {
        "id": 518,
        "parent": 513,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 031 о безопасности с\/х и лесо\/х тракторов и прицепов к ним"
    }, {
        "id": 519,
        "parent": 513,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 520,
        "parent": 513,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 521,
        "parent": 513,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 522,
        "parent": [499, 500, 501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511, 512],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 523,
        "parent": 522,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 524,
        "parent": 522,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 525,
        "parent": 522,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 031 о безопасности с\/х и лесо\/х тракторов и прицепов к ним"
    }, {
        "id": 526,
        "parent": 522,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 031 о безопасности с\/х и лесо\/х тракторов и прицепов к ним"
    }, {
        "id": 527,
        "parent": 522,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 528,
        "parent": 522,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 529,
        "parent": [499, 500, 501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511, 512],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 530, "parent": 529, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 531,
        "parent": 529,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 532,
        "parent": [499, 500, 501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511, 512],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 533,
        "parent": 532,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 534,
        "parent": 532,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 535,
        "parent": 532,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 031 о безопасности с\/х и лесо\/х тракторов и прицепов к ним"
    }, {
        "id": 536,
        "parent": 532,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 031 о безопасности с\/х и лесо\/х тракторов и прицепов к ним"
    }, {
        "id": 537,
        "parent": 532,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 538,
        "parent": 532,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 539,
        "parent": 433,
        "lvl": 2,
        "name": "Оборудование для лесозаготовительной промышленности"
    }, {
        "id": 540,
        "parent": 539,
        "lvl": 3,
        "name": "Лесные трактора"
    }, { "id": 541, "parent": 539, "lvl": 3, "name": "Прицепы к лесным тракторам" }, {
        "id": 542,
        "parent": 539,
        "lvl": 3,
        "name": "Лесопогрузчики"
    }, { "id": 543, "parent": 539, "lvl": 3, "name": "Лесопильное оборудование" }, {
        "id": 544,
        "parent": 539,
        "lvl": 3,
        "name": "Измельчители\/дробилки"
    }, { "id": 545, "parent": 539, "lvl": 3, "name": "Лесозахваты" }, {
        "id": 546,
        "parent": 539,
        "lvl": 3,
        "name": "Дровоколы"
    }, { "id": 547, "parent": 539, "lvl": 3, "name": "Другое оборудование" }, {
        "id": 548,
        "parent": [540, 541, 542, 543, 544, 545, 546, 547],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 549, "parent": 548, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 550,
        "parent": 548,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 551,
        "parent": 548,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 552,
        "parent": 548,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 031 о безопасности с\/х и лесо\/х тракторов и прицепов к ним"
    }, {
        "id": 553,
        "parent": 548,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 031 о безопасности с\/х и лесо\/х тракторов и прицепов к ним"
    }, {
        "id": 554,
        "parent": 548,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 555,
        "parent": 548,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 556,
        "parent": 548,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 557, "parent": [540, 541, 542, 543, 544, 545, 546, 547], "lvl": 4, "name": "Я - импортер" }, {
        "id": 558,
        "parent": 557,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 559,
        "parent": 557,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 560,
        "parent": 557,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 031 о безопасности с\/х и лесо\/х тракторов и прицепов к ним"
    }, {
        "id": 561,
        "parent": 557,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 031 о безопасности с\/х и лесо\/х тракторов и прицепов к ним"
    }, {
        "id": 562,
        "parent": 557,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 563,
        "parent": 557,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 564, "parent": [540, 541, 542, 543, 544, 545, 546, 547], "lvl": 4, "name": "Я - экспортер" }, {
        "id": 565,
        "parent": 564,
        "lvl": 5,
        "name": "Сертификат(-ы) происхождения продукции"
    }, {
        "id": 566,
        "parent": 564,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, { "id": 567, "parent": [540, 541, 542, 543, 544, 545, 546, 547], "lvl": 4, "name": "Я - продавец" }, {
        "id": 568,
        "parent": 567,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 569,
        "parent": 567,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 570,
        "parent": 567,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 031 о безопасности с\/х и лесо\/х тракторов и прицепов к ним"
    }, {
        "id": 571,
        "parent": 567,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 031 о безопасности с\/х и лесо\/х тракторов и прицепов к ним"
    }, {
        "id": 572,
        "parent": 567,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 573,
        "parent": 567,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 574,
        "parent": 433,
        "lvl": 2,
        "name": "Оборудование для предприятий торговли и общественного питания"
    }, { "id": 575, "parent": 574, "lvl": 3, "name": "Электромеханическое оборудование" }, {
        "id": 576,
        "parent": 574,
        "lvl": 3,
        "name": "Тепловое оборудование"
    }, { "id": 577, "parent": 574, "lvl": 3, "name": "Оборудование для выпечки" }, {
        "id": 578,
        "parent": 574,
        "lvl": 3,
        "name": "Оборудование для фаст-фуда"
    }, { "id": 579, "parent": 574, "lvl": 3, "name": "Холодильное оборудование" }, {
        "id": 580,
        "parent": 574,
        "lvl": 3,
        "name": "Барное оборудование"
    }, { "id": 581, "parent": 574, "lvl": 3, "name": "Кофемашины" }, {
        "id": 582,
        "parent": 574,
        "lvl": 3,
        "name": "Посудомоечное оборудование"
    }, { "id": 583, "parent": 574, "lvl": 3, "name": "Упаковочное оборудование" }, {
        "id": 584,
        "parent": 574,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 585,
        "parent": [575, 576, 577, 578, 579, 580, 581, 582, 583, 584],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 586, "parent": 585, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 587,
        "parent": 585,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 588,
        "parent": 585,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 589,
        "parent": 585,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 590,
        "parent": 585,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 591,
        "parent": 585,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 592,
        "parent": [575, 576, 577, 578, 579, 580, 581, 582, 583, 584],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 593,
        "parent": 592,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 594,
        "parent": 592,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 595,
        "parent": 592,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 596,
        "parent": 592,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 597,
        "parent": [575, 576, 577, 578, 579, 580, 581, 582, 583, 584],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 598, "parent": 597, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 599,
        "parent": 597,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 600,
        "parent": [575, 576, 577, 578, 579, 580, 581, 582, 583, 584],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 601,
        "parent": 600,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 602,
        "parent": 600,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 603,
        "parent": 600,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 604,
        "parent": 600,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 605, "parent": 433, "lvl": 2, "name": "Оборудование для горно-шахтной промышленности" }, {
        "id": 606,
        "parent": 605,
        "lvl": 3,
        "name": "Щековая дробилка"
    }, { "id": 607, "parent": 605, "lvl": 3, "name": "Шаровая мельница" }, {
        "id": 608,
        "parent": 605,
        "lvl": 3,
        "name": "Флотационная машина"
    }, { "id": 609, "parent": 605, "lvl": 3, "name": "Сепаратор" }, {
        "id": 610,
        "parent": 605,
        "lvl": 3,
        "name": "Отсадочная машина"
    }, { "id": 611, "parent": 605, "lvl": 3, "name": "Классификатор" }, {
        "id": 612,
        "parent": 605,
        "lvl": 3,
        "name": "Сгуститель"
    }, { "id": 613, "parent": 605, "lvl": 3, "name": "Чаны" }, {
        "id": 614,
        "parent": 605,
        "lvl": 3,
        "name": "Оборудование для электролиза и десорбции"
    }, { "id": 615, "parent": 605, "lvl": 3, "name": "Виброгрохот" }, {
        "id": 616,
        "parent": 605,
        "lvl": 3,
        "name": "Ленточный конвейер"
    }, { "id": 617, "parent": 605, "lvl": 3, "name": "Пескомойка" }, {
        "id": 618,
        "parent": 605,
        "lvl": 3,
        "name": "Мельница"
    }, { "id": 619, "parent": 605, "lvl": 3, "name": "Элеватор" }, {
        "id": 620,
        "parent": 605,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 621,
        "parent": [606, 607, 608, 609, 610, 611, 612, 613, 614, 615, 616, 617, 618, 619, 620],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 622, "parent": 621, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 623,
        "parent": 621,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 624,
        "parent": 621,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 625,
        "parent": 621,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 012 о безопасности оборудования при работе во взрывоопасных средах"
    }, {
        "id": 626,
        "parent": 621,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 012 о безопасности оборудования при работе во взрывоопасных средах"
    }, {
        "id": 627,
        "parent": 621,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 628,
        "parent": 621,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 629,
        "parent": 621,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 630,
        "parent": 621,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 631,
        "parent": 621,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 632,
        "parent": [606, 607, 608, 609, 610, 611, 612, 613, 614, 615, 616, 617, 618, 619, 620],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 633,
        "parent": 632,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 634,
        "parent": 632,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 635,
        "parent": 632,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 012 о безопасности оборудования при работе во взрывоопасных средах"
    }, {
        "id": 636,
        "parent": 632,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 012 о безопасности оборудования при работе во взрывоопасных средах"
    }, {
        "id": 637,
        "parent": 632,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 638,
        "parent": 632,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 639,
        "parent": 632,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 640,
        "parent": 632,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 641,
        "parent": [606, 607, 608, 609, 610, 611, 612, 613, 614, 615, 616, 617, 618, 619, 620],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 642, "parent": 641, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 643,
        "parent": 641,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 644,
        "parent": [606, 607, 608, 609, 610, 611, 612, 613, 614, 615, 616, 617, 618, 619, 620],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 645,
        "parent": 644,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 646,
        "parent": 644,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 647,
        "parent": 644,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 012 о безопасности оборудования при работе во взрывоопасных средах"
    }, {
        "id": 648,
        "parent": 644,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 012 о безопасности оборудования при работе во взрывоопасных средах"
    }, {
        "id": 649,
        "parent": 644,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 650,
        "parent": 644,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 651,
        "parent": 644,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 652,
        "parent": 644,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 653, "parent": 433, "lvl": 2, "name": "Оборудование буровое" }, {
        "id": 654,
        "parent": 653,
        "lvl": 3,
        "name": "Буровые установки"
    }, { "id": 655, "parent": 653, "lvl": 3, "name": "Буровые насосы" }, {
        "id": 656,
        "parent": 653,
        "lvl": 3,
        "name": "Компрессоры"
    }, { "id": 657, "parent": 653, "lvl": 3, "name": "Гидромолоты" }, {
        "id": 658,
        "parent": 653,
        "lvl": 3,
        "name": "Вибропогружатели"
    }, { "id": 659, "parent": 653, "lvl": 3, "name": "Гидробуры" }, {
        "id": 660,
        "parent": 653,
        "lvl": 3,
        "name": "Гидроподъемники"
    }, { "id": 661, "parent": 653, "lvl": 3, "name": "Другое оборудование" }, {
        "id": 662,
        "parent": [654, 655, 656, 657, 658, 659, 660, 661],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 663, "parent": 662, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 664,
        "parent": 662,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 665,
        "parent": 662,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 666,
        "parent": 662,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 012 о безопасности оборудования при работе во взрывоопасных средах"
    }, {
        "id": 667,
        "parent": 662,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 012 о безопасности оборудования при работе во взрывоопасных средах"
    }, {
        "id": 668,
        "parent": 662,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 669,
        "parent": 662,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 670,
        "parent": 662,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 671,
        "parent": 662,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 672,
        "parent": 662,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 673, "parent": [654, 655, 656, 657, 658, 659, 660, 661], "lvl": 4, "name": "Я - импортер" }, {
        "id": 674,
        "parent": 673,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 675,
        "parent": 673,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 676,
        "parent": 673,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 012 о безопасности оборудования при работе во взрывоопасных средах"
    }, {
        "id": 677,
        "parent": 673,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 012 о безопасности оборудования при работе во взрывоопасных средах"
    }, {
        "id": 678,
        "parent": 673,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 679,
        "parent": 673,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 680,
        "parent": 673,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 681,
        "parent": 673,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 682, "parent": [654, 655, 656, 657, 658, 659, 660, 661], "lvl": 4, "name": "Я - экспортер" }, {
        "id": 683,
        "parent": 682,
        "lvl": 5,
        "name": "Сертификат(-ы) происхождения продукции"
    }, {
        "id": 684,
        "parent": 682,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, { "id": 685, "parent": [654, 655, 656, 657, 658, 659, 660, 661], "lvl": 4, "name": "Я - продавец" }, {
        "id": 686,
        "parent": 685,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 687,
        "parent": 685,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 688,
        "parent": 685,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 012 о безопасности оборудования при работе во взрывоопасных средах"
    }, {
        "id": 689,
        "parent": 685,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 012 о безопасности оборудования при работе во взрывоопасных средах"
    }, {
        "id": 690,
        "parent": 685,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 691,
        "parent": 685,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 692,
        "parent": 685,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 693,
        "parent": 685,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 694, "parent": 433, "lvl": 2, "name": "Оборудование химическое, нефтегазоперерабатывающее" }, {
        "id": 695,
        "parent": 694,
        "lvl": 3,
        "name": "Оборудование емкостное"
    }, { "id": 696, "parent": 694, "lvl": 3, "name": "Оборудование реакторное" }, {
        "id": 697,
        "parent": 694,
        "lvl": 3,
        "name": "Оборудование фильтровальное"
    }, { "id": 698, "parent": 694, "lvl": 3, "name": "Оборудование экстракционное" }, {
        "id": 699,
        "parent": 694,
        "lvl": 3,
        "name": "Оборудование сорбционное"
    }, { "id": 700, "parent": 694, "lvl": 3, "name": "Оборудование вентиляционное" }, {
        "id": 701,
        "parent": 694,
        "lvl": 3,
        "name": "Оборудование водо-газоочистное"
    }, { "id": 702, "parent": 694, "lvl": 3, "name": "Оборудование для гальванических производств" }, {
        "id": 703,
        "parent": 694,
        "lvl": 3,
        "name": "Оборудование нефтепереработки"
    }, { "id": 704, "parent": 694, "lvl": 3, "name": "Оборудование газопереработки" }, {
        "id": 705,
        "parent": 694,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 706,
        "parent": [695, 696, 697, 698, 699, 700, 701, 702, 703, 704, 705],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 707, "parent": 706, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 708,
        "parent": 706,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 709,
        "parent": 706,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 710,
        "parent": 706,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 012 о безопасности оборудования при работе во взрывоопасных средах"
    }, {
        "id": 711,
        "parent": 706,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 012 о безопасности оборудования при работе во взрывоопасных средах"
    }, {
        "id": 712,
        "parent": 706,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 713,
        "parent": 706,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 714,
        "parent": 706,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 715,
        "parent": 706,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 716,
        "parent": 706,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 717,
        "parent": [695, 696, 697, 698, 699, 700, 701, 702, 703, 704, 705],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 718,
        "parent": 717,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 719,
        "parent": 717,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 720,
        "parent": 717,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 012 о безопасности оборудования при работе во взрывоопасных средах"
    }, {
        "id": 721,
        "parent": 717,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 012 о безопасности оборудования при работе во взрывоопасных средах"
    }, {
        "id": 722,
        "parent": 717,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 723,
        "parent": 717,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 724,
        "parent": 717,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 725,
        "parent": 717,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 726,
        "parent": [695, 696, 697, 698, 699, 700, 701, 702, 703, 704, 705],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 727, "parent": 726, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 728,
        "parent": 726,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 729,
        "parent": [695, 696, 697, 698, 699, 700, 701, 702, 703, 704, 705],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 730,
        "parent": 729,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 731,
        "parent": 729,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 732,
        "parent": 729,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 012 о безопасности оборудования при работе во взрывоопасных средах"
    }, {
        "id": 733,
        "parent": 729,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 012 о безопасности оборудования при работе во взрывоопасных средах"
    }, {
        "id": 734,
        "parent": 729,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 735,
        "parent": 729,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 736,
        "parent": 729,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 737,
        "parent": 729,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 738, "parent": 433, "lvl": 2, "name": "Оборудование для переработки полимерных материалов" }, {
        "id": 739,
        "parent": 738,
        "lvl": 3,
        "name": "Экструдеры"
    }, { "id": 740, "parent": 738, "lvl": 3, "name": "Экструзионные линии" }, {
        "id": 741,
        "parent": 738,
        "lvl": 3,
        "name": "Прессовое оборудование"
    }, { "id": 742, "parent": 738, "lvl": 3, "name": "Машины таблетирования" }, {
        "id": 743,
        "parent": 738,
        "lvl": 3,
        "name": "Валковые машины"
    }, { "id": 744, "parent": 738, "lvl": 3, "name": "Каландры" }, {
        "id": 745,
        "parent": 738,
        "lvl": 3,
        "name": "Дробилки"
    }, { "id": 746, "parent": 738, "lvl": 3, "name": "Грануляторы" }, {
        "id": 747,
        "parent": 738,
        "lvl": 3,
        "name": "Агломераторы"
    }, { "id": 748, "parent": 738, "lvl": 3, "name": "Другое оборудование" }, {
        "id": 749,
        "parent": [739, 740, 741, 742, 743, 744, 745, 746, 747, 748],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 750, "parent": 749, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 751,
        "parent": 749,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 752,
        "parent": 749,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 753,
        "parent": 749,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 754,
        "parent": 749,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 755,
        "parent": 749,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 756,
        "parent": [739, 740, 741, 742, 743, 744, 745, 746, 747, 748],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 757,
        "parent": 756,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 758,
        "parent": 756,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 759,
        "parent": 756,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 760,
        "parent": 756,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 761,
        "parent": [739, 740, 741, 742, 743, 744, 745, 746, 747, 748],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 762, "parent": 761, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 763,
        "parent": 761,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 764,
        "parent": [739, 740, 741, 742, 743, 744, 745, 746, 747, 748],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 765,
        "parent": 764,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 766,
        "parent": 764,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 767,
        "parent": 764,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 768,
        "parent": 764,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 769, "parent": 433, "lvl": 2, "name": "Оборудование насосное" }, {
        "id": 770,
        "parent": 769,
        "lvl": 3,
        "name": "Промышленное насосное оборудование"
    }, { "id": 771, "parent": 769, "lvl": 3, "name": "Бытовое насосное оборудование" }, {
        "id": 772,
        "parent": 769,
        "lvl": 3,
        "name": "Другое оборудование"
    }, { "id": 773, "parent": [770, 771, 772], "lvl": 4, "name": "Я - изготовитель" }, {
        "id": 774,
        "parent": 773,
        "lvl": 5,
        "name": "Технические условия (или ГОСТ при наличии)"
    }, {
        "id": 775,
        "parent": 773,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 776,
        "parent": 773,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 777,
        "parent": 773,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 778,
        "parent": 773,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 779,
        "parent": 773,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 780, "parent": [770, 771, 772], "lvl": 4, "name": "Я - импортер" }, {
        "id": 781,
        "parent": 780,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 782,
        "parent": 780,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 783,
        "parent": 780,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 784,
        "parent": 780,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 785, "parent": [770, 771, 772], "lvl": 4, "name": "Я - экспортер" }, {
        "id": 786,
        "parent": 785,
        "lvl": 5,
        "name": "Сертификат(-ы) происхождения продукции"
    }, {
        "id": 787,
        "parent": 785,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, { "id": 788, "parent": [770, 771, 772], "lvl": 4, "name": "Я - продавец" }, {
        "id": 789,
        "parent": 788,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 790,
        "parent": 788,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 791,
        "parent": 788,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 792,
        "parent": 788,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 793, "parent": 433, "lvl": 2, "name": "Оборудование холодильное, компрессорное" }, {
        "id": 794,
        "parent": 793,
        "lvl": 3,
        "name": "Аппараты шоковой заморозки"
    }, { "id": 795, "parent": 793, "lvl": 3, "name": "Витрины холодильные" }, {
        "id": 796,
        "parent": 793,
        "lvl": 3,
        "name": "Саладетты"
    }, { "id": 797, "parent": 793, "lvl": 3, "name": "Горки, лари" }, {
        "id": 798,
        "parent": 793,
        "lvl": 3,
        "name": "Салат-бары"
    }, { "id": 799, "parent": 793, "lvl": 3, "name": "Холодильные столы" }, {
        "id": 800,
        "parent": 793,
        "lvl": 3,
        "name": "Морозильные столы"
    }, { "id": 801, "parent": 793, "lvl": 3, "name": "Холодильные шкафы" }, {
        "id": 802,
        "parent": 793,
        "lvl": 3,
        "name": "Морозильные шкафы"
    }, { "id": 803, "parent": 793, "lvl": 3, "name": "Винтовые компрессоры" }, {
        "id": 804,
        "parent": 793,
        "lvl": 3,
        "name": "Поршневые компрессоры"
    }, { "id": 805, "parent": 793, "lvl": 3, "name": "Другое оборудование" }, {
        "id": 806,
        "parent": [794, 795, 796, 797, 798, 799, 800, 801, 802, 803, 804, 805],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 807, "parent": 806, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 808,
        "parent": 806,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 809,
        "parent": 806,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 810,
        "parent": 806,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 811,
        "parent": 806,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 812,
        "parent": 806,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 813,
        "parent": 806,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 814,
        "parent": 806,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 815,
        "parent": [794, 795, 796, 797, 798, 799, 800, 801, 802, 803, 804, 805],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 816,
        "parent": 815,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 817,
        "parent": 815,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 818,
        "parent": 815,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 819,
        "parent": 815,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 820,
        "parent": 815,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 821,
        "parent": 815,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 822,
        "parent": [794, 795, 796, 797, 798, 799, 800, 801, 802, 803, 804, 805],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 823, "parent": 822, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 824,
        "parent": 822,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 825,
        "parent": [794, 795, 796, 797, 798, 799, 800, 801, 802, 803, 804, 805],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 826,
        "parent": 825,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 827,
        "parent": 825,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 828,
        "parent": 825,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 829,
        "parent": 825,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 830,
        "parent": 825,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 831,
        "parent": 825,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 832,
        "parent": 433,
        "lvl": 2,
        "name": "Оборудование для газопламенной обработки металлов и металлизации изделий"
    }, { "id": 833, "parent": 832, "lvl": 3, "name": "Оборудование для кислородной резки" }, {
        "id": 834,
        "parent": 832,
        "lvl": 3,
        "name": "Газовые резаки"
    }, { "id": 835, "parent": 832, "lvl": 3, "name": "Газовые горелки" }, {
        "id": 836,
        "parent": 832,
        "lvl": 3,
        "name": "Оборудование для газофлюсовой сварки, пайки, наплавки"
    }, { "id": 837, "parent": 832, "lvl": 3, "name": "Аппараты термического напыления покрытий" }, {
        "id": 838,
        "parent": 832,
        "lvl": 3,
        "name": "Оборудование для электродуговой обработки"
    }, { "id": 839, "parent": 832, "lvl": 3, "name": "Оборудование для вакуумного напыления" }, {
        "id": 840,
        "parent": 832,
        "lvl": 3,
        "name": "Оборудование для плазменного напыления"
    }, { "id": 841, "parent": 832, "lvl": 3, "name": "Другое оборудование" }, {
        "id": 842,
        "parent": [833, 834, 835, 836, 837, 838, 839, 840, 841],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 843, "parent": 842, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 844,
        "parent": 842,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 845,
        "parent": 842,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 846,
        "parent": 842,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 847,
        "parent": 842,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 848,
        "parent": 842,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 849,
        "parent": [833, 834, 835, 836, 837, 838, 839, 840, 841],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 850,
        "parent": 849,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 851,
        "parent": 849,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 852,
        "parent": 849,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 853,
        "parent": 849,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 854,
        "parent": [833, 834, 835, 836, 837, 838, 839, 840, 841],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 855, "parent": 854, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 856,
        "parent": 854,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 857,
        "parent": [833, 834, 835, 836, 837, 838, 839, 840, 841],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 858,
        "parent": 857,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 859,
        "parent": 857,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 860,
        "parent": 857,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 861,
        "parent": 857,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 862, "parent": 433, "lvl": 2, "name": "Оборудование газоочистное и пылеулавливающее" }, {
        "id": 863,
        "parent": 862,
        "lvl": 3,
        "name": "Газоконверторы"
    }, { "id": 864, "parent": 862, "lvl": 3, "name": "Скрубберы вентури" }, {
        "id": 865,
        "parent": 862,
        "lvl": 3,
        "name": "Гидрофильтры"
    }, { "id": 866, "parent": 862, "lvl": 3, "name": "Электростатические фильтры" }, {
        "id": 867,
        "parent": 862,
        "lvl": 3,
        "name": "Дымофильтры для очистки от дыма"
    }, { "id": 868, "parent": 862, "lvl": 3, "name": "Рукавные фильтры" }, {
        "id": 869,
        "parent": 862,
        "lvl": 3,
        "name": "Пылеулавливающие агрегаты"
    }, { "id": 870, "parent": 862, "lvl": 3, "name": "Циклоны" }, {
        "id": 871,
        "parent": 862,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 872,
        "parent": [863, 864, 865, 866, 867, 868, 869, 870, 871],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 873, "parent": 872, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 874,
        "parent": 872,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 875,
        "parent": 872,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 876,
        "parent": 872,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 877,
        "parent": 872,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 878,
        "parent": 872,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 879,
        "parent": [863, 864, 865, 866, 867, 868, 869, 870, 871],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 880,
        "parent": 879,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 881,
        "parent": 879,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 882,
        "parent": 879,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 883,
        "parent": 879,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 884,
        "parent": [863, 864, 865, 866, 867, 868, 869, 870, 871],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 885, "parent": 884, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 886,
        "parent": 884,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 887,
        "parent": [863, 864, 865, 866, 867, 868, 869, 870, 871],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 888,
        "parent": 887,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 889,
        "parent": 887,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 890,
        "parent": 887,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 891,
        "parent": 887,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 892,
        "parent": 433,
        "lvl": 2,
        "name": "Оборудование целлюлозно-бумажное и бумагоделательное"
    }, {
        "id": 893,
        "parent": 892,
        "lvl": 3,
        "name": "Оборудование для окорки древесины"
    }, { "id": 894, "parent": 892, "lvl": 3, "name": "Оборудование для измельчения древесины в щепу" }, {
        "id": 895,
        "parent": 892,
        "lvl": 3,
        "name": "Оборудование для сортирования щепы"
    }, { "id": 896, "parent": 892, "lvl": 3, "name": "Дефибреры" }, {
        "id": 897,
        "parent": 892,
        "lvl": 3,
        "name": "Оборудование отбельных цехов"
    }, { "id": 898, "parent": 892, "lvl": 3, "name": "Бумагоделательные машины" }, {
        "id": 899,
        "parent": 892,
        "lvl": 3,
        "name": "Картоноделательные машины"
    }, { "id": 900, "parent": 892, "lvl": 3, "name": "Другое оборудование" }, {
        "id": 901,
        "parent": [893, 894, 895, 896, 897, 898, 899, 900],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 902, "parent": 901, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 903,
        "parent": 901,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 904,
        "parent": 901,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 905,
        "parent": 901,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 906,
        "parent": 901,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 907,
        "parent": 901,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 908, "parent": [893, 894, 895, 896, 897, 898, 899, 900], "lvl": 4, "name": "Я - импортер" }, {
        "id": 909,
        "parent": 908,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 910,
        "parent": 908,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 911,
        "parent": 908,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 912,
        "parent": 908,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 913, "parent": [893, 894, 895, 896, 897, 898, 899, 900], "lvl": 4, "name": "Я - экспортер" }, {
        "id": 914,
        "parent": 913,
        "lvl": 5,
        "name": "Сертификат(-ы) происхождения продукции"
    }, {
        "id": 915,
        "parent": 913,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, { "id": 916, "parent": [893, 894, 895, 896, 897, 898, 899, 900], "lvl": 4, "name": "Я - продавец" }, {
        "id": 917,
        "parent": 916,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 918,
        "parent": 916,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 919,
        "parent": 916,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 920,
        "parent": 916,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 921,
        "parent": 433,
        "lvl": 2,
        "name": "Оборудование нефтепромысловое, буровое геолого-разведочное"
    }, { "id": 922, "parent": 921, "lvl": 3, "name": "Мобильная буровая установка" }, {
        "id": 923,
        "parent": 921,
        "lvl": 3,
        "name": "Установка бурильно-шнековая"
    }, { "id": 924, "parent": 921, "lvl": 3, "name": "Платформа для буровой установки" }, {
        "id": 925,
        "parent": 921,
        "lvl": 3,
        "name": "Самоходный буровой агрегат"
    }, { "id": 926, "parent": 921, "lvl": 3, "name": "Установка прокола грунта" }, {
        "id": 927,
        "parent": 921,
        "lvl": 3,
        "name": "Установка разведочного бурения"
    }, { "id": 928, "parent": 921, "lvl": 3, "name": "Лебедка буровая" }, {
        "id": 929,
        "parent": 921,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 930,
        "parent": [922, 923, 924, 925, 926, 927, 928, 929],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 931, "parent": 930, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 932,
        "parent": 930,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 933,
        "parent": 930,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 934,
        "parent": 930,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 935,
        "parent": 930,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 936,
        "parent": 930,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 937, "parent": [922, 923, 924, 925, 926, 927, 928, 929], "lvl": 4, "name": "Я - импортер" }, {
        "id": 938,
        "parent": 937,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 939,
        "parent": 937,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 940,
        "parent": 937,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 941,
        "parent": 937,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 942, "parent": [922, 923, 924, 925, 926, 927, 928, 929], "lvl": 4, "name": "Я - экспортер" }, {
        "id": 943,
        "parent": 942,
        "lvl": 5,
        "name": "Сертификат(-ы) происхождения продукции"
    }, {
        "id": 944,
        "parent": 942,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, { "id": 945, "parent": [922, 923, 924, 925, 926, 927, 928, 929], "lvl": 4, "name": "Я - продавец" }, {
        "id": 946,
        "parent": 945,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 947,
        "parent": 945,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 948,
        "parent": 945,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 949,
        "parent": 945,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 950,
        "parent": 433,
        "lvl": 2,
        "name": "Оборудование технологическое и аппаратура для нанесения лакокрасочных покрытий"
    }, { "id": 951, "parent": 950, "lvl": 3, "name": "Окрасочные камеры" }, {
        "id": 952,
        "parent": 950,
        "lvl": 3,
        "name": "Аппараты для ручного нанесения"
    }, { "id": 953, "parent": 950, "lvl": 3, "name": "Аппараты для полуавтоматического нанесения" }, {
        "id": 954,
        "parent": 950,
        "lvl": 3,
        "name": "Лаконаливные станки"
    }, { "id": 955, "parent": 950, "lvl": 3, "name": "Станки для окраски погонажных изделий" }, {
        "id": 956,
        "parent": 950,
        "lvl": 3,
        "name": "Станки для окраски плитных материалов"
    }, { "id": 957, "parent": 950, "lvl": 3, "name": "Сборники лакокрасочных отходов" }, {
        "id": 958,
        "parent": 950,
        "lvl": 3,
        "name": "Дисольверы"
    }, { "id": 959, "parent": 950, "lvl": 3, "name": "Мельницы" }, {
        "id": 960,
        "parent": 950,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 961,
        "parent": [951, 952, 953, 954, 955, 956, 957, 958, 959, 960],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 962, "parent": 961, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 963,
        "parent": 961,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 964,
        "parent": 961,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 965,
        "parent": 961,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 966,
        "parent": 961,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 967,
        "parent": 961,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 968,
        "parent": [951, 952, 953, 954, 955, 956, 957, 958, 959, 960],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 969,
        "parent": 968,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 970,
        "parent": 968,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 971,
        "parent": 968,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 972,
        "parent": 968,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 973,
        "parent": [951, 952, 953, 954, 955, 956, 957, 958, 959, 960],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 974, "parent": 973, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 975,
        "parent": 973,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 976,
        "parent": [951, 952, 953, 954, 955, 956, 957, 958, 959, 960],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 977,
        "parent": 976,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 978,
        "parent": 976,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 979,
        "parent": 976,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 980,
        "parent": 976,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 981,
        "parent": 433,
        "lvl": 2,
        "name": "Оборудование для подготовки и очистки питьевой воды"
    }, {
        "id": 982,
        "parent": 981,
        "lvl": 3,
        "name": "Водоочистные установки"
    }, { "id": 983, "parent": 981, "lvl": 3, "name": "Установки для аэрации" }, {
        "id": 984,
        "parent": 981,
        "lvl": 3,
        "name": "Установки для осветления и сорбции"
    }, { "id": 985, "parent": 981, "lvl": 3, "name": "Установки для умягчения и ионного обмена" }, {
        "id": 986,
        "parent": 981,
        "lvl": 3,
        "name": "Установки для обессоливания"
    }, { "id": 987, "parent": 981, "lvl": 3, "name": "Установки для УФ-обеззараживания" }, {
        "id": 988,
        "parent": 981,
        "lvl": 3,
        "name": "Установки обратного осмоса"
    }, { "id": 989, "parent": 981, "lvl": 3, "name": "Водоочистные установки в блок-контейнерах" }, {
        "id": 990,
        "parent": 981,
        "lvl": 3,
        "name": "Фильтры"
    }, { "id": 991, "parent": 981, "lvl": 3, "name": "Аэрационные колонны" }, {
        "id": 992,
        "parent": 981,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 993,
        "parent": [982, 983, 984, 985, 986, 987, 988, 989, 990, 991, 992],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 994, "parent": 993, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 995,
        "parent": 993,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации"
    }, {
        "id": 996,
        "parent": 993,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 997,
        "parent": 993,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 998,
        "parent": 993,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 999,
        "parent": 993,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1000,
        "parent": 993,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1001,
        "parent": [982, 983, 984, 985, 986, 987, 988, 989, 990, 991, 992],
        "lvl": 4,
        "name": "Я - импортер"
    }, { "id": 1002, "parent": 1001, "lvl": 5, "name": "Свидетельство(-а) о государственной регистрации" }, {
        "id": 1003,
        "parent": 1001,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1004,
        "parent": 1001,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1005,
        "parent": 1001,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1006,
        "parent": 1001,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1007,
        "parent": [982, 983, 984, 985, 986, 987, 988, 989, 990, 991, 992],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1008, "parent": 1007, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1009,
        "parent": 1007,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1010,
        "parent": [982, 983, 984, 985, 986, 987, 988, 989, 990, 991, 992],
        "lvl": 4,
        "name": "Я - продавец"
    }, { "id": 1011, "parent": 1010, "lvl": 5, "name": "Копии свидетельств о государственной регистрации" }, {
        "id": 1012,
        "parent": 1010,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1013,
        "parent": 1010,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1014,
        "parent": 1010,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1015,
        "parent": 1010,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1016, "parent": 433, "lvl": 2, "name": "Оборудование металлообрабатывающее" }, {
        "id": 1017,
        "parent": 1016,
        "lvl": 3,
        "name": "Токарные станки"
    }, { "id": 1018, "parent": 1016, "lvl": 3, "name": "Кромкообрезные станки" }, {
        "id": 1019,
        "parent": 1016,
        "lvl": 3,
        "name": "Многопильные станки"
    }, { "id": 1020, "parent": 1016, "lvl": 3, "name": "Фрезерные станки" }, {
        "id": 1021,
        "parent": 1016,
        "lvl": 3,
        "name": "Форматно-раскроечные станки"
    }, { "id": 1022, "parent": 1016, "lvl": 3, "name": "Прессы" }, {
        "id": 1023,
        "parent": 1016,
        "lvl": 3,
        "name": "Зачистные станки"
    }, { "id": 1024, "parent": 1016, "lvl": 3, "name": "Станки плазменной резки" }, {
        "id": 1025,
        "parent": 1016,
        "lvl": 3,
        "name": "Станки-ножницы"
    }, { "id": 1026, "parent": 1016, "lvl": 3, "name": "Другое оборудование" }, {
        "id": 1027,
        "parent": [1017, 1018, 1019, 1020, 1021, 1022, 1023, 1024, 1025, 1026],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1028, "parent": 1027, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1029,
        "parent": 1027,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1030,
        "parent": 1027,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1031,
        "parent": 1027,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1032,
        "parent": 1027,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1033,
        "parent": 1027,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1034,
        "parent": [1017, 1018, 1019, 1020, 1021, 1022, 1023, 1024, 1025, 1026],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1035,
        "parent": 1034,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1036,
        "parent": 1034,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1037,
        "parent": 1034,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1038,
        "parent": 1034,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1039,
        "parent": [1017, 1018, 1019, 1020, 1021, 1022, 1023, 1024, 1025, 1026],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1040, "parent": 1039, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1041,
        "parent": 1039,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1042,
        "parent": [1017, 1018, 1019, 1020, 1021, 1022, 1023, 1024, 1025, 1026],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1043,
        "parent": 1042,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1044,
        "parent": 1042,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1045,
        "parent": 1042,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1046,
        "parent": 1042,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1047, "parent": 433, "lvl": 2, "name": "Оборудование кузнечно-прессовое" }, {
        "id": 1048,
        "parent": 1047,
        "lvl": 3,
        "name": "Прессы кривошипные"
    }, { "id": 1049, "parent": 1047, "lvl": 3, "name": "Вертикальные гидравлические прессы" }, {
        "id": 1050,
        "parent": 1047,
        "lvl": 3,
        "name": "Прессы гидравлические горизонтальные"
    }, { "id": 1051, "parent": 1047, "lvl": 3, "name": "Пресс-ножницы" }, {
        "id": 1052,
        "parent": 1047,
        "lvl": 3,
        "name": "Молоты паровоздушные кованые"
    }, { "id": 1053, "parent": 1047, "lvl": 3, "name": "Прессы дугостатные" }, {
        "id": 1054,
        "parent": 1047,
        "lvl": 3,
        "name": "Прессы для пакетирования"
    }, { "id": 1055, "parent": 1047, "lvl": 3, "name": "Другое оборудование" }, {
        "id": 1056,
        "parent": [1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1057, "parent": 1056, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1058,
        "parent": 1056,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1059,
        "parent": 1056,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1060,
        "parent": 1056,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1061,
        "parent": 1056,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1062,
        "parent": 1056,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1063,
        "parent": [1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1064,
        "parent": 1063,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1065,
        "parent": 1063,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1066,
        "parent": 1063,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1067,
        "parent": 1063,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1068,
        "parent": [1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1069, "parent": 1068, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1070,
        "parent": 1068,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1071,
        "parent": [1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1072,
        "parent": 1071,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1073,
        "parent": 1071,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1074,
        "parent": 1071,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1075,
        "parent": 1071,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1076,
        "parent": 433,
        "lvl": 2,
        "name": "Оборудование технологическое для литейного производства"
    }, { "id": 1077, "parent": 1076, "lvl": 3, "name": "Смесеприготовительное оборудование" }, {
        "id": 1078,
        "parent": 1076,
        "lvl": 3,
        "name": "Вибростолы"
    }, { "id": 1079, "parent": 1076, "lvl": 3, "name": "Формовочное оборудование" }, {
        "id": 1080,
        "parent": 1076,
        "lvl": 3,
        "name": "Стержневое оборудование"
    }, { "id": 1081, "parent": 1076, "lvl": 3, "name": "Дуговые печи постоянного тока" }, {
        "id": 1082,
        "parent": 1076,
        "lvl": 3,
        "name": "Дозаторы и заливочное оборудование"
    }, {
        "id": 1083,
        "parent": 1076,
        "lvl": 3,
        "name": "Установка для дегазации (рафинирования) алюминиевых расплавов"
    }, { "id": 1084, "parent": 1076, "lvl": 3, "name": "Установка гравитационного литья" }, {
        "id": 1085,
        "parent": 1076,
        "lvl": 3,
        "name": "Оборудование для пропитки отливок"
    }, { "id": 1086, "parent": 1076, "lvl": 3, "name": "Оборудование для литья по выплавляемым моделям" }, {
        "id": 1087,
        "parent": 1076,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 1088,
        "parent": [1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1089, "parent": 1088, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1090,
        "parent": 1088,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1091,
        "parent": 1088,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1092,
        "parent": 1088,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1093,
        "parent": 1088,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1094,
        "parent": 1088,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1095,
        "parent": [1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1096,
        "parent": 1095,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1097,
        "parent": 1095,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1098,
        "parent": 1095,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1099,
        "parent": 1095,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1100,
        "parent": [1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1101, "parent": 1100, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1102,
        "parent": 1100,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1103,
        "parent": [1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1104,
        "parent": 1103,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1105,
        "parent": 1103,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1106,
        "parent": 1103,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1107,
        "parent": 1103,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1108,
        "parent": 433,
        "lvl": 2,
        "name": "Оборудование для сварки и газотермического напыления"
    }, { "id": 1109, "parent": 1108, "lvl": 3, "name": "Аргонодуговые установки" }, {
        "id": 1110,
        "parent": 1108,
        "lvl": 3,
        "name": "Инвертор сварочный"
    }, { "id": 1111, "parent": 1108, "lvl": 3, "name": "Оборудование для контактной точечной сварки" }, {
        "id": 1112,
        "parent": 1108,
        "lvl": 3,
        "name": "Оборудование для микросварки"
    }, { "id": 1113, "parent": 1108, "lvl": 3, "name": "Оборудование для ударно-конденсаторной сварки" }, {
        "id": 1114,
        "parent": 1108,
        "lvl": 3,
        "name": "Оборудование для воздушно-пламенной резки"
    }, { "id": 1115, "parent": 1108, "lvl": 3, "name": "Оборудование для координатной сварки" }, {
        "id": 1116,
        "parent": 1108,
        "lvl": 3,
        "name": "Оборудование газотермического напыления"
    }, { "id": 1117, "parent": 1108, "lvl": 3, "name": "Другое оборудование" }, {
        "id": 1118,
        "parent": [1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1119, "parent": 1118, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1120,
        "parent": 1118,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1121,
        "parent": 1118,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1122,
        "parent": 1118,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1123,
        "parent": 1118,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1124,
        "parent": 1118,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1125,
        "parent": [1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1126,
        "parent": 1125,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1127,
        "parent": 1125,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1128,
        "parent": 1125,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1129,
        "parent": 1125,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1130,
        "parent": [1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1131, "parent": 1130, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1132,
        "parent": 1130,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1133,
        "parent": [1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1134,
        "parent": 1133,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1135,
        "parent": 1133,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1136,
        "parent": 1133,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1137,
        "parent": 1133,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1138,
        "parent": 433,
        "lvl": 2,
        "name": "Оборудование дорожное, оборудование для приготовления строительных смесей"
    }, { "id": 1139, "parent": 1138, "lvl": 3, "name": "Асфальтоукладчики" }, {
        "id": 1140,
        "parent": 1138,
        "lvl": 3,
        "name": "Виброплиты"
    }, { "id": 1141, "parent": 1138, "lvl": 3, "name": "Вибротрамбовки" }, {
        "id": 1142,
        "parent": 1138,
        "lvl": 3,
        "name": "Дорожные катки"
    }, { "id": 1143, "parent": 1138, "lvl": 3, "name": "Дорожные фрезы" }, {
        "id": 1144,
        "parent": 1138,
        "lvl": 3,
        "name": "Смесители"
    }, { "id": 1145, "parent": 1138, "lvl": 3, "name": "Сушилки" }, {
        "id": 1146,
        "parent": 1138,
        "lvl": 3,
        "name": "Элеваторы"
    }, { "id": 1147, "parent": 1138, "lvl": 3, "name": "Вибросито" }, {
        "id": 1148,
        "parent": 1138,
        "lvl": 3,
        "name": "Дозаторы"
    }, { "id": 1149, "parent": 1138, "lvl": 3, "name": "Фасовочные машины" }, {
        "id": 1150,
        "parent": 1138,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 1151,
        "parent": [1139, 1140, 1141, 1142, 1143, 1144, 1145, 1146, 1147, 1148, 1149, 1150],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1152, "parent": 1151, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1153,
        "parent": 1151,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1154,
        "parent": 1151,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1155,
        "parent": 1151,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1156,
        "parent": 1151,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1157,
        "parent": 1151,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1158,
        "parent": [1139, 1140, 1141, 1142, 1143, 1144, 1145, 1146, 1147, 1148, 1149, 1150],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1159,
        "parent": 1158,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1160,
        "parent": 1158,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1161,
        "parent": 1158,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1162,
        "parent": 1158,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1163,
        "parent": [1139, 1140, 1141, 1142, 1143, 1144, 1145, 1146, 1147, 1148, 1149, 1150],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1164, "parent": 1163, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1165,
        "parent": 1163,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1166,
        "parent": [1139, 1140, 1141, 1142, 1143, 1144, 1145, 1146, 1147, 1148, 1149, 1150],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1167,
        "parent": 1166,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1168,
        "parent": 1166,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1169,
        "parent": 1166,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1170,
        "parent": 1166,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1171, "parent": 433, "lvl": 2, "name": "Оборудование и машины строительные" }, {
        "id": 1172,
        "parent": 1171,
        "lvl": 3,
        "name": "Оборудование для бетонных работ"
    }, { "id": 1173, "parent": 1171, "lvl": 3, "name": "Вибротехника" }, {
        "id": 1174,
        "parent": 1171,
        "lvl": 3,
        "name": "Вышки подъемные"
    }, { "id": 1175, "parent": 1171, "lvl": 3, "name": "Оборудование для устройства пола" }, {
        "id": 1176,
        "parent": 1171,
        "lvl": 3,
        "name": "Сварочное оборудование"
    }, { "id": 1177, "parent": 1171, "lvl": 3, "name": "Малярное оборудование" }, {
        "id": 1178,
        "parent": 1171,
        "lvl": 3,
        "name": "Дорожно-строительная техника"
    }, { "id": 1179, "parent": 1171, "lvl": 3, "name": "Резчики" }, {
        "id": 1180,
        "parent": 1171,
        "lvl": 3,
        "name": "Краны строительные"
    }, { "id": 1181, "parent": 1171, "lvl": 3, "name": "Станки для арматуры" }, {
        "id": 1182,
        "parent": 1171,
        "lvl": 3,
        "name": "Траншеекопатели"
    }, { "id": 1183, "parent": 1171, "lvl": 3, "name": "Пневмопробойники" }, {
        "id": 1184,
        "parent": 1171,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 1185,
        "parent": [1172, 1173, 1174, 1175, 1176, 1177, 1178, 1179, 1180, 1181, 1182, 1183, 1184],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1186, "parent": 1185, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1187,
        "parent": 1185,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1188,
        "parent": 1185,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1189,
        "parent": 1185,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1190,
        "parent": 1185,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1191,
        "parent": 1185,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1192,
        "parent": [1172, 1173, 1174, 1175, 1176, 1177, 1178, 1179, 1180, 1181, 1182, 1183, 1184],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1193,
        "parent": 1192,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1194,
        "parent": 1192,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1195,
        "parent": 1192,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1196,
        "parent": 1192,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1197,
        "parent": [1172, 1173, 1174, 1175, 1176, 1177, 1178, 1179, 1180, 1181, 1182, 1183, 1184],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1198, "parent": 1197, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1199,
        "parent": 1197,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1200,
        "parent": [1172, 1173, 1174, 1175, 1176, 1177, 1178, 1179, 1180, 1181, 1182, 1183, 1184],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1201,
        "parent": 1200,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1202,
        "parent": 1200,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1203,
        "parent": 1200,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1204,
        "parent": 1200,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1205,
        "parent": 433,
        "lvl": 2,
        "name": "Оборудование для промышленности строительных материалов"
    }, {
        "id": 1206,
        "parent": 1205,
        "lvl": 3,
        "name": "Оборудование для производства изделий из бетона, глины"
    }, { "id": 1207, "parent": 1205, "lvl": 3, "name": "Кузнечно-прессовое оборудование" }, {
        "id": 1208,
        "parent": 1205,
        "lvl": 3,
        "name": "Оборудование для обработки пластика и резины"
    }, { "id": 1209, "parent": 1205, "lvl": 3, "name": "Оборудование для производства и прокладки кабеля" }, {
        "id": 1210,
        "parent": 1205,
        "lvl": 3,
        "name": "Оборудование для производства профилей, профнастила"
    }, { "id": 1211, "parent": 1205, "lvl": 3, "name": "Оборудование для производства сэндвич-панелей" }, {
        "id": 1212,
        "parent": 1205,
        "lvl": 3,
        "name": "Асфальтосмесительные установки"
    }, { "id": 1213, "parent": 1205, "lvl": 3, "name": "Оборудование для обработки камня" }, {
        "id": 1214,
        "parent": 1205,
        "lvl": 3,
        "name": "Оборудование для производства строительных смесей"
    }, {
        "id": 1215,
        "parent": 1205,
        "lvl": 3,
        "name": "Оборудование для производства стеклопластиковых продуктов"
    }, { "id": 1216, "parent": 1205, "lvl": 3, "name": "Другое оборудование" }, {
        "id": 1217,
        "parent": [1206, 1207, 1208, 1209, 1210, 1211, 1212, 1213, 1214, 1215, 1216],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1218, "parent": 1217, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1219,
        "parent": 1217,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1220,
        "parent": 1217,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1221,
        "parent": 1217,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1222,
        "parent": 1217,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1223,
        "parent": 1217,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1224,
        "parent": [1206, 1207, 1208, 1209, 1210, 1211, 1212, 1213, 1214, 1215, 1216],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1225,
        "parent": 1224,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1226,
        "parent": 1224,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1227,
        "parent": 1224,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1228,
        "parent": 1224,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1229,
        "parent": [1206, 1207, 1208, 1209, 1210, 1211, 1212, 1213, 1214, 1215, 1216],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1230, "parent": 1229, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1231,
        "parent": 1229,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1232,
        "parent": [1206, 1207, 1208, 1209, 1210, 1211, 1212, 1213, 1214, 1215, 1216],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1233,
        "parent": 1232,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1234,
        "parent": 1232,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1235,
        "parent": 1232,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1236,
        "parent": 1232,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1237,
        "parent": 433,
        "lvl": 2,
        "name": "Оборудование прачечное промышленное и для химчисток"
    }, { "id": 1238, "parent": 1237, "lvl": 3, "name": "Машины стиральные" }, {
        "id": 1239,
        "parent": 1237,
        "lvl": 3,
        "name": "Машины стирально-отжимные"
    }, { "id": 1240, "parent": 1237, "lvl": 3, "name": "Центрифуги" }, {
        "id": 1241,
        "parent": 1237,
        "lvl": 3,
        "name": "Машины сушильные"
    }, { "id": 1242, "parent": 1237, "lvl": 3, "name": "Катки гладильные" }, {
        "id": 1243,
        "parent": 1237,
        "lvl": 3,
        "name": "Каландры гладильные"
    }, { "id": 1244, "parent": 1237, "lvl": 3, "name": "Упаковочное оборудование" }, {
        "id": 1245,
        "parent": 1237,
        "lvl": 3,
        "name": "Пятновыводное оборудование"
    }, { "id": 1246, "parent": 1237, "lvl": 3, "name": "Пароманекены" }, {
        "id": 1247,
        "parent": 1237,
        "lvl": 3,
        "name": "Парогенераторы"
    }, { "id": 1248, "parent": 1237, "lvl": 3, "name": "Другое оборудование" }, {
        "id": 1249,
        "parent": [1238, 1239, 1240, 1241, 1242, 1243, 1244, 1245, 1246, 1247, 1248],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1250, "parent": 1249, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1251,
        "parent": 1249,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1252,
        "parent": 1249,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1253,
        "parent": 1249,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1254,
        "parent": 1249,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1255,
        "parent": 1249,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1256,
        "parent": [1238, 1239, 1240, 1241, 1242, 1243, 1244, 1245, 1246, 1247, 1248],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1257,
        "parent": 1256,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1258,
        "parent": 1256,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1259,
        "parent": 1256,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1260,
        "parent": 1256,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1261,
        "parent": [1238, 1239, 1240, 1241, 1242, 1243, 1244, 1245, 1246, 1247, 1248],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1262, "parent": 1261, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1263,
        "parent": 1261,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1264,
        "parent": [1238, 1239, 1240, 1241, 1242, 1243, 1244, 1245, 1246, 1247, 1248],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1265,
        "parent": 1264,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1266,
        "parent": 1264,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1267,
        "parent": 1264,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1268,
        "parent": 1264,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1269, "parent": 433, "lvl": 2, "name": "Оборудование для коммунального хозяйства" }, {
        "id": 1270,
        "parent": 1269,
        "lvl": 3,
        "name": "Оборудование для водопроводно-канализационного хозяйства"
    }, { "id": 1271, "parent": 1269, "lvl": 3, "name": "Оборудование для коммунального газоснабжения" }, {
        "id": 1272,
        "parent": 1269,
        "lvl": 3,
        "name": "Оборудование по защите подземных городских сооружений от коррозии"
    }, {
        "id": 1273,
        "parent": 1269,
        "lvl": 3,
        "name": "Оборудование для эксплуатации коммунальных распределительных электросетей и систем теплоснабжения"
    }, { "id": 1274, "parent": 1269, "lvl": 3, "name": "Оборудование для ремонта и эксплуатации зданий" }, {
        "id": 1275,
        "parent": 1269,
        "lvl": 3,
        "name": "Другое оборудование"
    }, { "id": 1276, "parent": [1270, 1271, 1272, 1273, 1274, 1275], "lvl": 4, "name": "Я - изготовитель" }, {
        "id": 1277,
        "parent": 1276,
        "lvl": 5,
        "name": "Технические условия (или ГОСТ при наличии)"
    }, { "id": 1278, "parent": 1276, "lvl": 5, "name": "Свидетельство(-а) о государственной регистрации" }, {
        "id": 1279,
        "parent": 1276,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1280,
        "parent": 1276,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1281,
        "parent": 1276,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1282,
        "parent": 1276,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1283,
        "parent": 1276,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1284, "parent": [1270, 1271, 1272, 1273, 1274, 1275], "lvl": 4, "name": "Я - импортер" }, {
        "id": 1285,
        "parent": 1284,
        "lvl": 5,
        "name": "Свидетельство(-а) о государственной регистрации"
    }, {
        "id": 1286,
        "parent": 1284,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1287,
        "parent": 1284,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1288,
        "parent": 1284,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1289,
        "parent": 1284,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1290, "parent": [1270, 1271, 1272, 1273, 1274, 1275], "lvl": 4, "name": "Я - экспортер" }, {
        "id": 1291,
        "parent": 1290,
        "lvl": 5,
        "name": "Сертификат(-ы) происхождения продукции"
    }, {
        "id": 1292,
        "parent": 1290,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, { "id": 1293, "parent": [1270, 1271, 1272, 1273, 1274, 1275], "lvl": 4, "name": "Я - продавец" }, {
        "id": 1294,
        "parent": 1293,
        "lvl": 5,
        "name": "Копии свидетельств о государственной регистрации"
    }, {
        "id": 1295,
        "parent": 1293,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1296,
        "parent": 1293,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1297,
        "parent": 1293,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1298,
        "parent": 1293,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1299,
        "parent": 433,
        "lvl": 2,
        "name": "Оборудование технологическое для легкой промышленности"
    }, { "id": 1300, "parent": 1299, "lvl": 3, "name": "Вышивальное оборудование" }, {
        "id": 1301,
        "parent": 1299,
        "lvl": 3,
        "name": "Вязальное и трикотажное оборудование"
    }, {
        "id": 1302,
        "parent": 1299,
        "lvl": 3,
        "name": "Лазерные машины для раскроя, резки и гравировки материалов"
    }, { "id": 1303, "parent": 1299, "lvl": 3, "name": "Мерильно-браковочные машины" }, {
        "id": 1304,
        "parent": 1299,
        "lvl": 3,
        "name": "Оборудование для мехового и кожевенного производства"
    }, {
        "id": 1305,
        "parent": 1299,
        "lvl": 3,
        "name": "Оборудование для нетканых материалов и химических волокон"
    }, { "id": 1306, "parent": 1299, "lvl": 3, "name": "Обордование для обувного производства" }, {
        "id": 1307,
        "parent": 1299,
        "lvl": 3,
        "name": "Стегальное оборудование"
    }, { "id": 1308, "parent": 1299, "lvl": 3, "name": "Ткацкое, прядильное и отделочное оборудование" }, {
        "id": 1309,
        "parent": 1299,
        "lvl": 3,
        "name": "Швейное оборудование"
    }, { "id": 1310, "parent": 1299, "lvl": 3, "name": "Другое оборудование" }, {
        "id": 1311,
        "parent": [1300, 1301, 1302, 1303, 1304, 1305, 1306, 1307, 1308, 1309, 1310],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1312, "parent": 1311, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1313,
        "parent": 1311,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1314,
        "parent": 1311,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1315,
        "parent": 1311,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1316,
        "parent": 1311,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1317,
        "parent": 1311,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1318,
        "parent": [1300, 1301, 1302, 1303, 1304, 1305, 1306, 1307, 1308, 1309, 1310],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1319,
        "parent": 1318,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1320,
        "parent": 1318,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1321,
        "parent": 1318,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1322,
        "parent": 1318,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1323,
        "parent": [1300, 1301, 1302, 1303, 1304, 1305, 1306, 1307, 1308, 1309, 1310],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1324, "parent": 1323, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1325,
        "parent": 1323,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1326,
        "parent": [1300, 1301, 1302, 1303, 1304, 1305, 1306, 1307, 1308, 1309, 1310],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1327,
        "parent": 1326,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1328,
        "parent": 1326,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1329,
        "parent": 1326,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1330,
        "parent": 1326,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1331, "parent": 433, "lvl": 2, "name": "Оборудование для систем кондиционирования" }, {
        "id": 1332,
        "parent": 1331,
        "lvl": 3,
        "name": "Настенные кондиционеры"
    }, { "id": 1333, "parent": 1331, "lvl": 3, "name": "Напольные кондиционеры" }, {
        "id": 1334,
        "parent": 1331,
        "lvl": 3,
        "name": "Кассетные кондиционеры"
    }, { "id": 1335, "parent": 1331, "lvl": 3, "name": "Канальные кондиционеры" }, {
        "id": 1336,
        "parent": 1331,
        "lvl": 3,
        "name": "Мультисистемы"
    }, { "id": 1337, "parent": 1331, "lvl": 3, "name": "Сплит системы" }, {
        "id": 1338,
        "parent": 1331,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 1339,
        "parent": [1332, 1333, 1334, 1335, 1336, 1337, 1338],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1340, "parent": 1339, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1341,
        "parent": 1339,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1342,
        "parent": 1339,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1343,
        "parent": 1339,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1344,
        "parent": 1339,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1345,
        "parent": 1339,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1346,
        "parent": [1332, 1333, 1334, 1335, 1336, 1337, 1338],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1347,
        "parent": 1346,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1348,
        "parent": 1346,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1349,
        "parent": 1346,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1350,
        "parent": 1346,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1351,
        "parent": [1332, 1333, 1334, 1335, 1336, 1337, 1338],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1352, "parent": 1351, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1353,
        "parent": 1351,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1354,
        "parent": [1332, 1333, 1334, 1335, 1336, 1337, 1338],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1355,
        "parent": 1354,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1356,
        "parent": 1354,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1357,
        "parent": 1354,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1358,
        "parent": 1354,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1359,
        "parent": 433,
        "lvl": 2,
        "name": "Оборудование технологическое для пищевой, мясомолочной и рыбной промышленности"
    }, { "id": 1360, "parent": 1359, "lvl": 3, "name": "Тестомесы" }, {
        "id": 1361,
        "parent": 1359,
        "lvl": 3,
        "name": "Миксеры"
    }, { "id": 1362, "parent": 1359, "lvl": 3, "name": "Куттеры" }, {
        "id": 1363,
        "parent": 1359,
        "lvl": 3,
        "name": "Мясорубки"
    }, { "id": 1364, "parent": 1359, "lvl": 3, "name": "Тендерайзеры" }, {
        "id": 1365,
        "parent": 1359,
        "lvl": 3,
        "name": "Картофелечистки"
    }, { "id": 1366, "parent": 1359, "lvl": 3, "name": "Протирочнорезательные машины" }, {
        "id": 1367,
        "parent": 1359,
        "lvl": 3,
        "name": "Слайсеры"
    }, { "id": 1368, "parent": 1359, "lvl": 3, "name": "Сыротерки" }, {
        "id": 1369,
        "parent": 1359,
        "lvl": 3,
        "name": "Пилы для мяса"
    }, { "id": 1370, "parent": 1359, "lvl": 3, "name": "Шприц колбасный" }, {
        "id": 1371,
        "parent": 1359,
        "lvl": 3,
        "name": "Оборудование для пельменей"
    }, { "id": 1372, "parent": 1359, "lvl": 3, "name": "Оборудование для удаления чешую" }, {
        "id": 1373,
        "parent": 1359,
        "lvl": 3,
        "name": "Оборудование для головоотрезания"
    }, { "id": 1374, "parent": 1359, "lvl": 3, "name": "Оборудование для потрошения" }, {
        "id": 1375,
        "parent": 1359,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 1376,
        "parent": [1360, 1361, 1362, 1363, 1364, 1365, 1366, 1367, 1368, 1369, 1370, 1371, 1372, 1373, 1374, 1375],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1377, "parent": 1376, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1378,
        "parent": 1376,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1379,
        "parent": 1376,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1380,
        "parent": 1376,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1381,
        "parent": 1376,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1382,
        "parent": 1376,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1383,
        "parent": [1360, 1361, 1362, 1363, 1364, 1365, 1366, 1367, 1368, 1369, 1370, 1371, 1372, 1373, 1374, 1375],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1384,
        "parent": 1383,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1385,
        "parent": 1383,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1386,
        "parent": 1383,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1387,
        "parent": 1383,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1388,
        "parent": [1360, 1361, 1362, 1363, 1364, 1365, 1366, 1367, 1368, 1369, 1370, 1371, 1372, 1373, 1374, 1375],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1389, "parent": 1388, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1390,
        "parent": 1388,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1391,
        "parent": [1360, 1361, 1362, 1363, 1364, 1365, 1366, 1367, 1368, 1369, 1370, 1371, 1372, 1373, 1374, 1375],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1392,
        "parent": 1391,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1393,
        "parent": 1391,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1394,
        "parent": 1391,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1395,
        "parent": 1391,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1396, "parent": 433, "lvl": 2, "name": "Оборудование полиграфическое" }, {
        "id": 1397,
        "parent": 1396,
        "lvl": 3,
        "name": "Сталкиватель для бумаг"
    }, { "id": 1398, "parent": 1396, "lvl": 3, "name": "Фальцовщик" }, {
        "id": 1399,
        "parent": 1396,
        "lvl": 3,
        "name": "Буклетмейкер"
    }, { "id": 1400, "parent": 1396, "lvl": 3, "name": "Дрель для бумаги" }, {
        "id": 1401,
        "parent": 1396,
        "lvl": 3,
        "name": "Крышкоделательный аппарат"
    }, { "id": 1402, "parent": 1396, "lvl": 3, "name": "Лакировальная машина" }, {
        "id": 1403,
        "parent": 1396,
        "lvl": 3,
        "name": "Персс обжимной"
    }, { "id": 1404, "parent": 1396, "lvl": 3, "name": "Электрический штрихователь" }, {
        "id": 1405,
        "parent": 1396,
        "lvl": 3,
        "name": "Термопереплетная машина"
    }, { "id": 1406, "parent": 1396, "lvl": 3, "name": "Термоклеевая машина" }, {
        "id": 1407,
        "parent": 1396,
        "lvl": 3,
        "name": "Ниткошвейный переплетчик"
    }, {
        "id": 1408,
        "parent": [1397, 1398, 1399, 1400, 1401, 1402, 1403, 1404, 1405, 1406, 1407],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1409, "parent": 1408, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1410,
        "parent": 1408,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1411,
        "parent": 1408,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1412,
        "parent": 1408,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1413,
        "parent": 1408,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1414,
        "parent": 1408,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1415,
        "parent": [1397, 1398, 1399, 1400, 1401, 1402, 1403, 1404, 1405, 1406, 1407],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1416,
        "parent": 1415,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1417,
        "parent": 1415,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1418,
        "parent": 1415,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1419,
        "parent": 1415,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1420,
        "parent": [1397, 1398, 1399, 1400, 1401, 1402, 1403, 1404, 1405, 1406, 1407],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1421, "parent": 1420, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1422,
        "parent": 1420,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1423,
        "parent": [1397, 1398, 1399, 1400, 1401, 1402, 1403, 1404, 1405, 1406, 1407],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1424,
        "parent": 1423,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1425,
        "parent": 1423,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1426,
        "parent": 1423,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1427,
        "parent": 1423,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1428,
        "parent": 433,
        "lvl": 2,
        "name": "Оборудование отопительное, работающее на жидком и твердом топливе"
    }, { "id": 1429, "parent": 1428, "lvl": 3, "name": "Котлы на жидком топливе" }, {
        "id": 1430,
        "parent": 1428,
        "lvl": 3,
        "name": "Котлы на твердом топливе"
    }, { "id": 1431, "parent": 1428, "lvl": 3, "name": "Котельные установки" }, {
        "id": 1432,
        "parent": 1428,
        "lvl": 3,
        "name": "Мобильные котельные установки"
    }, { "id": 1433, "parent": 1428, "lvl": 3, "name": "Печи" }, {
        "id": 1434,
        "parent": 1428,
        "lvl": 3,
        "name": "Другое оборудование"
    }, { "id": 1435, "parent": [1429, 1430, 1431, 1432, 1433, 1434], "lvl": 4, "name": "Я - изготовитель" }, {
        "id": 1436,
        "parent": 1435,
        "lvl": 5,
        "name": "Технические условия (или ГОСТ при наличии)"
    }, {
        "id": 1437,
        "parent": 1435,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1438,
        "parent": 1435,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1439,
        "parent": 1435,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1440,
        "parent": 1435,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1441,
        "parent": 1435,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1442, "parent": [1429, 1430, 1431, 1432, 1433, 1434], "lvl": 4, "name": "Я - импортер" }, {
        "id": 1443,
        "parent": 1442,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1444,
        "parent": 1442,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1445,
        "parent": 1442,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1446,
        "parent": 1442,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1447, "parent": [1429, 1430, 1431, 1432, 1433, 1434], "lvl": 4, "name": "Я - экспортер" }, {
        "id": 1448,
        "parent": 1447,
        "lvl": 5,
        "name": "Сертификат(-ы) происхождения продукции"
    }, {
        "id": 1449,
        "parent": 1447,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, { "id": 1450, "parent": [1429, 1430, 1431, 1432, 1433, 1434], "lvl": 4, "name": "Я - продавец" }, {
        "id": 1451,
        "parent": 1450,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1452,
        "parent": 1450,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1453,
        "parent": 1450,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1454,
        "parent": 1450,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1455, "parent": 433, "lvl": 2, "name": "Арматура промышленная трубопроводная" }, {
        "id": 1456,
        "parent": 1455,
        "lvl": 3,
        "name": "Клапаны балансировочные"
    }, { "id": 1457, "parent": 1455, "lvl": 3, "name": "Шаровые краны" }, {
        "id": 1458,
        "parent": 1455,
        "lvl": 3,
        "name": "Задвижки"
    }, { "id": 1459, "parent": 1455, "lvl": 3, "name": "Регулирующие шаровые краны" }, {
        "id": 1460,
        "parent": 1455,
        "lvl": 3,
        "name": "Затворы"
    }, { "id": 1461, "parent": 1455, "lvl": 3, "name": "Вентили" }, {
        "id": 1462,
        "parent": 1455,
        "lvl": 3,
        "name": "Электроприводы"
    }, { "id": 1463, "parent": 1455, "lvl": 3, "name": "Энергетическая арматура" }, {
        "id": 1464,
        "parent": 1455,
        "lvl": 3,
        "name": "Регуляторы температуры"
    }, { "id": 1465, "parent": 1455, "lvl": 3, "name": "Регуляторы давления" }, {
        "id": 1466,
        "parent": 1455,
        "lvl": 3,
        "name": "Клапаны предохранительные"
    }, { "id": 1467, "parent": 1455, "lvl": 3, "name": "Клапаны обратные" }, {
        "id": 1468,
        "parent": 1455,
        "lvl": 3,
        "name": "Фланцы"
    }, { "id": 1469, "parent": 1455, "lvl": 3, "name": "Фильтры и грязевики" }, {
        "id": 1470,
        "parent": 1455,
        "lvl": 3,
        "name": "Фитинги стальные и чугунные"
    }, { "id": 1471, "parent": 1455, "lvl": 3, "name": "Конденсатоотводчики" }, {
        "id": 1472,
        "parent": 1455,
        "lvl": 3,
        "name": "Другая арматура"
    }, {
        "id": 1473,
        "parent": [1456, 1457, 1458, 1459, 1460, 1461, 1462, 1463, 1464, 1465, 1466, 1467, 1468, 1469, 1470, 1471, 1472],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1474, "parent": 1473, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1475,
        "parent": 1473,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 010 о безопасности машин и оборудования"
    }, {
        "id": 1476,
        "parent": 1473,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 010 о безопасности машин и оборудования"
    }, {
        "id": 1477,
        "parent": 1473,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 1478,
        "parent": 1473,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 1479,
        "parent": 1473,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1480,
        "parent": 1473,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1481,
        "parent": 1473,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1482,
        "parent": [1456, 1457, 1458, 1459, 1460, 1461, 1462, 1463, 1464, 1465, 1466, 1467, 1468, 1469, 1470, 1471, 1472],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1483,
        "parent": 1482,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 010 о безопасности машин и оборудования"
    }, {
        "id": 1484,
        "parent": 1482,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 010 о безопасности машин и оборудования"
    }, {
        "id": 1485,
        "parent": 1482,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 1486,
        "parent": 1482,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 1487,
        "parent": 1482,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1488,
        "parent": 1482,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1489,
        "parent": [1456, 1457, 1458, 1459, 1460, 1461, 1462, 1463, 1464, 1465, 1466, 1467, 1468, 1469, 1470, 1471, 1472],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1490, "parent": 1489, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1491,
        "parent": 1489,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1492,
        "parent": [1456, 1457, 1458, 1459, 1460, 1461, 1462, 1463, 1464, 1465, 1466, 1467, 1468, 1469, 1470, 1471, 1472],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1493,
        "parent": 1492,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 010 о безопасности машин и оборудования"
    }, {
        "id": 1494,
        "parent": 1492,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 010 о безопасности машин и оборудования"
    }, {
        "id": 1495,
        "parent": 1492,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 1496,
        "parent": 1492,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 032 о безопасности оборудования, работающего под избыточным давлением"
    }, {
        "id": 1497,
        "parent": 1492,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1498,
        "parent": 1492,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1499,
        "parent": 433,
        "lvl": 2,
        "name": "Инструмент абразивный, материалы абразивные, фрезы"
    }, {
        "id": 1500,
        "parent": 1499,
        "lvl": 3,
        "name": "Круги шлифовальные лепестковые"
    }, { "id": 1501, "parent": 1499, "lvl": 3, "name": "Лента шлифовальная" }, {
        "id": 1502,
        "parent": 1499,
        "lvl": 3,
        "name": "Паста абразивная"
    }, { "id": 1503, "parent": 1499, "lvl": 3, "name": "Диски шлифовальные" }, {
        "id": 1504,
        "parent": 1499,
        "lvl": 3,
        "name": "Бобины шлифовальные"
    }, { "id": 1505, "parent": 1499, "lvl": 3, "name": "Листы шлифовальные" }, {
        "id": 1506,
        "parent": 1499,
        "lvl": 3,
        "name": "Фрезы"
    }, { "id": 1507, "parent": 1499, "lvl": 3, "name": "Алмазные диски" }, {
        "id": 1508,
        "parent": 1499,
        "lvl": 3,
        "name": "Шлифовальная шкурка"
    }, { "id": 1509, "parent": 1499, "lvl": 3, "name": "Эльборовые круги" }, {
        "id": 1510,
        "parent": 1499,
        "lvl": 3,
        "name": "Шлифовальные бруски"
    }, { "id": 1511, "parent": 1499, "lvl": 3, "name": "Другая продукция" }, {
        "id": 1512,
        "parent": [1500, 1501, 1502, 1503, 1504, 1505, 1506, 1507, 1508, 1509, 1510, 1511],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1513, "parent": 1512, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1514,
        "parent": 1512,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1515,
        "parent": 1512,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1516,
        "parent": 1512,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1517,
        "parent": 1512,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1518,
        "parent": 1512,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1519,
        "parent": [1500, 1501, 1502, 1503, 1504, 1505, 1506, 1507, 1508, 1509, 1510, 1511],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1520,
        "parent": 1519,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1521,
        "parent": 1519,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1522,
        "parent": 1519,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1523,
        "parent": 1519,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1524,
        "parent": [1500, 1501, 1502, 1503, 1504, 1505, 1506, 1507, 1508, 1509, 1510, 1511],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1525, "parent": 1524, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1526,
        "parent": 1524,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1527,
        "parent": [1500, 1501, 1502, 1503, 1504, 1505, 1506, 1507, 1508, 1509, 1510, 1511],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1528,
        "parent": 1527,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1529,
        "parent": 1527,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1530,
        "parent": 1527,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1531,
        "parent": 1527,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1532, "parent": 433, "lvl": 2, "name": "Оборудование высоковольтное" }, {
        "id": 1533,
        "parent": 1532,
        "lvl": 3,
        "name": "Выключатели силовые"
    }, { "id": 1534, "parent": 1532, "lvl": 3, "name": "Разъединители" }, {
        "id": 1535,
        "parent": 1532,
        "lvl": 3,
        "name": "Заземлители"
    }, { "id": 1536, "parent": 1532, "lvl": 3, "name": "Разрядники" }, {
        "id": 1537,
        "parent": 1532,
        "lvl": 3,
        "name": "Высоковольтные изоляторы"
    }, { "id": 1538, "parent": 1532, "lvl": 3, "name": "Высоковольтные предохранители" }, {
        "id": 1539,
        "parent": 1532,
        "lvl": 3,
        "name": "Ограничители напряжений"
    }, { "id": 1540, "parent": 1532, "lvl": 3, "name": "Трансформаторы тока" }, {
        "id": 1541,
        "parent": 1532,
        "lvl": 3,
        "name": "Конденсаторы"
    }, { "id": 1542, "parent": 1532, "lvl": 3, "name": "Комплектные распределительные устройства" }, {
        "id": 1543,
        "parent": 1532,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 1544,
        "parent": [1533, 1534, 1535, 1536, 1537, 1538, 1539, 1540, 1541, 1542, 1543],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1545, "parent": 1544, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1546,
        "parent": 1544,
        "lvl": 5,
        "name": "Декларация(-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 1547,
        "parent": 1544,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1548,
        "parent": 1544,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1549,
        "parent": 1544,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1550,
        "parent": [1533, 1534, 1535, 1536, 1537, 1538, 1539, 1540, 1541, 1542, 1543],
        "lvl": 4,
        "name": "Я - импортер"
    }, { "id": 1551, "parent": 1550, "lvl": 5, "name": "Декларация(-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)" }, {
        "id": 1552,
        "parent": 1550,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1553,
        "parent": 1550,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1554,
        "parent": [1533, 1534, 1535, 1536, 1537, 1538, 1539, 1540, 1541, 1542, 1543],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1555, "parent": 1554, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1556,
        "parent": 1554,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1557,
        "parent": [1533, 1534, 1535, 1536, 1537, 1538, 1539, 1540, 1541, 1542, 1543],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1558,
        "parent": 1557,
        "lvl": 5,
        "name": "Копии деклараций ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 1559,
        "parent": 1557,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1560,
        "parent": 1557,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1561, "parent": 433, "lvl": 2, "name": "Приборы бытовые" }, {
        "id": 1562,
        "parent": 1561,
        "lvl": 3,
        "name": "Утюг"
    }, { "id": 1563, "parent": 1561, "lvl": 3, "name": "Чайник" }, {
        "id": 1564,
        "parent": 1561,
        "lvl": 3,
        "name": "Кофеварка"
    }, { "id": 1565, "parent": 1561, "lvl": 3, "name": "Стиральная машина" }, {
        "id": 1566,
        "parent": 1561,
        "lvl": 3,
        "name": "Магнитофон"
    }, { "id": 1567, "parent": 1561, "lvl": 3, "name": "Холодильник" }, {
        "id": 1568,
        "parent": 1561,
        "lvl": 3,
        "name": "Кухонная плита"
    }, { "id": 1569, "parent": 1561, "lvl": 3, "name": "Пылесос" }, {
        "id": 1570,
        "parent": 1561,
        "lvl": 3,
        "name": "Фен"
    }, { "id": 1571, "parent": 1561, "lvl": 3, "name": "Телефон" }, {
        "id": 1572,
        "parent": 1561,
        "lvl": 3,
        "name": "Вентилятор"
    }, { "id": 1573, "parent": 1561, "lvl": 3, "name": "Другие приборы" }, {
        "id": 1574,
        "parent": [1562, 1563, 1564, 1565, 1566, 1567, 1568, 1569, 1570, 1571, 1572, 1573],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1575, "parent": 1574, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1576,
        "parent": 1574,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1577,
        "parent": 1574,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1578,
        "parent": 1574,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1579,
        "parent": 1574,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1580,
        "parent": 1574,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1581,
        "parent": [1562, 1563, 1564, 1565, 1566, 1567, 1568, 1569, 1570, 1571, 1572, 1573],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1582,
        "parent": 1581,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1583,
        "parent": 1581,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1584,
        "parent": 1581,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1585,
        "parent": 1581,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1586,
        "parent": [1562, 1563, 1564, 1565, 1566, 1567, 1568, 1569, 1570, 1571, 1572, 1573],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1587, "parent": 1586, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1588,
        "parent": 1586,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1589,
        "parent": [1562, 1563, 1564, 1565, 1566, 1567, 1568, 1569, 1570, 1571, 1572, 1573],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1590,
        "parent": 1589,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1591,
        "parent": 1589,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1592,
        "parent": 1589,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1593,
        "parent": 1589,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1594, "parent": 433, "lvl": 2, "name": "Оборудование осветительное" }, {
        "id": 1595,
        "parent": 1594,
        "lvl": 3,
        "name": "Аварийные светильники"
    }, { "id": 1596, "parent": 1594, "lvl": 3, "name": "Прожекторы" }, {
        "id": 1597,
        "parent": 1594,
        "lvl": 3,
        "name": "Светодиодные светильники"
    }, { "id": 1598, "parent": 1594, "lvl": 3, "name": "Встраиваемые светильники" }, {
        "id": 1599,
        "parent": 1594,
        "lvl": 3,
        "name": "Офисные светильники"
    }, { "id": 1600, "parent": 1594, "lvl": 3, "name": "Грунтовые светильники" }, {
        "id": 1601,
        "parent": 1594,
        "lvl": 3,
        "name": "Парковые светильники"
    }, { "id": 1602, "parent": 1594, "lvl": 3, "name": "Подводные светильники" }, {
        "id": 1603,
        "parent": 1594,
        "lvl": 3,
        "name": "Промышленные светильники"
    }, { "id": 1604, "parent": 1594, "lvl": 3, "name": "Пылевлагозащищенные светильники" }, {
        "id": 1605,
        "parent": 1594,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 1606,
        "parent": [1595, 1596, 1597, 1598, 1599, 1600, 1601, 1602, 1603, 1604, 1605],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1607, "parent": 1606, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1608,
        "parent": 1606,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1609,
        "parent": 1606,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1610,
        "parent": 1606,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1611,
        "parent": 1606,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1612,
        "parent": 1606,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1613,
        "parent": [1595, 1596, 1597, 1598, 1599, 1600, 1601, 1602, 1603, 1604, 1605],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1614,
        "parent": 1613,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1615,
        "parent": 1613,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1616,
        "parent": 1613,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1617,
        "parent": 1613,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1618,
        "parent": [1595, 1596, 1597, 1598, 1599, 1600, 1601, 1602, 1603, 1604, 1605],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1619, "parent": 1618, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1620,
        "parent": 1618,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1621,
        "parent": [1595, 1596, 1597, 1598, 1599, 1600, 1601, 1602, 1603, 1604, 1605],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1622,
        "parent": 1621,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1623,
        "parent": 1621,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1624,
        "parent": 1621,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1625,
        "parent": 1621,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1626, "parent": 0, "lvl": 1, "name": "Оборудование измерительное" }, {
        "id": 1627,
        "parent": 1626,
        "lvl": 2,
        "name": "Оборудование измерительное"
    }, { "id": 1628, "parent": 1627, "lvl": 3, "name": "Лазерные дальномеры" }, {
        "id": 1629,
        "parent": 1627,
        "lvl": 3,
        "name": "Угломеры и уклономеры"
    }, { "id": 1630, "parent": 1627, "lvl": 3, "name": "Газоанализаторы" }, {
        "id": 1631,
        "parent": 1627,
        "lvl": 3,
        "name": "Тахометры"
    }, { "id": 1632, "parent": 1627, "lvl": 3, "name": "Манометры" }, {
        "id": 1633,
        "parent": 1627,
        "lvl": 3,
        "name": "Теодолиты"
    }, { "id": 1634, "parent": 1627, "lvl": 3, "name": "Анемометры" }, {
        "id": 1635,
        "parent": 1627,
        "lvl": 3,
        "name": "Нивелиры"
    }, { "id": 1636, "parent": 1627, "lvl": 3, "name": "Детекторы металла" }, {
        "id": 1637,
        "parent": 1627,
        "lvl": 3,
        "name": "Видеоэндоскопы"
    }, { "id": 1638, "parent": 1627, "lvl": 3, "name": "Дозиметры радиации" }, {
        "id": 1639,
        "parent": 1627,
        "lvl": 3,
        "name": "Измерители температуры"
    }, { "id": 1640, "parent": 1627, "lvl": 3, "name": "Тепловизоры" }, {
        "id": 1641,
        "parent": 1627,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 1642,
        "parent": [1628, 1629, 1630, 1631, 1632, 1633, 1634, 1635, 1636, 1637, 1638, 1639, 1640, 1641],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1643, "parent": 1642, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1644,
        "parent": 1642,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1645,
        "parent": 1642,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, { "id": 1646, "parent": 1642, "lvl": 5, "name": "Сертификат утверждения типа средства измерения" }, {
        "id": 1647,
        "parent": 1642,
        "lvl": 5,
        "name": "Декларация (-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, { "id": 1648, "parent": 1642, "lvl": 5, "name": "Сертификат(-ы) ГОСТ Р (982 ПП РФ от 01.12.2009)" }, {
        "id": 1649,
        "parent": 1642,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1650,
        "parent": 1642,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1651,
        "parent": 1642,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1652,
        "parent": [1628, 1629, 1630, 1631, 1632, 1633, 1634, 1635, 1636, 1637, 1638, 1639, 1640, 1641],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1653,
        "parent": 1652,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1654,
        "parent": 1652,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, { "id": 1655, "parent": 1652, "lvl": 5, "name": "Сертификат утверждения типа средства измерения" }, {
        "id": 1656,
        "parent": 1652,
        "lvl": 5,
        "name": "Декларация (-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, { "id": 1657, "parent": 1652, "lvl": 5, "name": "Сертификат(-ы) ГОСТ Р (982 ПП РФ от 01.12.2009)" }, {
        "id": 1658,
        "parent": 1652,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1659,
        "parent": 1652,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1660,
        "parent": [1628, 1629, 1630, 1631, 1632, 1633, 1634, 1635, 1636, 1637, 1638, 1639, 1640, 1641],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1661, "parent": 1660, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1662,
        "parent": 1660,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1663,
        "parent": [1628, 1629, 1630, 1631, 1632, 1633, 1634, 1635, 1636, 1637, 1638, 1639, 1640, 1641],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1664,
        "parent": 1663,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1665,
        "parent": 1663,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1666,
        "parent": 1663,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 1667,
        "parent": 1663,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 1668,
        "parent": 1663,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1669,
        "parent": 1663,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1670, "parent": 433, "lvl": 2, "name": "Оборудование низковольтное промышленное" }, {
        "id": 1671,
        "parent": 1670,
        "lvl": 3,
        "name": "Модульная аппаратура"
    }, { "id": 1672, "parent": 1670, "lvl": 3, "name": "Автоматические выключатели" }, {
        "id": 1673,
        "parent": 1670,
        "lvl": 3,
        "name": "Пуско-регулирующая аппаратура"
    }, { "id": 1674, "parent": 1670, "lvl": 3, "name": "Рубильники" }, {
        "id": 1675,
        "parent": 1670,
        "lvl": 3,
        "name": "Предохранители"
    }, { "id": 1676, "parent": 1670, "lvl": 3, "name": "Компьютеры" }, {
        "id": 1677,
        "parent": 1670,
        "lvl": 3,
        "name": "Панели управления"
    }, { "id": 1678, "parent": 1670, "lvl": 3, "name": "Модульные выключатели" }, {
        "id": 1679,
        "parent": 1670,
        "lvl": 3,
        "name": "Счетчики"
    }, { "id": 1680, "parent": 1670, "lvl": 3, "name": "Защитные устройства" }, {
        "id": 1681,
        "parent": 1670,
        "lvl": 3,
        "name": "Распределительные устройства"
    }, { "id": 1682, "parent": 1670, "lvl": 3, "name": "Вводные устройства" }, {
        "id": 1683,
        "parent": 1670,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 1684,
        "parent": [1671, 1672, 1673, 1674, 1675, 1676, 1677, 1678, 1679, 1680, 1681, 1682, 1683],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1685, "parent": 1684, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1686,
        "parent": 1684,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1687,
        "parent": 1684,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1688,
        "parent": 1684,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1689,
        "parent": 1684,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1690,
        "parent": 1684,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1691,
        "parent": [1671, 1672, 1673, 1674, 1675, 1676, 1677, 1678, 1679, 1680, 1681, 1682, 1683],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1692,
        "parent": 1691,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1693,
        "parent": 1691,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1694,
        "parent": 1691,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1695,
        "parent": 1691,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1696,
        "parent": [1671, 1672, 1673, 1674, 1675, 1676, 1677, 1678, 1679, 1680, 1681, 1682, 1683],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1697, "parent": 1696, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1698,
        "parent": 1696,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1699,
        "parent": [1671, 1672, 1673, 1674, 1675, 1676, 1677, 1678, 1679, 1680, 1681, 1682, 1683],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1700,
        "parent": 1699,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1701,
        "parent": 1699,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/010\/020 о безопасности низковольтного оборудования\/машин и оборудования\/электромагнитная совместимость"
    }, {
        "id": 1702,
        "parent": 1699,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1703,
        "parent": 1699,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1704, "parent": 0, "lvl": 1, "name": "Транспортные средства и их компоненты" }, {
        "id": 1705,
        "parent": 1704,
        "lvl": 2,
        "name": "Транспортные средства и их компоненты"
    }, { "id": 1706, "parent": 1705, "lvl": 3, "name": "Легковые автомобили" }, {
        "id": 1707,
        "parent": 1705,
        "lvl": 3,
        "name": "Грузовые автомобили"
    }, { "id": 1708, "parent": 1705, "lvl": 3, "name": "Мотоциклы" }, {
        "id": 1709,
        "parent": 1705,
        "lvl": 3,
        "name": "Микроавтобусы"
    }, { "id": 1710, "parent": 1705, "lvl": 3, "name": "Автобусы" }, {
        "id": 1711,
        "parent": 1705,
        "lvl": 3,
        "name": "Запасные части"
    }, { "id": 1712, "parent": 1705, "lvl": 3, "name": "Другие транспортные средства" }, {
        "id": 1713,
        "parent": [1706, 1707, 1708, 1709, 1710, 1711, 1712],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1714, "parent": 1713, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1715,
        "parent": 1713,
        "lvl": 5,
        "name": "Одобрение типа транспортного средства"
    }, {
        "id": 1716,
        "parent": 1713,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 018 о безопасности колесных транспортных средств"
    }, {
        "id": 1717,
        "parent": 1713,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 018 о безопасности колесных транспортных средств"
    }, {
        "id": 1718,
        "parent": 1713,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1719,
        "parent": 1713,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1720,
        "parent": 1713,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1721,
        "parent": [1706, 1707, 1708, 1709, 1710, 1711, 1712],
        "lvl": 4,
        "name": "Я - импортер"
    }, { "id": 1722, "parent": 1721, "lvl": 5, "name": "Одобрение типа транспортного средства" }, {
        "id": 1723,
        "parent": 1721,
        "lvl": 5,
        "name": "Свидетельство о безопасности конструкции транспортного средсвтва"
    }, {
        "id": 1724,
        "parent": 1721,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 018 о безопасности колесных транспортных средств"
    }, {
        "id": 1725,
        "parent": 1721,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 018 о безопасности колесных транспортных средств"
    }, {
        "id": 1726,
        "parent": 1721,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1727,
        "parent": 1721,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1728,
        "parent": [1706, 1707, 1708, 1709, 1710, 1711, 1712],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1729, "parent": 1728, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1730,
        "parent": 1728,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1731,
        "parent": [1706, 1707, 1708, 1709, 1710, 1711, 1712],
        "lvl": 4,
        "name": "Я - продавец"
    }, { "id": 1732, "parent": 1731, "lvl": 5, "name": "Копия одобрения типа транспортного средства" }, {
        "id": 1733,
        "parent": 1731,
        "lvl": 5,
        "name": "Копия свидетельства о безопасности конструкции транспортного средсвтва"
    }, {
        "id": 1734,
        "parent": 1731,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 018 о безопасности колесных транспортных средств"
    }, {
        "id": 1735,
        "parent": 1731,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 018 о безопасности колесных транспортных средств"
    }, {
        "id": 1736,
        "parent": 1731,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1737,
        "parent": 1731,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1738, "parent": 0, "lvl": 1, "name": "Продукция резинотехнической промышленности" }, {
        "id": 1739,
        "parent": 1738,
        "lvl": 2,
        "name": "Продукция резинотехнической промышленности"
    }, { "id": 1740, "parent": 1739, "lvl": 3, "name": "Конвейерные ленты" }, {
        "id": 1741,
        "parent": 1739,
        "lvl": 3,
        "name": "Транспортерные и плоские ремни"
    }, { "id": 1742, "parent": 1739, "lvl": 3, "name": "Рукава" }, {
        "id": 1743,
        "parent": 1739,
        "lvl": 3,
        "name": "Шланги"
    }, { "id": 1744, "parent": 1739, "lvl": 3, "name": "Рукава высокого давления" }, {
        "id": 1745,
        "parent": 1739,
        "lvl": 3,
        "name": "Мембранное полотно"
    }, { "id": 1746, "parent": 1739, "lvl": 3, "name": "Гофрированные чехлы" }, {
        "id": 1747,
        "parent": 1739,
        "lvl": 3,
        "name": "Виброизоляционные компоненты"
    }, { "id": 1748, "parent": 1739, "lvl": 3, "name": "Другая продукция" }, {
        "id": 1749,
        "parent": [1740, 1741, 1742, 1743, 1744, 1745, 1746, 1747, 1748],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1750, "parent": 1749, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1751,
        "parent": 1749,
        "lvl": 5,
        "name": "Свидетельство о государственной регистрации"
    }, {
        "id": 1752,
        "parent": 1749,
        "lvl": 5,
        "name": "Декларация (-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 1753,
        "parent": 1749,
        "lvl": 5,
        "name": "Сертификат(-ы) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 1754,
        "parent": 1749,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1755,
        "parent": 1749,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1756,
        "parent": 1749,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1757,
        "parent": [1740, 1741, 1742, 1743, 1744, 1745, 1746, 1747, 1748],
        "lvl": 4,
        "name": "Я - импортер"
    }, { "id": 1758, "parent": 1757, "lvl": 5, "name": "Свидетельство о государственной регистрации" }, {
        "id": 1759,
        "parent": 1757,
        "lvl": 5,
        "name": "Декларация (-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, { "id": 1760, "parent": 1757, "lvl": 5, "name": "Сертификат(-ы) ГОСТ Р (982 ПП РФ от 01.12.2009)" }, {
        "id": 1761,
        "parent": 1757,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1762,
        "parent": 1757,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1763,
        "parent": [1740, 1741, 1742, 1743, 1744, 1745, 1746, 1747, 1748],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1764, "parent": 1763, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1765,
        "parent": 1763,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1766,
        "parent": [1740, 1741, 1742, 1743, 1744, 1745, 1746, 1747, 1748],
        "lvl": 4,
        "name": "Я - продавец"
    }, { "id": 1767, "parent": 1766, "lvl": 5, "name": "Копии свидетельств о государственной регистрации" }, {
        "id": 1768,
        "parent": 1766,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 1769,
        "parent": 1766,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 1770,
        "parent": 1766,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1771,
        "parent": 1766,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1772, "parent": 1, "lvl": 2, "name": "Игрушки для детей" }, {
        "id": 1773,
        "parent": 1772,
        "lvl": 3,
        "name": "Пасты для лепки, пластилин"
    }, { "id": 1774, "parent": 1772, "lvl": 3, "name": "Трехколесные велосипеды" }, {
        "id": 1775,
        "parent": 1772,
        "lvl": 3,
        "name": "Самокаты"
    }, { "id": 1776, "parent": 1772, "lvl": 3, "name": "Куклы" }, {
        "id": 1777,
        "parent": 1772,
        "lvl": 3,
        "name": "Поезда"
    }, { "id": 1778, "parent": 1772, "lvl": 3, "name": "Наборы конструкторские" }, {
        "id": 1779,
        "parent": 1772,
        "lvl": 3,
        "name": "Головоломки"
    }, { "id": 1780, "parent": 1772, "lvl": 3, "name": "Мячи" }, {
        "id": 1781,
        "parent": 1772,
        "lvl": 3,
        "name": "Мягкие игрушки"
    }, { "id": 1782, "parent": 1772, "lvl": 3, "name": "Электронные игры" }, {
        "id": 1783,
        "parent": 1772,
        "lvl": 3,
        "name": "Бассейны для детей"
    }, { "id": 1784, "parent": 1772, "lvl": 3, "name": "Другие игрушки" }, {
        "id": 1785,
        "parent": [1773, 1774, 1775, 1776, 1777, 1778, 1779, 1780, 1781, 1782, 1783, 1784],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1786, "parent": 1785, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1787,
        "parent": 1785,
        "lvl": 5,
        "name": "Свидетельство о государственной регистрации"
    }, { "id": 1788, "parent": 1785, "lvl": 5, "name": "Сертификат(-ы) ТР ТС 008 о безопасности игрушек" }, {
        "id": 1789,
        "parent": 1785,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1790,
        "parent": 1785,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1791,
        "parent": 1785,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1792,
        "parent": [1773, 1774, 1775, 1776, 1777, 1778, 1779, 1780, 1781, 1782, 1783, 1784],
        "lvl": 4,
        "name": "Я - импортер"
    }, { "id": 1793, "parent": 1792, "lvl": 5, "name": "Свидетельство о государственной регистрации" }, {
        "id": 1794,
        "parent": 1792,
        "lvl": 5,
        "name": "Сертификат(-ы) ТР ТС 008 о безопасности игрушек"
    }, {
        "id": 1795,
        "parent": 1792,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1796,
        "parent": 1792,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1797,
        "parent": [1773, 1774, 1775, 1776, 1777, 1778, 1779, 1780, 1781, 1782, 1783, 1784],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1798, "parent": 1797, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1799,
        "parent": 1797,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1800,
        "parent": [1773, 1774, 1775, 1776, 1777, 1778, 1779, 1780, 1781, 1782, 1783, 1784],
        "lvl": 4,
        "name": "Я - продавец"
    }, { "id": 1801, "parent": 1800, "lvl": 5, "name": "Копии свидетельств о государственной регистрации" }, {
        "id": 1802,
        "parent": 1800,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 008 о безопасности игрушек"
    }, {
        "id": 1803,
        "parent": 1800,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1804,
        "parent": 1800,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1805, "parent": 1, "lvl": 2, "name": "Детская одежда и украшения для детей" }, {
        "id": 1806,
        "parent": 1805,
        "lvl": 3,
        "name": "Одежда"
    }, { "id": 1807, "parent": 1805, "lvl": 3, "name": "Головные уборы" }, {
        "id": 1808,
        "parent": 1805,
        "lvl": 3,
        "name": "Обувь"
    }, { "id": 1809, "parent": 1805, "lvl": 3, "name": "Купальные изделия" }, {
        "id": 1810,
        "parent": 1805,
        "lvl": 3,
        "name": "Изделия кожгалантерейные"
    }, { "id": 1811, "parent": 1805, "lvl": 3, "name": "Постельные принадлежности" }, {
        "id": 1812,
        "parent": 1805,
        "lvl": 3,
        "name": "Серьги, браслеты"
    }, { "id": 1813, "parent": 1805, "lvl": 3, "name": "Другие изделия" }, {
        "id": 1814,
        "parent": [1806, 1807, 1808, 1809, 1810, 1811, 1812, 1813],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1815, "parent": 1814, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1816,
        "parent": 1814,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 007 о безопасности продукции, предназначенной для детей и подростков"
    }, {
        "id": 1817,
        "parent": 1814,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 007 о безопасности продукции, предназначенной для детей и подростков"
    }, { "id": 1818, "parent": 1814, "lvl": 5, "name": "Свидетельство о государственной регистрации" }, {
        "id": 1819,
        "parent": 1814,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1820,
        "parent": 1814,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1821,
        "parent": 1814,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1822,
        "parent": [1806, 1807, 1808, 1809, 1810, 1811, 1812, 1813],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1823,
        "parent": 1822,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 007 о безопасности продукции, предназначенной для детей и подростков"
    }, {
        "id": 1824,
        "parent": 1822,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 007 о безопасности продукции, предназначенной для детей и подростков"
    }, { "id": 1825, "parent": 1822, "lvl": 5, "name": "Свидетельство о государственной регистрации" }, {
        "id": 1826,
        "parent": 1822,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1827,
        "parent": 1822,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1828,
        "parent": [1806, 1807, 1808, 1809, 1810, 1811, 1812, 1813],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1829, "parent": 1828, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1830,
        "parent": 1828,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1831,
        "parent": [1806, 1807, 1808, 1809, 1810, 1811, 1812, 1813],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1832,
        "parent": 1831,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 007 о безопасности продукции, предназначенной для детей и подростков"
    }, {
        "id": 1833,
        "parent": 1831,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 007 о безопасности продукции, предназначенной для детей и подростков"
    }, { "id": 1834, "parent": 1831, "lvl": 5, "name": "Копии свидетельств о государственной регистрации" }, {
        "id": 1835,
        "parent": 1831,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1836,
        "parent": 1831,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1837, "parent": 1, "lvl": 2, "name": "Санитрно-гигиенические принадлежности для детей" }, {
        "id": 1838,
        "parent": 1837,
        "lvl": 3,
        "name": "Соски молочные, соски-пустышки"
    }, { "id": 1839, "parent": 1837, "lvl": 3, "name": "Ванночка" }, {
        "id": 1840,
        "parent": 1837,
        "lvl": 3,
        "name": "Горшок туалетный"
    }, { "id": 1841, "parent": 1837, "lvl": 3, "name": "Стульчик" }, {
        "id": 1842,
        "parent": 1837,
        "lvl": 3,
        "name": "Зубные щетки"
    }, { "id": 1843, "parent": 1837, "lvl": 3, "name": "Подгузники" }, {
        "id": 1844,
        "parent": 1837,
        "lvl": 3,
        "name": "Ватные палочки"
    }, { "id": 1845, "parent": 1837, "lvl": 3, "name": "Пеленки" }, {
        "id": 1846,
        "parent": 1837,
        "lvl": 3,
        "name": "Шампуни"
    }, { "id": 1847, "parent": 1837, "lvl": 3, "name": "Масла, духи" }, {
        "id": 1848,
        "parent": 1837,
        "lvl": 3,
        "name": "Косметика"
    }, { "id": 1849, "parent": 1837, "lvl": 3, "name": "Зубная паста" }, {
        "id": 1850,
        "parent": 1837,
        "lvl": 3,
        "name": "Другие принадлежности"
    }, {
        "id": 1851,
        "parent": [1838, 1839, 1840, 1841, 1842, 1843, 1844, 1845, 1846, 1847, 1848, 1849, 1850],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1852, "parent": 1851, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1853,
        "parent": 1851,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 007 о безопасности продукции, предназначенной для детей и подростков"
    }, {
        "id": 1854,
        "parent": 1851,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 007 о безопасности продукции, предназначенной для детей и подростков"
    }, {
        "id": 1855,
        "parent": 1851,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 009 о безопасности парфюмерно-косметической продукции"
    }, {
        "id": 1856,
        "parent": 1851,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 009 о безопасности парфюмерно-косметической продукции"
    }, { "id": 1857, "parent": 1851, "lvl": 5, "name": "Свидетельство о государственной регистрации" }, {
        "id": 1858,
        "parent": 1851,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1859,
        "parent": 1851,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1860,
        "parent": 1851,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1861,
        "parent": [1838, 1839, 1840, 1841, 1842, 1843, 1844, 1845, 1846, 1847, 1848, 1849, 1850],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1862,
        "parent": 1861,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 007 о безопасности продукции, предназначенной для детей и подростков"
    }, {
        "id": 1863,
        "parent": 1861,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 007 о безопасности продукции, предназначенной для детей и подростков"
    }, {
        "id": 1864,
        "parent": 1861,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 009 о безопасности парфюмерно-косметической продукции"
    }, {
        "id": 1865,
        "parent": 1861,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 009 о безопасности парфюмерно-косметической продукции"
    }, { "id": 1866, "parent": 1861, "lvl": 5, "name": "Свидетельство о государственной регистрации" }, {
        "id": 1867,
        "parent": 1861,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1868,
        "parent": 1861,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1869,
        "parent": [1838, 1839, 1840, 1841, 1842, 1843, 1844, 1845, 1846, 1847, 1848, 1849, 1850],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1870, "parent": 1869, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1871,
        "parent": 1869,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1872,
        "parent": [1838, 1839, 1840, 1841, 1842, 1843, 1844, 1845, 1846, 1847, 1848, 1849, 1850],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1873,
        "parent": 1872,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 007 о безопасности продукции, предназначенной для детей и подростков"
    }, {
        "id": 1874,
        "parent": 1872,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 007 о безопасности продукции, предназначенной для детей и подростков"
    }, {
        "id": 1875,
        "parent": 1872,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 009 о безопасности парфюмерно-косметической продукции"
    }, {
        "id": 1876,
        "parent": 1872,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 009 о безопасности парфюмерно-косметической продукции"
    }, { "id": 1877, "parent": 1872, "lvl": 5, "name": "Копии свидетельств о государственной регистрации" }, {
        "id": 1878,
        "parent": 1872,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1879,
        "parent": 1872,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1880, "parent": 0, "lvl": 1, "name": "Смазочные материалы и масла" }, {
        "id": 1881,
        "parent": 1880,
        "lvl": 2,
        "name": "Смазочные материалы и масла"
    }, { "id": 1882, "parent": 1881, "lvl": 3, "name": "Масла моторные" }, {
        "id": 1883,
        "parent": 1881,
        "lvl": 3,
        "name": "Масла трансмиссионные"
    }, { "id": 1884, "parent": 1881, "lvl": 3, "name": "Масла гидравлические" }, {
        "id": 1885,
        "parent": 1881,
        "lvl": 3,
        "name": "Масла компрессорные"
    }, { "id": 1886, "parent": 1881, "lvl": 3, "name": "Масла турбинные" }, {
        "id": 1887,
        "parent": 1881,
        "lvl": 3,
        "name": "Масла антикоррозионные"
    }, { "id": 1888, "parent": 1881, "lvl": 3, "name": "Масла базовые" }, {
        "id": 1889,
        "parent": 1881,
        "lvl": 3,
        "name": "Пластичные смазки"
    }, { "id": 1890, "parent": 1881, "lvl": 3, "name": "Охлаждающие жидкости" }, {
        "id": 1891,
        "parent": 1881,
        "lvl": 3,
        "name": "Тормозные жидкости"
    }, { "id": 1892, "parent": 1881, "lvl": 3, "name": "Другая продукция" }, {
        "id": 1893,
        "parent": [1882, 1883, 1884, 1885, 1886, 1887, 1888, 1889, 1890, 1891, 1892],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1894, "parent": 1893, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1895,
        "parent": 1893,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 030 о безопасности смазочных материалов, масел, специальных жидкостей"
    }, {
        "id": 1896,
        "parent": 1893,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1897,
        "parent": 1893,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1898,
        "parent": 1893,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1899,
        "parent": [1882, 1883, 1884, 1885, 1886, 1887, 1888, 1889, 1890, 1891, 1892],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1900,
        "parent": 1899,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 030 о безопасности смазочных материалов, масел, специальных жидкостей"
    }, {
        "id": 1901,
        "parent": 1899,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1902,
        "parent": 1899,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1903,
        "parent": [1882, 1883, 1884, 1885, 1886, 1887, 1888, 1889, 1890, 1891, 1892],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1904, "parent": 1903, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1905,
        "parent": 1903,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1906,
        "parent": [1882, 1883, 1884, 1885, 1886, 1887, 1888, 1889, 1890, 1891, 1892],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1907,
        "parent": 1906,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 030 о безопасности смазочных материалов, масел, специальных жидкостей"
    }, {
        "id": 1908,
        "parent": 1906,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1909,
        "parent": 1906,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1910, "parent": 0, "lvl": 1, "name": "Средства индивидуальной защиты" }, {
        "id": 1911,
        "parent": 1910,
        "lvl": 2,
        "name": "Средства индивидуальной защиты"
    }, { "id": 1912, "parent": 1911, "lvl": 3, "name": "Костюмы для защиты от механических факторов" }, {
        "id": 1913,
        "parent": 1911,
        "lvl": 3,
        "name": "Костюмы для защиты от химических факторов"
    }, { "id": 1914, "parent": 1911, "lvl": 3, "name": "Рукавицы и перчатки защитные" }, {
        "id": 1915,
        "parent": 1911,
        "lvl": 3,
        "name": "Обувь защитная"
    }, { "id": 1916, "parent": 1911, "lvl": 3, "name": "Каски защитные" }, {
        "id": 1917,
        "parent": 1911,
        "lvl": 3,
        "name": "Противошумные наушники"
    }, { "id": 1918, "parent": 1911, "lvl": 3, "name": "Средства индивидуальной защиты органов дыхания" }, {
        "id": 1919,
        "parent": 1911,
        "lvl": 3,
        "name": "Очки защитные"
    }, { "id": 1920, "parent": 1911, "lvl": 3, "name": "Очищающие средства: кремы, пасты, гели" }, {
        "id": 1921,
        "parent": 1911,
        "lvl": 3,
        "name": "Другая продукция"
    }, {
        "id": 1922,
        "parent": [1912, 1913, 1914, 1915, 1916, 1917, 1918, 1919, 1920, 1921],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1923, "parent": 1922, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1924,
        "parent": 1922,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 019 о безопасности средств индивидуальной защиты"
    }, {
        "id": 1925,
        "parent": 1922,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 019 о безопасности средств индивидуальной защиты"
    }, {
        "id": 1926,
        "parent": 1922,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1927,
        "parent": 1922,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1928,
        "parent": 1922,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1929,
        "parent": [1912, 1913, 1914, 1915, 1916, 1917, 1918, 1919, 1920, 1921],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 1930,
        "parent": 1929,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 019 о безопасности средств индивидуальной защиты"
    }, {
        "id": 1931,
        "parent": 1929,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 019 о безопасности средств индивидуальной защиты"
    }, {
        "id": 1932,
        "parent": 1929,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1933,
        "parent": 1929,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1934,
        "parent": [1912, 1913, 1914, 1915, 1916, 1917, 1918, 1919, 1920, 1921],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1935, "parent": 1934, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1936,
        "parent": 1934,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1937,
        "parent": [1912, 1913, 1914, 1915, 1916, 1917, 1918, 1919, 1920, 1921],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1938,
        "parent": 1937,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 019 о безопасности средств индивидуальной защиты"
    }, {
        "id": 1939,
        "parent": 1937,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 019 о безопасности средств индивидуальной защиты"
    }, {
        "id": 1940,
        "parent": 1937,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1941,
        "parent": 1937,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1942, "parent": 0, "lvl": 1, "name": "Медицинские изделия и оборудование" }, {
        "id": 1943,
        "parent": 1942,
        "lvl": 2,
        "name": "Медицинские изделия и оборудование"
    }, { "id": 1944, "parent": 1943, "lvl": 3, "name": "Диагностическое оборудование" }, {
        "id": 1945,
        "parent": 1943,
        "lvl": 3,
        "name": "Операционное оборудование"
    }, { "id": 1946, "parent": 1943, "lvl": 3, "name": "Эндоскопическое оборудование" }, {
        "id": 1947,
        "parent": 1943,
        "lvl": 3,
        "name": "Косметологическое оборудование"
    }, { "id": 1948, "parent": 1943, "lvl": 3, "name": "Массажное оборудование" }, {
        "id": 1949,
        "parent": 1943,
        "lvl": 3,
        "name": "Офтальмологическое оборудование"
    }, { "id": 1950, "parent": 1943, "lvl": 3, "name": "Стоматологическое оборудование" }, {
        "id": 1951,
        "parent": 1943,
        "lvl": 3,
        "name": "Медицинская мебель"
    }, { "id": 1952, "parent": 1943, "lvl": 3, "name": "Медецинская одежда" }, {
        "id": 1953,
        "parent": 1943,
        "lvl": 3,
        "name": "Бахилы"
    }, { "id": 1954, "parent": 1943, "lvl": 3, "name": "Другие изделия и оборудование" }, {
        "id": 1955,
        "parent": [1944, 1945, 1946, 1947, 1948, 1949, 1950, 1951, 1952, 1953, 1954],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1956, "parent": 1955, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1957,
        "parent": 1955,
        "lvl": 5,
        "name": "Регистрационное удостоверение Росздравнадзора"
    }, {
        "id": 1958,
        "parent": 1955,
        "lvl": 5,
        "name": "Декларация (-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 1959,
        "parent": 1955,
        "lvl": 5,
        "name": "Сертификат(-ы) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 1960,
        "parent": 1955,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1961,
        "parent": 1955,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1962,
        "parent": 1955,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1963,
        "parent": [1944, 1945, 1946, 1947, 1948, 1949, 1950, 1951, 1952, 1953, 1954],
        "lvl": 4,
        "name": "Я - импортер"
    }, { "id": 1964, "parent": 1963, "lvl": 5, "name": "Регистрационное удостоверение Росздравнадзора" }, {
        "id": 1965,
        "parent": 1963,
        "lvl": 5,
        "name": "Декларация (-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, { "id": 1966, "parent": 1963, "lvl": 5, "name": "Сертификат(-ы) ГОСТ Р (982 ПП РФ от 01.12.2009)" }, {
        "id": 1967,
        "parent": 1963,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1968,
        "parent": 1963,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 1969,
        "parent": [1944, 1945, 1946, 1947, 1948, 1949, 1950, 1951, 1952, 1953, 1954],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 1970, "parent": 1969, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 1971,
        "parent": 1969,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 1972,
        "parent": [1944, 1945, 1946, 1947, 1948, 1949, 1950, 1951, 1952, 1953, 1954],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 1973,
        "parent": 1972,
        "lvl": 5,
        "name": "Копии Регистрационных удостоверений Росздравнадзора"
    }, {
        "id": 1974,
        "parent": 1972,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 1975,
        "parent": 1972,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 1976,
        "parent": 1972,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 1977,
        "parent": 1972,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 1978, "parent": 0, "lvl": 1, "name": "Строительные материалы" }, {
        "id": 1979,
        "parent": 1978,
        "lvl": 2,
        "name": "Строительные материалы"
    }, { "id": 1980, "parent": 1979, "lvl": 3, "name": "Гипсокартон и листовые материалы" }, {
        "id": 1981,
        "parent": 1979,
        "lvl": 3,
        "name": "Профиль для ГКЛ и штукатурки"
    }, { "id": 1982, "parent": 1979, "lvl": 3, "name": "Сухие строительные смеси, цемент" }, {
        "id": 1983,
        "parent": 1979,
        "lvl": 3,
        "name": "Теплозвукоизоляция"
    }, { "id": 1984, "parent": 1979, "lvl": 3, "name": "Напольные покрытия" }, {
        "id": 1985,
        "parent": 1979,
        "lvl": 3,
        "name": "Лакокрасочные материалы"
    }, { "id": 1986, "parent": 1979, "lvl": 3, "name": "Кирпич, газобетон, стеновые материалы" }, {
        "id": 1987,
        "parent": 1979,
        "lvl": 3,
        "name": "Пиломатериалы и изделия из дерева"
    }, { "id": 1988, "parent": 1979, "lvl": 3, "name": "Кровля, водосточные системы, водоотливы" }, {
        "id": 1989,
        "parent": 1979,
        "lvl": 3,
        "name": "Поликарбонат и комплектующие для поликарбоната"
    }, { "id": 1990, "parent": 1979, "lvl": 3, "name": "Двери и фурнитура" }, {
        "id": 1991,
        "parent": 1979,
        "lvl": 3,
        "name": "Плитка керамическая и керамогранит"
    }, { "id": 1992, "parent": 1979, "lvl": 3, "name": "Другие строительные материалы" }, {
        "id": 1993,
        "parent": [1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991, 1992],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 1994, "parent": 1993, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 1995,
        "parent": 1993,
        "lvl": 5,
        "name": "Свидетельство о государственной регистрации"
    }, { "id": 1996, "parent": 1993, "lvl": 5, "name": "Сертификат\/декларация пожарной безопасности" }, {
        "id": 1997,
        "parent": 1993,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 1998,
        "parent": 1993,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 1999,
        "parent": 1993,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2000,
        "parent": [1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991, 1992],
        "lvl": 4,
        "name": "Я - импортер"
    }, { "id": 2001, "parent": 2000, "lvl": 5, "name": "Свидетельство о государственной регистрации" }, {
        "id": 2002,
        "parent": 2000,
        "lvl": 5,
        "name": "Сертификат\/декларация пожарной безопасности"
    }, {
        "id": 2003,
        "parent": 2000,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2004,
        "parent": 2000,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2005,
        "parent": [1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991, 1992],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 2006, "parent": 2005, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 2007,
        "parent": 2005,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 2008,
        "parent": [1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991, 1992],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 2009,
        "parent": 2008,
        "lvl": 5,
        "name": "Копии свидетельств о государственной регистрации продукции"
    }, {
        "id": 2010,
        "parent": 2008,
        "lvl": 5,
        "name": "Копии сертификатов\/деклараций пожарной безопасности"
    }, {
        "id": 2011,
        "parent": 2008,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 2012,
        "parent": 2008,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2013, "parent": 0, "lvl": 1, "name": "Мебель" }, {
        "id": 2014,
        "parent": 2013,
        "lvl": 2,
        "name": "Продукция мебельной промышленности"
    }, { "id": 2015, "parent": 2014, "lvl": 3, "name": "Мебель для учебных заведений" }, {
        "id": 2016,
        "parent": 2014,
        "lvl": 3,
        "name": "Мебель для дошкольных учреждений"
    }, { "id": 2017, "parent": 2014, "lvl": 3, "name": "Мебель для предприятий торговли" }, {
        "id": 2018,
        "parent": 2014,
        "lvl": 3,
        "name": "Мебель для гостиниц"
    }, { "id": 2019, "parent": 2014, "lvl": 3, "name": "Мебель бытовая" }, {
        "id": 2020,
        "parent": 2014,
        "lvl": 3,
        "name": "Другая мебель"
    }, { "id": 2021, "parent": [2015, 2016, 2017, 2018, 2019, 2020], "lvl": 4, "name": "Я - изготовитель" }, {
        "id": 2022,
        "parent": 2021,
        "lvl": 5,
        "name": "Технические условия (или ГОСТ при наличии)"
    }, {
        "id": 2023,
        "parent": 2021,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 025 о безопасности мебельной продукции"
    }, {
        "id": 2024,
        "parent": 2021,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 025 о безопасности мебельной продукции"
    }, {
        "id": 2025,
        "parent": 2021,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2026,
        "parent": 2021,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 2027,
        "parent": 2021,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2028, "parent": [2015, 2016, 2017, 2018, 2019, 2020], "lvl": 4, "name": "Я - импортер" }, {
        "id": 2029,
        "parent": 2028,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 025 о безопасности мебельной продукции"
    }, {
        "id": 2030,
        "parent": 2028,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 025 о безопасности мебельной продукции"
    }, {
        "id": 2031,
        "parent": 2028,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2032,
        "parent": 2028,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2033, "parent": [2015, 2016, 2017, 2018, 2019, 2020], "lvl": 4, "name": "Я - экспортер" }, {
        "id": 2034,
        "parent": 2033,
        "lvl": 5,
        "name": "Сертификат(-ы) происхождения продукции"
    }, {
        "id": 2035,
        "parent": 2033,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, { "id": 2036, "parent": [2015, 2016, 2017, 2018, 2019, 2020], "lvl": 4, "name": "Я - продавец" }, {
        "id": 2037,
        "parent": 2036,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 025 о безопасности мебельной продукции"
    }, {
        "id": 2038,
        "parent": 2036,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 025 о безопасности мебельной продукции"
    }, {
        "id": 2039,
        "parent": 2036,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 2040,
        "parent": 2036,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2041, "parent": 0, "lvl": 1, "name": "Косметика" }, {
        "id": 2042,
        "parent": 2041,
        "lvl": 2,
        "name": "Продукция косметической промышленности"
    }, { "id": 2043, "parent": 2042, "lvl": 3, "name": "Масла" }, {
        "id": 2044,
        "parent": 2042,
        "lvl": 3,
        "name": "Духи"
    }, { "id": 2045, "parent": 2042, "lvl": 3, "name": "Туалетная вода" }, {
        "id": 2046,
        "parent": 2042,
        "lvl": 3,
        "name": "Средства косметические для макияжа губ"
    }, { "id": 2047, "parent": 2042, "lvl": 3, "name": "Средства косметические для макияжа глаз" }, {
        "id": 2048,
        "parent": 2042,
        "lvl": 3,
        "name": "Средства косметические для маникюра или педикюра"
    }, { "id": 2049, "parent": 2042, "lvl": 3, "name": "Шампуни, лаки для волос" }, {
        "id": 2050,
        "parent": 2042,
        "lvl": 3,
        "name": "Средства гигиены полости рта"
    }, { "id": 2051, "parent": 2042, "lvl": 3, "name": "Средства косметические для бритья" }, {
        "id": 2052,
        "parent": 2042,
        "lvl": 3,
        "name": "Дезодоранты"
    }, { "id": 2053, "parent": 2042, "lvl": 3, "name": "Ароматизированные соли" }, {
        "id": 2054,
        "parent": 2042,
        "lvl": 3,
        "name": "Мыло туалетное"
    }, { "id": 2055, "parent": 2042, "lvl": 3, "name": "Детская косметика" }, {
        "id": 2056,
        "parent": 2042,
        "lvl": 3,
        "name": "Другая продукция"
    }, {
        "id": 2057,
        "parent": [2043, 2044, 2045, 2046, 2047, 2048, 2049, 2050, 2051, 2052, 2053, 2054, 2055, 2056],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 2058, "parent": 2057, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 2059,
        "parent": 2057,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 009 о безопасности парфюмерно-косметической продукции"
    }, {
        "id": 2060,
        "parent": 2057,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 009 о безопасности парфюмерно-косметической продукции"
    }, { "id": 2061, "parent": 2057, "lvl": 5, "name": "Свидетельство о государственной регистрации" }, {
        "id": 2062,
        "parent": 2057,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2063,
        "parent": 2057,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 2064,
        "parent": 2057,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2065,
        "parent": [2043, 2044, 2045, 2046, 2047, 2048, 2049, 2050, 2051, 2052, 2053, 2054, 2055, 2056],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 2066,
        "parent": 2065,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 009 о безопасности парфюмерно-косметической продукции"
    }, {
        "id": 2067,
        "parent": 2065,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 009 о безопасности парфюмерно-косметической продукции"
    }, { "id": 2068, "parent": 2065, "lvl": 5, "name": "Свидетельство о государственной регистрации" }, {
        "id": 2069,
        "parent": 2065,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2070,
        "parent": 2065,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2071,
        "parent": [2043, 2044, 2045, 2046, 2047, 2048, 2049, 2050, 2051, 2052, 2053, 2054, 2055, 2056],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 2072, "parent": 2071, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 2073,
        "parent": 2071,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 2074,
        "parent": [2043, 2044, 2045, 2046, 2047, 2048, 2049, 2050, 2051, 2052, 2053, 2054, 2055, 2056],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 2075,
        "parent": 2074,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 009 о безопасности парфюмерно-косметической продукции"
    }, {
        "id": 2076,
        "parent": 2074,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 009 о безопасности парфюмерно-косметической продукции"
    }, { "id": 2077, "parent": 2074, "lvl": 5, "name": "Копии свидетельств о государственной регистрации" }, {
        "id": 2078,
        "parent": 2074,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 2079,
        "parent": 2074,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2080, "parent": 1, "lvl": 2, "name": "Упаковочная продукция" }, {
        "id": 2081,
        "parent": 2080,
        "lvl": 3,
        "name": "Упаковка металлическая"
    }, { "id": 2082, "parent": 2080, "lvl": 3, "name": "Упаковка полимерная" }, {
        "id": 2083,
        "parent": 2080,
        "lvl": 3,
        "name": "Упаковка бумажная и картонная"
    }, { "id": 2084, "parent": 2080, "lvl": 3, "name": "Упаковка стеклянная" }, {
        "id": 2085,
        "parent": 2080,
        "lvl": 3,
        "name": "Упаковка деревянная"
    }, { "id": 2086, "parent": 2080, "lvl": 3, "name": "Упаковка керамическая" }, {
        "id": 2087,
        "parent": 2080,
        "lvl": 3,
        "name": "Укупорочные средства"
    }, { "id": 2088, "parent": 2080, "lvl": 3, "name": "Другая продукция" }, {
        "id": 2089,
        "parent": [2081, 2082, 2083, 2084, 2085, 2086, 2087, 2088],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 2090, "parent": 2089, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 2091,
        "parent": 2089,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 005 о безопасности упаковки"
    }, {
        "id": 2092,
        "parent": 2089,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2093,
        "parent": 2089,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 2094,
        "parent": 2089,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2095,
        "parent": [2081, 2082, 2083, 2084, 2085, 2086, 2087, 2088],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 2096,
        "parent": 2095,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 005 о безопасности упаковки"
    }, {
        "id": 2097,
        "parent": 2095,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2098,
        "parent": 2095,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2099,
        "parent": [2081, 2082, 2083, 2084, 2085, 2086, 2087, 2088],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 2100, "parent": 2099, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 2101,
        "parent": 2099,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 2102,
        "parent": [2081, 2082, 2083, 2084, 2085, 2086, 2087, 2088],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 2103,
        "parent": 2102,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 005 о безопасности упаковки"
    }, {
        "id": 2104,
        "parent": 2102,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 2105,
        "parent": 2102,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2106, "parent": 433, "lvl": 2, "name": "Оборудование во взрывозащищенном исполнении" }, {
        "id": 2107,
        "parent": 2106,
        "lvl": 3,
        "name": "Взрывозащищенные шкафы"
    }, { "id": 2108, "parent": 2106, "lvl": 3, "name": "Взрывозащищенные коробки" }, {
        "id": 2109,
        "parent": 2106,
        "lvl": 3,
        "name": "Взрывозащищенные светильники"
    }, { "id": 2110, "parent": 2106, "lvl": 3, "name": "Взрывозащищенные посты управления" }, {
        "id": 2111,
        "parent": 2106,
        "lvl": 3,
        "name": "Оповещатели"
    }, { "id": 2112, "parent": 2106, "lvl": 3, "name": "Источники питания" }, {
        "id": 2113,
        "parent": 2106,
        "lvl": 3,
        "name": "Видеокамеры"
    }, { "id": 2114, "parent": 2106, "lvl": 3, "name": "Другое оборудование" }, {
        "id": 2115,
        "parent": [2107, 2108, 2109, 2110, 2111, 2112, 2113, 2114],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 2116, "parent": 2115, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 2117,
        "parent": 2115,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 012 о безопасности оборудования для работы во взрывоопасных средах"
    }, {
        "id": 2118,
        "parent": 2115,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2119,
        "parent": 2115,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 2120,
        "parent": 2115,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2121,
        "parent": [2107, 2108, 2109, 2110, 2111, 2112, 2113, 2114],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 2122,
        "parent": 2121,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 012 о безопасности оборудования для работы во взрывоопасных средах"
    }, {
        "id": 2123,
        "parent": 2121,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2124,
        "parent": 2121,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2125,
        "parent": [2107, 2108, 2109, 2110, 2111, 2112, 2113, 2114],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 2126, "parent": 2125, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 2127,
        "parent": 2125,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 2128,
        "parent": [2107, 2108, 2109, 2110, 2111, 2112, 2113, 2114],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 2129,
        "parent": 2128,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 012 о безопасности оборудования для работы во взрывоопасных средах"
    }, {
        "id": 2130,
        "parent": 2128,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 2131,
        "parent": 2128,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2132, "parent": 1, "lvl": 2, "name": "Продукция хозяйственно-бытового назначения" }, {
        "id": 2133,
        "parent": 2132,
        "lvl": 3,
        "name": "Ведра"
    }, { "id": 2134, "parent": 2132, "lvl": 3, "name": "Тазы" }, {
        "id": 2135,
        "parent": 2132,
        "lvl": 3,
        "name": "Посуда"
    }, { "id": 2136, "parent": 2132, "lvl": 3, "name": "Мочалки" }, {
        "id": 2137,
        "parent": 2132,
        "lvl": 3,
        "name": "Мыльницы"
    }, { "id": 2138, "parent": 2132, "lvl": 3, "name": "Вешалки" }, {
        "id": 2139,
        "parent": 2132,
        "lvl": 3,
        "name": "Гладильные доски"
    }, { "id": 2140, "parent": 2132, "lvl": 3, "name": "Губки" }, {
        "id": 2141,
        "parent": 2132,
        "lvl": 3,
        "name": "Салфетки для уборки"
    }, { "id": 2142, "parent": 2132, "lvl": 3, "name": "Веник, совок" }, {
        "id": 2143,
        "parent": 2132,
        "lvl": 3,
        "name": "Швабры"
    }, { "id": 2144, "parent": 2132, "lvl": 3, "name": "Другая продукция" }, {
        "id": 2145,
        "parent": [2133, 2134, 2135, 2136, 2137, 2138, 2139, 2140, 2141, 2142, 2143, 2144],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 2146, "parent": 2145, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 2147,
        "parent": 2145,
        "lvl": 5,
        "name": "Декларация (-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2148,
        "parent": 2145,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2149,
        "parent": 2145,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 2150,
        "parent": 2145,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2151,
        "parent": [2133, 2134, 2135, 2136, 2137, 2138, 2139, 2140, 2141, 2142, 2143, 2144],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 2152,
        "parent": 2151,
        "lvl": 5,
        "name": "Декларация (-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2153,
        "parent": 2151,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2154,
        "parent": 2151,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2155,
        "parent": [2133, 2134, 2135, 2136, 2137, 2138, 2139, 2140, 2141, 2142, 2143, 2144],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 2156, "parent": 2155, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 2157,
        "parent": 2155,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 2158,
        "parent": [2133, 2134, 2135, 2136, 2137, 2138, 2139, 2140, 2141, 2142, 2143, 2144],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 2159,
        "parent": 2158,
        "lvl": 5,
        "name": "Копии деклараций ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2160,
        "parent": 2158,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 2161,
        "parent": 2158,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2162, "parent": 1, "lvl": 2, "name": "Средства санитарно-гигиенические" }, {
        "id": 2163,
        "parent": 2162,
        "lvl": 3,
        "name": "Шампуни"
    }, { "id": 2164, "parent": 2162, "lvl": 3, "name": "Средства гигиены полости рта" }, {
        "id": 2165,
        "parent": 2162,
        "lvl": 3,
        "name": "Средства для бритья"
    }, { "id": 2166, "parent": 2162, "lvl": 3, "name": "Мыло туалентное" }, {
        "id": 2167,
        "parent": 2162,
        "lvl": 3,
        "name": "Поверхностно-активные вещества для мытья кожи"
    }, { "id": 2168, "parent": 2162, "lvl": 3, "name": "Туалетная бумага" }, {
        "id": 2169,
        "parent": 2162,
        "lvl": 3,
        "name": "Прокладки женские"
    }, { "id": 2170, "parent": 2162, "lvl": 3, "name": "Платки носовые" }, {
        "id": 2171,
        "parent": 2162,
        "lvl": 3,
        "name": "Детские санитарно-гигиенические средства"
    }, {
        "id": 2172,
        "parent": [2163, 2164, 2165, 2166, 2167, 2168, 2169, 2170, 2171],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 2173, "parent": 2172, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 2174,
        "parent": 2172,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 009 о безопасности парфюмерно-косметической продукции"
    }, {
        "id": 2175,
        "parent": 2172,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 009 о безопасности парфюмерно-косметической продукции"
    }, { "id": 2176, "parent": 2172, "lvl": 5, "name": "Свидетельство о государственной регистрации" }, {
        "id": 2177,
        "parent": 2172,
        "lvl": 5,
        "name": "Декларация (-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2178,
        "parent": 2172,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2179,
        "parent": 2172,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 2180,
        "parent": 2172,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2181,
        "parent": [2163, 2164, 2165, 2166, 2167, 2168, 2169, 2170, 2171],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 2182,
        "parent": 2181,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 009 о безопасности парфюмерно-косметической продукции"
    }, {
        "id": 2183,
        "parent": 2181,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 009 о безопасности парфюмерно-косметической продукции"
    }, { "id": 2184, "parent": 2181, "lvl": 5, "name": "Свидетельство о государственной регистрации" }, {
        "id": 2185,
        "parent": 2181,
        "lvl": 5,
        "name": "Декларация (-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2186,
        "parent": 2181,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2187,
        "parent": 2181,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2188,
        "parent": [2163, 2164, 2165, 2166, 2167, 2168, 2169, 2170, 2171],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 2189, "parent": 2188, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 2190,
        "parent": 2188,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 2191,
        "parent": [2163, 2164, 2165, 2166, 2167, 2168, 2169, 2170, 2171],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 2192,
        "parent": 2191,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 009 о безопасности парфюмерно-косметической продукции"
    }, {
        "id": 2193,
        "parent": 2191,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 009 о безопасности парфюмерно-косметической продукции"
    }, { "id": 2194, "parent": 2191, "lvl": 5, "name": "Копии свидетельств о государственной регистрации" }, {
        "id": 2195,
        "parent": 2191,
        "lvl": 5,
        "name": "Копии деклараций ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2196,
        "parent": 2191,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 2197,
        "parent": 2191,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2198, "parent": 1, "lvl": 2, "name": "Сувенирная продукция" }, {
        "id": 2199,
        "parent": 2198,
        "lvl": 3,
        "name": "Брелки"
    }, { "id": 2200, "parent": 2198, "lvl": 3, "name": "Магниты" }, {
        "id": 2201,
        "parent": 2198,
        "lvl": 3,
        "name": "Подставки"
    }, { "id": 2202, "parent": 2198, "lvl": 3, "name": "Значки" }, {
        "id": 2203,
        "parent": 2198,
        "lvl": 3,
        "name": "Канцелярские товары"
    }, { "id": 2204, "parent": 2198, "lvl": 3, "name": "Посуда" }, {
        "id": 2205,
        "parent": 2198,
        "lvl": 3,
        "name": "Фоторамки"
    }, { "id": 2206, "parent": 2198, "lvl": 3, "name": "Часы" }, {
        "id": 2207,
        "parent": 2198,
        "lvl": 3,
        "name": "Другая продукция"
    }, {
        "id": 2208,
        "parent": [2199, 2200, 2201, 2202, 2203, 2204, 2205, 2206, 2207],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 2209, "parent": 2208, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 2210,
        "parent": 2208,
        "lvl": 5,
        "name": "Декларация (-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2211,
        "parent": 2208,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2212,
        "parent": 2208,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 2213,
        "parent": 2208,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2214,
        "parent": [2199, 2200, 2201, 2202, 2203, 2204, 2205, 2206, 2207],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 2215,
        "parent": 2214,
        "lvl": 5,
        "name": "Декларация (-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2216,
        "parent": 2214,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2217,
        "parent": 2214,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2218,
        "parent": [2199, 2200, 2201, 2202, 2203, 2204, 2205, 2206, 2207],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 2219, "parent": 2218, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 2220,
        "parent": 2218,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 2221,
        "parent": [2199, 2200, 2201, 2202, 2203, 2204, 2205, 2206, 2207],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 2222,
        "parent": 2221,
        "lvl": 5,
        "name": "Копии деклараций ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2223,
        "parent": 2221,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 2224,
        "parent": 2221,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2225, "parent": 1, "lvl": 2, "name": "Аксессуары для мобильных телефонов" }, {
        "id": 2226,
        "parent": 2225,
        "lvl": 3,
        "name": "Аккумуляторные батареи"
    }, { "id": 2227, "parent": 2225, "lvl": 3, "name": "Гарнитуры, наушники" }, {
        "id": 2228,
        "parent": 2225,
        "lvl": 3,
        "name": "Зарядные устройства"
    }, { "id": 2229, "parent": 2225, "lvl": 3, "name": "Блоки питания" }, {
        "id": 2230,
        "parent": 2225,
        "lvl": 3,
        "name": "Защитные пленки"
    }, { "id": 2231, "parent": 2225, "lvl": 3, "name": "Карты памяти, накопители" }, {
        "id": 2232,
        "parent": 2225,
        "lvl": 3,
        "name": "Картридеры"
    }, { "id": 2233, "parent": 2225, "lvl": 3, "name": "Кабели" }, {
        "id": 2234,
        "parent": 2225,
        "lvl": 3,
        "name": "Чехлы"
    }, { "id": 2235, "parent": 2225, "lvl": 3, "name": "Автомобильные держатели" }, {
        "id": 2236,
        "parent": 2225,
        "lvl": 3,
        "name": "Другие аксессуары"
    }, {
        "id": 2237,
        "parent": [2226, 2227, 2228, 2229, 2230, 2231, 2232, 2233, 2234, 2235, 2236],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 2238, "parent": 2237, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 2239,
        "parent": 2237,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/020 о безопасности низковольтного оборудования\/электромагнитная совместимость"
    }, {
        "id": 2240,
        "parent": 2237,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/020 о безопасности низковольтного оборудования\/электромагнитная совместимость"
    }, {
        "id": 2241,
        "parent": 2237,
        "lvl": 5,
        "name": "Декларация (-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2242,
        "parent": 2237,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2243,
        "parent": 2237,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 2244,
        "parent": 2237,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2245,
        "parent": [2226, 2227, 2228, 2229, 2230, 2231, 2232, 2233, 2234, 2235, 2236],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 2246,
        "parent": 2245,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 004\/020 о безопасности низковольтного оборудования\/электромагнитная совместимость"
    }, {
        "id": 2247,
        "parent": 2245,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 004\/020 о безопасности низковольтного оборудования\/электромагнитная совместимость"
    }, {
        "id": 2248,
        "parent": 2245,
        "lvl": 5,
        "name": "Декларация (-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2249,
        "parent": 2245,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2250,
        "parent": 2245,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2251,
        "parent": [2226, 2227, 2228, 2229, 2230, 2231, 2232, 2233, 2234, 2235, 2236],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 2252, "parent": 2251, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 2253,
        "parent": 2251,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 2254,
        "parent": [2226, 2227, 2228, 2229, 2230, 2231, 2232, 2233, 2234, 2235, 2236],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 2255,
        "parent": 2254,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 004\/020 о безопасности низковольтного оборудования\/электромагнитная совместимост"
    }, {
        "id": 2256,
        "parent": 2254,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 004\/020 о безопасности низковольтного оборудования\/электромагнитная совместимост"
    }, {
        "id": 2257,
        "parent": 2254,
        "lvl": 5,
        "name": "Копии деклараций ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2258,
        "parent": 2254,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 2259,
        "parent": 2254,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2260, "parent": 0, "lvl": 1, "name": "Спортивное оборудование" }, {
        "id": 2261,
        "parent": 2260,
        "lvl": 2,
        "name": "Спортивное оборудование"
    }, { "id": 2262, "parent": 2261, "lvl": 3, "name": "Тренажеры" }, {
        "id": 2263,
        "parent": 2261,
        "lvl": 3,
        "name": "Ворота для хоккея"
    }, { "id": 2264, "parent": 2261, "lvl": 3, "name": "Ворота для футбола" }, {
        "id": 2265,
        "parent": 2261,
        "lvl": 3,
        "name": "Ворота для мини-футбола"
    }, { "id": 2266, "parent": 2261, "lvl": 3, "name": "Ворота для гандбола" }, {
        "id": 2267,
        "parent": 2261,
        "lvl": 3,
        "name": "Гимнастическое оборудование"
    }, { "id": 2268, "parent": 2261, "lvl": 3, "name": "Оборудование для бассейнов" }, {
        "id": 2269,
        "parent": 2261,
        "lvl": 3,
        "name": "Оборудование для ледовых арен"
    }, { "id": 2270, "parent": 2261, "lvl": 3, "name": "Оборудование для единоборств" }, {
        "id": 2271,
        "parent": 2261,
        "lvl": 3,
        "name": "Оборудование для легкой ателитики"
    }, { "id": 2272, "parent": 2261, "lvl": 3, "name": "Другое оборудование" }, {
        "id": 2273,
        "parent": [2262, 2263, 2264, 2265, 2266, 2267, 2268, 2269, 2270, 2271, 2272],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 2274, "parent": 2273, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 2275,
        "parent": 2273,
        "lvl": 5,
        "name": "Сертификат(-ы) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2276,
        "parent": 2273,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2277,
        "parent": 2273,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 2278,
        "parent": 2273,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2279,
        "parent": [2262, 2263, 2264, 2265, 2266, 2267, 2268, 2269, 2270, 2271, 2272],
        "lvl": 4,
        "name": "Я - импортер"
    }, { "id": 2280, "parent": 2279, "lvl": 5, "name": "Сертификат(-ы) ГОСТ Р (982 ПП РФ от 01.12.2009)" }, {
        "id": 2281,
        "parent": 2279,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2282,
        "parent": 2279,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2283,
        "parent": [2262, 2263, 2264, 2265, 2266, 2267, 2268, 2269, 2270, 2271, 2272],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 2284, "parent": 2283, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 2285,
        "parent": 2283,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 2286,
        "parent": [2262, 2263, 2264, 2265, 2266, 2267, 2268, 2269, 2270, 2271, 2272],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 2287,
        "parent": 2286,
        "lvl": 5,
        "name": "Копии сертификатов ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2288,
        "parent": 2286,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 2289,
        "parent": 2286,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2290, "parent": 0, "lvl": 1, "name": "Бытовая химия" }, {
        "id": 2291,
        "parent": 2290,
        "lvl": 2,
        "name": "Бытовая химия"
    }, { "id": 2292, "parent": 2291, "lvl": 3, "name": "Освежители воздуха" }, {
        "id": 2293,
        "parent": 2291,
        "lvl": 3,
        "name": "Дезодоранты"
    }, { "id": 2294, "parent": 2291, "lvl": 3, "name": "Чистящие моющие средства" }, {
        "id": 2295,
        "parent": 2291,
        "lvl": 3,
        "name": "Отбеливающие средства"
    }, { "id": 2296, "parent": 2291, "lvl": 3, "name": "Дезинфицирующие средства" }, {
        "id": 2297,
        "parent": 2291,
        "lvl": 3,
        "name": "Репелленты"
    }, { "id": 2298, "parent": 2291, "lvl": 3, "name": "Клей" }, {
        "id": 2299,
        "parent": 2291,
        "lvl": 3,
        "name": "Стиральные порошки"
    }, { "id": 2300, "parent": 2291, "lvl": 3, "name": "Кондиционеры для белья" }, {
        "id": 2301,
        "parent": 2291,
        "lvl": 3,
        "name": "Гель для стирки"
    }, { "id": 2302, "parent": 2291, "lvl": 3, "name": "Хозяйственное мыло" }, {
        "id": 2303,
        "parent": 2291,
        "lvl": 3,
        "name": "Другая продукция"
    }, {
        "id": 2304,
        "parent": [2292, 2293, 2294, 2295, 2296, 2297, 2298, 2299, 2300, 2301, 2302, 2303],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 2305, "parent": 2304, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 2306,
        "parent": 2304,
        "lvl": 5,
        "name": "Декларация (-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, { "id": 2307, "parent": 2304, "lvl": 5, "name": "Свидетельство о государственной регистрации" }, {
        "id": 2308,
        "parent": 2304,
        "lvl": 5,
        "name": "Декларация (-ии) ТР ТС 024\/2011 о безопасности масложировой продукции"
    }, {
        "id": 2309,
        "parent": 2304,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2310,
        "parent": 2304,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 2311,
        "parent": 2304,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2312,
        "parent": [2292, 2293, 2294, 2295, 2296, 2297, 2298, 2299, 2300, 2301, 2302, 2303],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 2313,
        "parent": 2312,
        "lvl": 5,
        "name": "Декларация (-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2314,
        "parent": 2312,
        "lvl": 5,
        "name": "Свидетельство о государственной регистрации"
    }, {
        "id": 2315,
        "parent": 2312,
        "lvl": 5,
        "name": "Декларация (-ии) ТР ТС 024\/2011 о безопасности масложировой продукции"
    }, {
        "id": 2316,
        "parent": 2312,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2317,
        "parent": 2312,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2318,
        "parent": [2292, 2293, 2294, 2295, 2296, 2297, 2298, 2299, 2300, 2301, 2302, 2303],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 2319, "parent": 2318, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 2320,
        "parent": 2318,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 2321,
        "parent": [2292, 2293, 2294, 2295, 2296, 2297, 2298, 2299, 2300, 2301, 2302, 2303],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 2322,
        "parent": 2321,
        "lvl": 5,
        "name": "Копии деклараций ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2323,
        "parent": 2321,
        "lvl": 5,
        "name": "Копии свидетельств о государственной регистрации"
    }, {
        "id": 2324,
        "parent": 2321,
        "lvl": 5,
        "name": "Копии деклараций ТР ТС 024\/2011 о безопасности масложировой продукции"
    }, {
        "id": 2325,
        "parent": 2321,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 2326,
        "parent": 2321,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2327, "parent": 433, "lvl": 2, "name": "Крепежные изделия" }, {
        "id": 2328,
        "parent": 2327,
        "lvl": 3,
        "name": "Болты"
    }, { "id": 2329, "parent": 2327, "lvl": 3, "name": "Гайки" }, {
        "id": 2330,
        "parent": 2327,
        "lvl": 3,
        "name": "Винты"
    }, { "id": 2331, "parent": 2327, "lvl": 3, "name": "Шурупы" }, {
        "id": 2332,
        "parent": 2327,
        "lvl": 3,
        "name": "Саморезы"
    }, { "id": 2333, "parent": 2327, "lvl": 3, "name": "Дюбели" }, {
        "id": 2334,
        "parent": 2327,
        "lvl": 3,
        "name": "Заклёпки"
    }, { "id": 2335, "parent": 2327, "lvl": 3, "name": "Шайбы" }, {
        "id": 2336,
        "parent": 2327,
        "lvl": 3,
        "name": "Штифты"
    }, { "id": 2337, "parent": 2327, "lvl": 3, "name": "Шпильки" }, {
        "id": 2338,
        "parent": 2327,
        "lvl": 3,
        "name": "Другие изделия"
    }, {
        "id": 2339,
        "parent": [2328, 2329, 2330, 2331, 2332, 2333, 2334, 2335, 2336, 2337, 2338],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 2340, "parent": 2339, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 2341,
        "parent": 2339,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2342,
        "parent": 2339,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 2343,
        "parent": 2339,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2344,
        "parent": [2328, 2329, 2330, 2331, 2332, 2333, 2334, 2335, 2336, 2337, 2338],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 2345,
        "parent": 2344,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2346,
        "parent": 2344,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2347,
        "parent": [2328, 2329, 2330, 2331, 2332, 2333, 2334, 2335, 2336, 2337, 2338],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 2348, "parent": 2347, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 2349,
        "parent": 2347,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 2350,
        "parent": [2328, 2329, 2330, 2331, 2332, 2333, 2334, 2335, 2336, 2337, 2338],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 2351,
        "parent": 2350,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 2352,
        "parent": 2350,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2353, "parent": 0, "lvl": 1, "name": "Продукция полиграфической промышленности" }, {
        "id": 2354,
        "parent": 2353,
        "lvl": 2,
        "name": "Продукция полиграфической промышленности"
    }, { "id": 2355, "parent": 2354, "lvl": 3, "name": "Визитки" }, {
        "id": 2356,
        "parent": 2354,
        "lvl": 3,
        "name": "Календари"
    }, { "id": 2357, "parent": 2354, "lvl": 3, "name": "Открытки" }, {
        "id": 2358,
        "parent": 2354,
        "lvl": 3,
        "name": "Пластиковые карты"
    }, { "id": 2359, "parent": 2354, "lvl": 3, "name": "Учебные пособия" }, {
        "id": 2360,
        "parent": 2354,
        "lvl": 3,
        "name": "Книги для детей"
    }, { "id": 2361, "parent": 2354, "lvl": 3, "name": "Брошюры" }, {
        "id": 2362,
        "parent": 2354,
        "lvl": 3,
        "name": "Каталоги"
    }, { "id": 2363, "parent": 2354, "lvl": 3, "name": "Журналы" }, {
        "id": 2364,
        "parent": 2354,
        "lvl": 3,
        "name": "Фирменные конверты"
    }, { "id": 2365, "parent": 2354, "lvl": 3, "name": "Папки для документов" }, {
        "id": 2366,
        "parent": 2354,
        "lvl": 3,
        "name": "Другая продукция"
    }, {
        "id": 2367,
        "parent": [2355, 2356, 2357, 2358, 2359, 2360, 2361, 2362, 2363, 2364, 2365, 2366],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 2368, "parent": 2367, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 2369,
        "parent": 2367,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 007 о безопасности продукции, предназначенной для детей и подростков"
    }, {
        "id": 2370,
        "parent": 2367,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2371,
        "parent": 2367,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 2372,
        "parent": 2367,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2373,
        "parent": [2355, 2356, 2357, 2358, 2359, 2360, 2361, 2362, 2363, 2364, 2365, 2366],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 2374,
        "parent": 2373,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 007 о безопасности продукции, предназначенной для детей и подростков"
    }, {
        "id": 2375,
        "parent": 2373,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2376,
        "parent": 2373,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2377,
        "parent": [2355, 2356, 2357, 2358, 2359, 2360, 2361, 2362, 2363, 2364, 2365, 2366],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 2378, "parent": 2377, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 2379,
        "parent": 2377,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 2380,
        "parent": [2355, 2356, 2357, 2358, 2359, 2360, 2361, 2362, 2363, 2364, 2365, 2366],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 2381,
        "parent": 2380,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 007 о безопасности продукции, предназначенной для детей и подростков"
    }, {
        "id": 2382,
        "parent": 2380,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 2383,
        "parent": 2380,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2384, "parent": 0, "lvl": 1, "name": "Растения, животные (в т.ч. корма)" }, {
        "id": 2385,
        "parent": 2384,
        "lvl": 2,
        "name": "Корма для животных"
    }, { "id": 2386, "parent": 2385, "lvl": 3, "name": "Корма для непродуктивных животных" }, {
        "id": 2387,
        "parent": 2385,
        "lvl": 3,
        "name": "Корма для продуктивных животных"
    }, { "id": 2388, "parent": 2385, "lvl": 3, "name": "Кормовые добавки" }, {
        "id": 2389,
        "parent": 2385,
        "lvl": 3,
        "name": "Комбикорм"
    }, { "id": 2390, "parent": 2385, "lvl": 3, "name": "Другая продукция" }, {
        "id": 2391,
        "parent": [2386, 2387, 2388, 2389, 2390],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 2392, "parent": 2391, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 2393,
        "parent": 2391,
        "lvl": 5,
        "name": "Декларация (-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2394,
        "parent": 2391,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2395,
        "parent": 2391,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 2396,
        "parent": 2391,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2397, "parent": [2386, 2387, 2388, 2389, 2390], "lvl": 4, "name": "Я - импортер" }, {
        "id": 2398,
        "parent": 2397,
        "lvl": 5,
        "name": "Декларация (-ии) ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2399,
        "parent": 2397,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2400,
        "parent": 2397,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2401, "parent": [2386, 2387, 2388, 2389, 2390], "lvl": 4, "name": "Я - экспортер" }, {
        "id": 2402,
        "parent": 2401,
        "lvl": 5,
        "name": "Сертификат(-ы) происхождения продукции"
    }, {
        "id": 2403,
        "parent": 2401,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, { "id": 2404, "parent": [2386, 2387, 2388, 2389, 2390], "lvl": 4, "name": "Я - продавец" }, {
        "id": 2405,
        "parent": 2404,
        "lvl": 5,
        "name": "Копии деклараций ГОСТ Р (982 ПП РФ от 01.12.2009)"
    }, {
        "id": 2406,
        "parent": 2404,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 2407,
        "parent": 2404,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2408, "parent": 2384, "lvl": 2, "name": "Семена, живые цветы иживотные" }, {
        "id": 2409,
        "parent": 2408,
        "lvl": 3,
        "name": "Комантные растения"
    }, { "id": 2410, "parent": 2408, "lvl": 3, "name": "Садовые растения" }, {
        "id": 2411,
        "parent": 2408,
        "lvl": 3,
        "name": "Семена"
    }, { "id": 2412, "parent": 2408, "lvl": 3, "name": "Рассада" }, {
        "id": 2413,
        "parent": 2408,
        "lvl": 3,
        "name": "Домашний скот Домашняя птицаДругое"
    }, { "id": 2414, "parent": [2409, 2410, 2411, 2412, 2413], "lvl": 4, "name": "Я - изготовитель" }, {
        "id": 2415,
        "parent": 2414,
        "lvl": 5,
        "name": "Технические условия (или ГОСТ при наличии)"
    }, {
        "id": 2416,
        "parent": 2414,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2417,
        "parent": 2414,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 2418,
        "parent": 2414,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2419, "parent": [2409, 2410, 2411, 2412, 2413], "lvl": 4, "name": "Я - импортер" }, {
        "id": 2420,
        "parent": 2419,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2421,
        "parent": 2419,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2422, "parent": [2409, 2410, 2411, 2412, 2413], "lvl": 4, "name": "Я - экспортер" }, {
        "id": 2423,
        "parent": 2422,
        "lvl": 5,
        "name": "Сертификат(-ы) происхождения продукции"
    }, {
        "id": 2424,
        "parent": 2422,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, { "id": 2425, "parent": [2409, 2410, 2411, 2412, 2413], "lvl": 4, "name": "Я - продавец" }, {
        "id": 2426,
        "parent": 2425,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 2427,
        "parent": 2425,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2428,
        "parent": 1,
        "lvl": 2,
        "name": "Бижутерия для взрослых (расчески, украшения для волос и т.д.)"
    }, { "id": 2429, "parent": 2428, "lvl": 3, "name": "Браслеты" }, {
        "id": 2430,
        "parent": 2428,
        "lvl": 3,
        "name": "Цепочки"
    }, { "id": 2431, "parent": 2428, "lvl": 3, "name": "Серьги" }, {
        "id": 2432,
        "parent": 2428,
        "lvl": 3,
        "name": "Расчески"
    }, { "id": 2433, "parent": 2428, "lvl": 3, "name": "Бигуди" }, {
        "id": 2434,
        "parent": 2428,
        "lvl": 3,
        "name": "Подставки под бижутерию"
    }, { "id": 2435, "parent": 2428, "lvl": 3, "name": "Средства для макияжа" }, {
        "id": 2436,
        "parent": 2428,
        "lvl": 3,
        "name": "Средства для маникюра"
    }, { "id": 2437, "parent": 2428, "lvl": 3, "name": "Средства для педикюра" }, {
        "id": 2438,
        "parent": 2428,
        "lvl": 3,
        "name": "Зеркала"
    }, { "id": 2439, "parent": 2428, "lvl": 3, "name": "Другая продукция" }, {
        "id": 2440,
        "parent": [2429, 2430, 2431, 2432, 2433, 2434, 2435, 2436, 2437, 2438, 2439],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 2441, "parent": 2440, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 2442,
        "parent": 2440,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2443,
        "parent": 2440,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 2444,
        "parent": 2440,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2445,
        "parent": [2429, 2430, 2431, 2432, 2433, 2434, 2435, 2436, 2437, 2438, 2439],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 2446,
        "parent": 2445,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2447,
        "parent": 2445,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2448,
        "parent": [2429, 2430, 2431, 2432, 2433, 2434, 2435, 2436, 2437, 2438, 2439],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 2449, "parent": 2448, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 2450,
        "parent": 2448,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 2451,
        "parent": [2429, 2430, 2431, 2432, 2433, 2434, 2435, 2436, 2437, 2438, 2439],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 2452,
        "parent": 2451,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 2453,
        "parent": 2451,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2454, "parent": 0, "lvl": 1, "name": "Продукция для автомобильных дорог" }, {
        "id": 2455,
        "parent": 2454,
        "lvl": 2,
        "name": "Продукция для автомобильных дорог"
    }, { "id": 2456, "parent": 2455, "lvl": 3, "name": "Песок" }, {
        "id": 2457,
        "parent": 2455,
        "lvl": 3,
        "name": "Щебень"
    }, { "id": 2458, "parent": 2455, "lvl": 3, "name": "Цемент" }, {
        "id": 2459,
        "parent": 2455,
        "lvl": 3,
        "name": "Битум"
    }, { "id": 2460, "parent": 2455, "lvl": 3, "name": "Материалы для дорожной разметки" }, {
        "id": 2461,
        "parent": 2455,
        "lvl": 3,
        "name": "Светофоры"
    }, { "id": 2462, "parent": 2455, "lvl": 3, "name": "Дорожные знаки, табло" }, {
        "id": 2463,
        "parent": 2455,
        "lvl": 3,
        "name": "Искусственные неровности"
    }, { "id": 2464, "parent": 2455, "lvl": 3, "name": "Светильники" }, {
        "id": 2465,
        "parent": 2455,
        "lvl": 3,
        "name": "Плиты дорожные"
    }, { "id": 2466, "parent": 2455, "lvl": 3, "name": "Другая продукция" }, {
        "id": 2467,
        "parent": [2456, 2457, 2458, 2459, 2460, 2461, 2462, 2463, 2464, 2465, 2466],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 2468, "parent": 2467, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 2469,
        "parent": 2467,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 014 о безопасности автомобильных дорог"
    }, {
        "id": 2470,
        "parent": 2467,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 014 о безопасности автомобильных дорог"
    }, {
        "id": 2471,
        "parent": 2467,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2472,
        "parent": 2467,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 2473,
        "parent": 2467,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2474,
        "parent": [2456, 2457, 2458, 2459, 2460, 2461, 2462, 2463, 2464, 2465, 2466],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 2475,
        "parent": 2474,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 014 о безопасности автомобильных дорог"
    }, {
        "id": 2476,
        "parent": 2474,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 014 о безопасности автомобильных дорог"
    }, {
        "id": 2477,
        "parent": 2474,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2478,
        "parent": 2474,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2479,
        "parent": [2456, 2457, 2458, 2459, 2460, 2461, 2462, 2463, 2464, 2465, 2466],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 2480, "parent": 2479, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 2481,
        "parent": 2479,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 2482,
        "parent": [2456, 2457, 2458, 2459, 2460, 2461, 2462, 2463, 2464, 2465, 2466],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 2483,
        "parent": 2482,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 014 о безопасности автомобильных дорог"
    }, {
        "id": 2484,
        "parent": 2482,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 014 о безопасности автомобильных дорог"
    }, {
        "id": 2485,
        "parent": 2482,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 2486,
        "parent": 2482,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, { "id": 2487, "parent": 433, "lvl": 2, "name": "Оборудование, работающее на газообразном топливе" }, {
        "id": 2488,
        "parent": 2487,
        "lvl": 3,
        "name": "Аппараты отопительные"
    }, { "id": 2489, "parent": 2487, "lvl": 3, "name": "Аппараты водонагревательные" }, {
        "id": 2490,
        "parent": 2487,
        "lvl": 3,
        "name": "Плиты"
    }, { "id": 2491, "parent": 2487, "lvl": 3, "name": "Светильники" }, {
        "id": 2492,
        "parent": 2487,
        "lvl": 3,
        "name": "Котлы"
    }, { "id": 2493, "parent": 2487, "lvl": 3, "name": "Горелки" }, {
        "id": 2494,
        "parent": 2487,
        "lvl": 3,
        "name": "Воздухонагреватели"
    }, { "id": 2495, "parent": 2487, "lvl": 3, "name": "Теплогенераторы" }, {
        "id": 2496,
        "parent": 2487,
        "lvl": 3,
        "name": "Регуляторы давления"
    }, {
        "id": 2497,
        "parent": 2487,
        "lvl": 3,
        "name": "Соединения гибкие для газовых горелок и аппаратов"
    }, {
        "id": 2498,
        "parent": 2487,
        "lvl": 3,
        "name": "Другое оборудование"
    }, {
        "id": 2499,
        "parent": [2488, 2489, 2490, 2491, 2492, 2493, 2494, 2495, 2496, 2497, 2498],
        "lvl": 4,
        "name": "Я - изготовитель"
    }, { "id": 2500, "parent": 2499, "lvl": 5, "name": "Технические условия (или ГОСТ при наличии)" }, {
        "id": 2501,
        "parent": 2499,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 016 о безопасности аппаратов, работающих на газообразном топливе"
    }, {
        "id": 2502,
        "parent": 2499,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 016 о безопасности аппаратов, работающих на газообразном топливе"
    }, {
        "id": 2503,
        "parent": 2499,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2504,
        "parent": 2499,
        "lvl": 5,
        "name": "Сертификат ИСО предприятия (добровольный документ)"
    }, {
        "id": 2505,
        "parent": 2499,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2506,
        "parent": [2488, 2489, 2490, 2491, 2492, 2493, 2494, 2495, 2496, 2497, 2498],
        "lvl": 4,
        "name": "Я - импортер"
    }, {
        "id": 2507,
        "parent": 2506,
        "lvl": 5,
        "name": "Декларация(-ии) о соответствии ТР ТС 016 о безопасности аппаратов, работающих на газообразном топливе"
    }, {
        "id": 2508,
        "parent": 2506,
        "lvl": 5,
        "name": "Сертификат(-ы) о соответствии ТР ТС 016 о безопасности аппаратов, работающих на газообразном топливе"
    }, {
        "id": 2509,
        "parent": 2506,
        "lvl": 5,
        "name": "Сертификат(-ы) соответствия продукции (добровольные)"
    }, {
        "id": 2510,
        "parent": 2506,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }, {
        "id": 2511,
        "parent": [2488, 2489, 2490, 2491, 2492, 2493, 2494, 2495, 2496, 2497, 2498],
        "lvl": 4,
        "name": "Я - экспортер"
    }, { "id": 2512, "parent": 2511, "lvl": 5, "name": "Сертификат(-ы) происхождения продукции" }, {
        "id": 2513,
        "parent": 2511,
        "lvl": 5,
        "name": "Документы, подтверждающие качество продукции, в соответствии с законодательством принимающей страны"
    }, {
        "id": 2514,
        "parent": [2488, 2489, 2490, 2491, 2492, 2493, 2494, 2495, 2496, 2497, 2498],
        "lvl": 4,
        "name": "Я - продавец"
    }, {
        "id": 2515,
        "parent": 2514,
        "lvl": 5,
        "name": "Копии деклараций о соответствии ТР ТС 016 о безопасности аппаратов, работающих на газообразном топливе"
    }, {
        "id": 2516,
        "parent": 2514,
        "lvl": 5,
        "name": "Копии сертификатов соответствия ТР ТС 016 о безопасности аппаратов, работающих на газообразном топливе"
    }, {
        "id": 2517,
        "parent": 2514,
        "lvl": 5,
        "name": "Копии сертификатов соответствия продукции (добровольные)"
    }, {
        "id": 2518,
        "parent": 2514,
        "lvl": 5,
        "name": "Отказное письмо, если на продукцию не требуются обязательные сертификаты и декларации"
    }];


/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var zone_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! zone.js */ "./node_modules/zone.js/dist/zone.js");
/* harmony import */ var zone_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(zone_js__WEBPACK_IMPORTED_MODULE_5__);






if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /var/www/html/intercod/wp-content/themes/constructzine-child/assets/app-frontend/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map